export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  numeric: any;
  timestamptz: any;
  uuid: any;
  float8: any;
  date: any;
};

/** columns and relationships of "actual_balances" */
export type Actual_Balances = {
  __typename?: "actual_balances";
  balance: Scalars["numeric"];
  balance_eur?: Maybe<Scalars["numeric"]>;
  balance_gbp: Scalars["numeric"];
  balance_usd?: Maybe<Scalars["numeric"]>;
  /** An object relationship */
  bank_account: Bank_Accounts;
  bank_account_id: Scalars["String"];
  created_at: Scalars["timestamptz"];
  date: Scalars["date"];
  id: Scalars["Int"];
  interest_rate: Scalars["numeric"];
  maturity_date: Scalars["date"];
};

/** aggregated selection of "actual_balances" */
export type Actual_Balances_Aggregate = {
  __typename?: "actual_balances_aggregate";
  aggregate?: Maybe<Actual_Balances_Aggregate_Fields>;
  nodes: Array<Actual_Balances>;
};

/** aggregate fields of "actual_balances" */
export type Actual_Balances_Aggregate_Fields = {
  __typename?: "actual_balances_aggregate_fields";
  avg?: Maybe<Actual_Balances_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Actual_Balances_Max_Fields>;
  min?: Maybe<Actual_Balances_Min_Fields>;
  stddev?: Maybe<Actual_Balances_Stddev_Fields>;
  stddev_pop?: Maybe<Actual_Balances_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Actual_Balances_Stddev_Samp_Fields>;
  sum?: Maybe<Actual_Balances_Sum_Fields>;
  var_pop?: Maybe<Actual_Balances_Var_Pop_Fields>;
  var_samp?: Maybe<Actual_Balances_Var_Samp_Fields>;
  variance?: Maybe<Actual_Balances_Variance_Fields>;
};

/** aggregate fields of "actual_balances" */
export type Actual_Balances_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Actual_Balances_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "actual_balances" */
export type Actual_Balances_Aggregate_Order_By = {
  avg?: Maybe<Actual_Balances_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Actual_Balances_Max_Order_By>;
  min?: Maybe<Actual_Balances_Min_Order_By>;
  stddev?: Maybe<Actual_Balances_Stddev_Order_By>;
  stddev_pop?: Maybe<Actual_Balances_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Actual_Balances_Stddev_Samp_Order_By>;
  sum?: Maybe<Actual_Balances_Sum_Order_By>;
  var_pop?: Maybe<Actual_Balances_Var_Pop_Order_By>;
  var_samp?: Maybe<Actual_Balances_Var_Samp_Order_By>;
  variance?: Maybe<Actual_Balances_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "actual_balances" */
export type Actual_Balances_Arr_Rel_Insert_Input = {
  data: Array<Actual_Balances_Insert_Input>;
  on_conflict?: Maybe<Actual_Balances_On_Conflict>;
};

/** aggregate avg on columns */
export type Actual_Balances_Avg_Fields = {
  __typename?: "actual_balances_avg_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_eur?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  balance_usd?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  interest_rate?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "actual_balances" */
export type Actual_Balances_Avg_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "actual_balances". All fields are combined with a logical 'AND'. */
export type Actual_Balances_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Actual_Balances_Bool_Exp>>>;
  _not?: Maybe<Actual_Balances_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Actual_Balances_Bool_Exp>>>;
  balance?: Maybe<Numeric_Comparison_Exp>;
  balance_eur?: Maybe<Numeric_Comparison_Exp>;
  balance_gbp?: Maybe<Numeric_Comparison_Exp>;
  balance_usd?: Maybe<Numeric_Comparison_Exp>;
  bank_account?: Maybe<Bank_Accounts_Bool_Exp>;
  bank_account_id?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  interest_rate?: Maybe<Numeric_Comparison_Exp>;
  maturity_date?: Maybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "actual_balances" */
export enum Actual_Balances_Constraint {
  /** unique or primary key constraint */
  ActualBalancePkey = "ActualBalance_pkey",
  /** unique or primary key constraint */
  ActualBalancesDateBankAccountIdKey = "actual_balances_date_bank_account_id_key",
}

/** input type for incrementing integer column in table "actual_balances" */
export type Actual_Balances_Inc_Input = {
  balance?: Maybe<Scalars["numeric"]>;
  balance_eur?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  balance_usd?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  interest_rate?: Maybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "actual_balances" */
export type Actual_Balances_Insert_Input = {
  balance?: Maybe<Scalars["numeric"]>;
  balance_eur?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  balance_usd?: Maybe<Scalars["numeric"]>;
  bank_account?: Maybe<Bank_Accounts_Obj_Rel_Insert_Input>;
  bank_account_id?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  interest_rate?: Maybe<Scalars["numeric"]>;
  maturity_date?: Maybe<Scalars["date"]>;
};

/** aggregate max on columns */
export type Actual_Balances_Max_Fields = {
  __typename?: "actual_balances_max_fields";
  balance?: Maybe<Scalars["numeric"]>;
  balance_eur?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  balance_usd?: Maybe<Scalars["numeric"]>;
  bank_account_id?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  interest_rate?: Maybe<Scalars["numeric"]>;
  maturity_date?: Maybe<Scalars["date"]>;
};

/** order by max() on columns of table "actual_balances" */
export type Actual_Balances_Max_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  bank_account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
  maturity_date?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Actual_Balances_Min_Fields = {
  __typename?: "actual_balances_min_fields";
  balance?: Maybe<Scalars["numeric"]>;
  balance_eur?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  balance_usd?: Maybe<Scalars["numeric"]>;
  bank_account_id?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  interest_rate?: Maybe<Scalars["numeric"]>;
  maturity_date?: Maybe<Scalars["date"]>;
};

/** order by min() on columns of table "actual_balances" */
export type Actual_Balances_Min_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  bank_account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
  maturity_date?: Maybe<Order_By>;
};

/** response of any mutation on the table "actual_balances" */
export type Actual_Balances_Mutation_Response = {
  __typename?: "actual_balances_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Actual_Balances>;
};

/** input type for inserting object relation for remote table "actual_balances" */
export type Actual_Balances_Obj_Rel_Insert_Input = {
  data: Actual_Balances_Insert_Input;
  on_conflict?: Maybe<Actual_Balances_On_Conflict>;
};

/** on conflict condition type for table "actual_balances" */
export type Actual_Balances_On_Conflict = {
  constraint: Actual_Balances_Constraint;
  update_columns: Array<Actual_Balances_Update_Column>;
  where?: Maybe<Actual_Balances_Bool_Exp>;
};

/** ordering options when selecting data from "actual_balances" */
export type Actual_Balances_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  bank_account?: Maybe<Bank_Accounts_Order_By>;
  bank_account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
  maturity_date?: Maybe<Order_By>;
};

/** primary key columns input for table: "actual_balances" */
export type Actual_Balances_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "actual_balances" */
export enum Actual_Balances_Select_Column {
  /** column name */
  Balance = "balance",
  /** column name */
  BalanceEur = "balance_eur",
  /** column name */
  BalanceGbp = "balance_gbp",
  /** column name */
  BalanceUsd = "balance_usd",
  /** column name */
  BankAccountId = "bank_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Date = "date",
  /** column name */
  Id = "id",
  /** column name */
  InterestRate = "interest_rate",
  /** column name */
  MaturityDate = "maturity_date",
}

/** input type for updating data in table "actual_balances" */
export type Actual_Balances_Set_Input = {
  balance?: Maybe<Scalars["numeric"]>;
  balance_eur?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  balance_usd?: Maybe<Scalars["numeric"]>;
  bank_account_id?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  interest_rate?: Maybe<Scalars["numeric"]>;
  maturity_date?: Maybe<Scalars["date"]>;
};

/** aggregate stddev on columns */
export type Actual_Balances_Stddev_Fields = {
  __typename?: "actual_balances_stddev_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_eur?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  balance_usd?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  interest_rate?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "actual_balances" */
export type Actual_Balances_Stddev_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Actual_Balances_Stddev_Pop_Fields = {
  __typename?: "actual_balances_stddev_pop_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_eur?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  balance_usd?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  interest_rate?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "actual_balances" */
export type Actual_Balances_Stddev_Pop_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Actual_Balances_Stddev_Samp_Fields = {
  __typename?: "actual_balances_stddev_samp_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_eur?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  balance_usd?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  interest_rate?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "actual_balances" */
export type Actual_Balances_Stddev_Samp_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Actual_Balances_Sum_Fields = {
  __typename?: "actual_balances_sum_fields";
  balance?: Maybe<Scalars["numeric"]>;
  balance_eur?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  balance_usd?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  interest_rate?: Maybe<Scalars["numeric"]>;
};

/** order by sum() on columns of table "actual_balances" */
export type Actual_Balances_Sum_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** update columns of table "actual_balances" */
export enum Actual_Balances_Update_Column {
  /** column name */
  Balance = "balance",
  /** column name */
  BalanceEur = "balance_eur",
  /** column name */
  BalanceGbp = "balance_gbp",
  /** column name */
  BalanceUsd = "balance_usd",
  /** column name */
  BankAccountId = "bank_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Date = "date",
  /** column name */
  Id = "id",
  /** column name */
  InterestRate = "interest_rate",
  /** column name */
  MaturityDate = "maturity_date",
}

/** aggregate var_pop on columns */
export type Actual_Balances_Var_Pop_Fields = {
  __typename?: "actual_balances_var_pop_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_eur?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  balance_usd?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  interest_rate?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "actual_balances" */
export type Actual_Balances_Var_Pop_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Actual_Balances_Var_Samp_Fields = {
  __typename?: "actual_balances_var_samp_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_eur?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  balance_usd?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  interest_rate?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "actual_balances" */
export type Actual_Balances_Var_Samp_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Actual_Balances_Variance_Fields = {
  __typename?: "actual_balances_variance_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_eur?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  balance_usd?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  interest_rate?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "actual_balances" */
export type Actual_Balances_Variance_Order_By = {
  balance?: Maybe<Order_By>;
  balance_eur?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  balance_usd?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  interest_rate?: Maybe<Order_By>;
};

/** columns and relationships of "app_users" */
export type App_Users = {
  __typename?: "app_users";
  app_tour_completed: Scalars["Boolean"];
  created_at: Scalars["timestamptz"];
  email: Scalars["String"];
  id: Scalars["String"];
  /** An object relationship */
  image?: Maybe<Uploads>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  is_admin: Scalars["Boolean"];
  last_logged_in?: Maybe<Scalars["timestamptz"]>;
  name?: Maybe<Scalars["String"]>;
  /** An array relationship */
  organisations: Array<Organisation_Users>;
  /** An aggregated array relationship */
  organisations_aggregate: Organisation_Users_Aggregate;
  phone_number?: Maybe<Scalars["String"]>;
  /** An object relationship */
  selected_organisation?: Maybe<Organisations>;
  selected_organisation_id?: Maybe<Scalars["Int"]>;
};

/** columns and relationships of "app_users" */
export type App_UsersOrganisationsArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** columns and relationships of "app_users" */
export type App_UsersOrganisations_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** aggregated selection of "app_users" */
export type App_Users_Aggregate = {
  __typename?: "app_users_aggregate";
  aggregate?: Maybe<App_Users_Aggregate_Fields>;
  nodes: Array<App_Users>;
};

/** aggregate fields of "app_users" */
export type App_Users_Aggregate_Fields = {
  __typename?: "app_users_aggregate_fields";
  avg?: Maybe<App_Users_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<App_Users_Max_Fields>;
  min?: Maybe<App_Users_Min_Fields>;
  stddev?: Maybe<App_Users_Stddev_Fields>;
  stddev_pop?: Maybe<App_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<App_Users_Stddev_Samp_Fields>;
  sum?: Maybe<App_Users_Sum_Fields>;
  var_pop?: Maybe<App_Users_Var_Pop_Fields>;
  var_samp?: Maybe<App_Users_Var_Samp_Fields>;
  variance?: Maybe<App_Users_Variance_Fields>;
};

/** aggregate fields of "app_users" */
export type App_Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<App_Users_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "app_users" */
export type App_Users_Aggregate_Order_By = {
  avg?: Maybe<App_Users_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<App_Users_Max_Order_By>;
  min?: Maybe<App_Users_Min_Order_By>;
  stddev?: Maybe<App_Users_Stddev_Order_By>;
  stddev_pop?: Maybe<App_Users_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<App_Users_Stddev_Samp_Order_By>;
  sum?: Maybe<App_Users_Sum_Order_By>;
  var_pop?: Maybe<App_Users_Var_Pop_Order_By>;
  var_samp?: Maybe<App_Users_Var_Samp_Order_By>;
  variance?: Maybe<App_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "app_users" */
export type App_Users_Arr_Rel_Insert_Input = {
  data: Array<App_Users_Insert_Input>;
  on_conflict?: Maybe<App_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type App_Users_Avg_Fields = {
  __typename?: "app_users_avg_fields";
  selected_organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "app_users" */
export type App_Users_Avg_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "app_users". All fields are combined with a logical 'AND'. */
export type App_Users_Bool_Exp = {
  _and?: Maybe<Array<Maybe<App_Users_Bool_Exp>>>;
  _not?: Maybe<App_Users_Bool_Exp>;
  _or?: Maybe<Array<Maybe<App_Users_Bool_Exp>>>;
  app_tour_completed?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  image?: Maybe<Uploads_Bool_Exp>;
  image_upload_id?: Maybe<Uuid_Comparison_Exp>;
  is_admin?: Maybe<Boolean_Comparison_Exp>;
  last_logged_in?: Maybe<Timestamptz_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  organisations?: Maybe<Organisation_Users_Bool_Exp>;
  phone_number?: Maybe<String_Comparison_Exp>;
  selected_organisation?: Maybe<Organisations_Bool_Exp>;
  selected_organisation_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "app_users" */
export enum App_Users_Constraint {
  /** unique or primary key constraint */
  AppUserPkey = "appUser_pkey",
}

/** input type for incrementing integer column in table "app_users" */
export type App_Users_Inc_Input = {
  selected_organisation_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "app_users" */
export type App_Users_Insert_Input = {
  app_tour_completed?: Maybe<Scalars["Boolean"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  email?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  image?: Maybe<Uploads_Obj_Rel_Insert_Input>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  is_admin?: Maybe<Scalars["Boolean"]>;
  last_logged_in?: Maybe<Scalars["timestamptz"]>;
  name?: Maybe<Scalars["String"]>;
  organisations?: Maybe<Organisation_Users_Arr_Rel_Insert_Input>;
  phone_number?: Maybe<Scalars["String"]>;
  selected_organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  selected_organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type App_Users_Max_Fields = {
  __typename?: "app_users_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  email?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  last_logged_in?: Maybe<Scalars["timestamptz"]>;
  name?: Maybe<Scalars["String"]>;
  phone_number?: Maybe<Scalars["String"]>;
  selected_organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "app_users" */
export type App_Users_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image_upload_id?: Maybe<Order_By>;
  last_logged_in?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  selected_organisation_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type App_Users_Min_Fields = {
  __typename?: "app_users_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  email?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  last_logged_in?: Maybe<Scalars["timestamptz"]>;
  name?: Maybe<Scalars["String"]>;
  phone_number?: Maybe<Scalars["String"]>;
  selected_organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "app_users" */
export type App_Users_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image_upload_id?: Maybe<Order_By>;
  last_logged_in?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  phone_number?: Maybe<Order_By>;
  selected_organisation_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "app_users" */
export type App_Users_Mutation_Response = {
  __typename?: "app_users_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<App_Users>;
};

/** input type for inserting object relation for remote table "app_users" */
export type App_Users_Obj_Rel_Insert_Input = {
  data: App_Users_Insert_Input;
  on_conflict?: Maybe<App_Users_On_Conflict>;
};

/** on conflict condition type for table "app_users" */
export type App_Users_On_Conflict = {
  constraint: App_Users_Constraint;
  update_columns: Array<App_Users_Update_Column>;
  where?: Maybe<App_Users_Bool_Exp>;
};

/** ordering options when selecting data from "app_users" */
export type App_Users_Order_By = {
  app_tour_completed?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image?: Maybe<Uploads_Order_By>;
  image_upload_id?: Maybe<Order_By>;
  is_admin?: Maybe<Order_By>;
  last_logged_in?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  organisations_aggregate?: Maybe<Organisation_Users_Aggregate_Order_By>;
  phone_number?: Maybe<Order_By>;
  selected_organisation?: Maybe<Organisations_Order_By>;
  selected_organisation_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "app_users" */
export type App_Users_Pk_Columns_Input = {
  id: Scalars["String"];
};

/** select columns of table "app_users" */
export enum App_Users_Select_Column {
  /** column name */
  AppTourCompleted = "app_tour_completed",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Email = "email",
  /** column name */
  Id = "id",
  /** column name */
  ImageUploadId = "image_upload_id",
  /** column name */
  IsAdmin = "is_admin",
  /** column name */
  LastLoggedIn = "last_logged_in",
  /** column name */
  Name = "name",
  /** column name */
  PhoneNumber = "phone_number",
  /** column name */
  SelectedOrganisationId = "selected_organisation_id",
}

/** input type for updating data in table "app_users" */
export type App_Users_Set_Input = {
  app_tour_completed?: Maybe<Scalars["Boolean"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  email?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  is_admin?: Maybe<Scalars["Boolean"]>;
  last_logged_in?: Maybe<Scalars["timestamptz"]>;
  name?: Maybe<Scalars["String"]>;
  phone_number?: Maybe<Scalars["String"]>;
  selected_organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type App_Users_Stddev_Fields = {
  __typename?: "app_users_stddev_fields";
  selected_organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "app_users" */
export type App_Users_Stddev_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type App_Users_Stddev_Pop_Fields = {
  __typename?: "app_users_stddev_pop_fields";
  selected_organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "app_users" */
export type App_Users_Stddev_Pop_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type App_Users_Stddev_Samp_Fields = {
  __typename?: "app_users_stddev_samp_fields";
  selected_organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "app_users" */
export type App_Users_Stddev_Samp_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type App_Users_Sum_Fields = {
  __typename?: "app_users_sum_fields";
  selected_organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "app_users" */
export type App_Users_Sum_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** update columns of table "app_users" */
export enum App_Users_Update_Column {
  /** column name */
  AppTourCompleted = "app_tour_completed",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Email = "email",
  /** column name */
  Id = "id",
  /** column name */
  ImageUploadId = "image_upload_id",
  /** column name */
  IsAdmin = "is_admin",
  /** column name */
  LastLoggedIn = "last_logged_in",
  /** column name */
  Name = "name",
  /** column name */
  PhoneNumber = "phone_number",
  /** column name */
  SelectedOrganisationId = "selected_organisation_id",
}

/** aggregate var_pop on columns */
export type App_Users_Var_Pop_Fields = {
  __typename?: "app_users_var_pop_fields";
  selected_organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "app_users" */
export type App_Users_Var_Pop_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type App_Users_Var_Samp_Fields = {
  __typename?: "app_users_var_samp_fields";
  selected_organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "app_users" */
export type App_Users_Var_Samp_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type App_Users_Variance_Fields = {
  __typename?: "app_users_variance_fields";
  selected_organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "app_users" */
export type App_Users_Variance_Order_By = {
  selected_organisation_id?: Maybe<Order_By>;
};

/** columns and relationships of "bank_accounts" */
export type Bank_Accounts = {
  __typename?: "bank_accounts";
  account_description?: Maybe<Scalars["String"]>;
  account_id: Scalars["String"];
  /** An array relationship */
  actual_balances: Array<Actual_Balances>;
  /** An aggregated array relationship */
  actual_balances_aggregate: Actual_Balances_Aggregate;
  /** An object relationship */
  bank?: Maybe<Banks>;
  bank_id?: Maybe<Scalars["Int"]>;
  created_at: Scalars["timestamptz"];
  /** An object relationship */
  currency: Currencies;
  /** An object relationship */
  currency_book: Currency_Books;
  currency_book_id: Scalars["Int"];
  currency_id: Scalars["Int"];
  fixed_maturity_date?: Maybe<Scalars["date"]>;
  id: Scalars["uuid"];
  /** An array relationship */
  model_balances: Array<Model_Balances>;
  /** An aggregated array relationship */
  model_balances_aggregate: Model_Balances_Aggregate;
  notice_days?: Maybe<Scalars["Int"]>;
  opening_interest_rate: Scalars["numeric"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
  product_type: Product_Types_Enum_Enum;
};

/** columns and relationships of "bank_accounts" */
export type Bank_AccountsActual_BalancesArgs = {
  distinct_on?: Maybe<Array<Actual_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Actual_Balances_Order_By>>;
  where?: Maybe<Actual_Balances_Bool_Exp>;
};

/** columns and relationships of "bank_accounts" */
export type Bank_AccountsActual_Balances_AggregateArgs = {
  distinct_on?: Maybe<Array<Actual_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Actual_Balances_Order_By>>;
  where?: Maybe<Actual_Balances_Bool_Exp>;
};

/** columns and relationships of "bank_accounts" */
export type Bank_AccountsModel_BalancesArgs = {
  distinct_on?: Maybe<Array<Model_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Model_Balances_Order_By>>;
  where?: Maybe<Model_Balances_Bool_Exp>;
};

/** columns and relationships of "bank_accounts" */
export type Bank_AccountsModel_Balances_AggregateArgs = {
  distinct_on?: Maybe<Array<Model_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Model_Balances_Order_By>>;
  where?: Maybe<Model_Balances_Bool_Exp>;
};

/** aggregated selection of "bank_accounts" */
export type Bank_Accounts_Aggregate = {
  __typename?: "bank_accounts_aggregate";
  aggregate?: Maybe<Bank_Accounts_Aggregate_Fields>;
  nodes: Array<Bank_Accounts>;
};

/** aggregate fields of "bank_accounts" */
export type Bank_Accounts_Aggregate_Fields = {
  __typename?: "bank_accounts_aggregate_fields";
  avg?: Maybe<Bank_Accounts_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Bank_Accounts_Max_Fields>;
  min?: Maybe<Bank_Accounts_Min_Fields>;
  stddev?: Maybe<Bank_Accounts_Stddev_Fields>;
  stddev_pop?: Maybe<Bank_Accounts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bank_Accounts_Stddev_Samp_Fields>;
  sum?: Maybe<Bank_Accounts_Sum_Fields>;
  var_pop?: Maybe<Bank_Accounts_Var_Pop_Fields>;
  var_samp?: Maybe<Bank_Accounts_Var_Samp_Fields>;
  variance?: Maybe<Bank_Accounts_Variance_Fields>;
};

/** aggregate fields of "bank_accounts" */
export type Bank_Accounts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bank_Accounts_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "bank_accounts" */
export type Bank_Accounts_Aggregate_Order_By = {
  avg?: Maybe<Bank_Accounts_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bank_Accounts_Max_Order_By>;
  min?: Maybe<Bank_Accounts_Min_Order_By>;
  stddev?: Maybe<Bank_Accounts_Stddev_Order_By>;
  stddev_pop?: Maybe<Bank_Accounts_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bank_Accounts_Stddev_Samp_Order_By>;
  sum?: Maybe<Bank_Accounts_Sum_Order_By>;
  var_pop?: Maybe<Bank_Accounts_Var_Pop_Order_By>;
  var_samp?: Maybe<Bank_Accounts_Var_Samp_Order_By>;
  variance?: Maybe<Bank_Accounts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bank_accounts" */
export type Bank_Accounts_Arr_Rel_Insert_Input = {
  data: Array<Bank_Accounts_Insert_Input>;
  on_conflict?: Maybe<Bank_Accounts_On_Conflict>;
};

/** aggregate avg on columns */
export type Bank_Accounts_Avg_Fields = {
  __typename?: "bank_accounts_avg_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  notice_days?: Maybe<Scalars["Float"]>;
  opening_interest_rate?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "bank_accounts" */
export type Bank_Accounts_Avg_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bank_accounts". All fields are combined with a logical 'AND'. */
export type Bank_Accounts_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bank_Accounts_Bool_Exp>>>;
  _not?: Maybe<Bank_Accounts_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bank_Accounts_Bool_Exp>>>;
  account_description?: Maybe<String_Comparison_Exp>;
  account_id?: Maybe<String_Comparison_Exp>;
  actual_balances?: Maybe<Actual_Balances_Bool_Exp>;
  bank?: Maybe<Banks_Bool_Exp>;
  bank_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency?: Maybe<Currencies_Bool_Exp>;
  currency_book?: Maybe<Currency_Books_Bool_Exp>;
  currency_book_id?: Maybe<Int_Comparison_Exp>;
  currency_id?: Maybe<Int_Comparison_Exp>;
  fixed_maturity_date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  model_balances?: Maybe<Model_Balances_Bool_Exp>;
  notice_days?: Maybe<Int_Comparison_Exp>;
  opening_interest_rate?: Maybe<Numeric_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
  product_type?: Maybe<Product_Types_Enum_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "bank_accounts" */
export enum Bank_Accounts_Constraint {
  /** unique or primary key constraint */
  BankAccountAcIdKey = "BankAccount_acId_key",
  /** unique or primary key constraint */
  BankAccountsPkey = "BankAccounts_pkey",
}

/** input type for incrementing integer column in table "bank_accounts" */
export type Bank_Accounts_Inc_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  notice_days?: Maybe<Scalars["Int"]>;
  opening_interest_rate?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "bank_accounts" */
export type Bank_Accounts_Insert_Input = {
  account_description?: Maybe<Scalars["String"]>;
  account_id?: Maybe<Scalars["String"]>;
  actual_balances?: Maybe<Actual_Balances_Arr_Rel_Insert_Input>;
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency?: Maybe<Currencies_Obj_Rel_Insert_Input>;
  currency_book?: Maybe<Currency_Books_Obj_Rel_Insert_Input>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  fixed_maturity_date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["uuid"]>;
  model_balances?: Maybe<Model_Balances_Arr_Rel_Insert_Input>;
  notice_days?: Maybe<Scalars["Int"]>;
  opening_interest_rate?: Maybe<Scalars["numeric"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
  product_type?: Maybe<Product_Types_Enum_Enum>;
};

/** aggregate max on columns */
export type Bank_Accounts_Max_Fields = {
  __typename?: "bank_accounts_max_fields";
  account_description?: Maybe<Scalars["String"]>;
  account_id?: Maybe<Scalars["String"]>;
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  fixed_maturity_date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["uuid"]>;
  notice_days?: Maybe<Scalars["Int"]>;
  opening_interest_rate?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "bank_accounts" */
export type Bank_Accounts_Max_Order_By = {
  account_description?: Maybe<Order_By>;
  account_id?: Maybe<Order_By>;
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  fixed_maturity_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bank_Accounts_Min_Fields = {
  __typename?: "bank_accounts_min_fields";
  account_description?: Maybe<Scalars["String"]>;
  account_id?: Maybe<Scalars["String"]>;
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  fixed_maturity_date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["uuid"]>;
  notice_days?: Maybe<Scalars["Int"]>;
  opening_interest_rate?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "bank_accounts" */
export type Bank_Accounts_Min_Order_By = {
  account_description?: Maybe<Order_By>;
  account_id?: Maybe<Order_By>;
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  fixed_maturity_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bank_accounts" */
export type Bank_Accounts_Mutation_Response = {
  __typename?: "bank_accounts_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Bank_Accounts>;
};

/** input type for inserting object relation for remote table "bank_accounts" */
export type Bank_Accounts_Obj_Rel_Insert_Input = {
  data: Bank_Accounts_Insert_Input;
  on_conflict?: Maybe<Bank_Accounts_On_Conflict>;
};

/** on conflict condition type for table "bank_accounts" */
export type Bank_Accounts_On_Conflict = {
  constraint: Bank_Accounts_Constraint;
  update_columns: Array<Bank_Accounts_Update_Column>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** ordering options when selecting data from "bank_accounts" */
export type Bank_Accounts_Order_By = {
  account_description?: Maybe<Order_By>;
  account_id?: Maybe<Order_By>;
  actual_balances_aggregate?: Maybe<Actual_Balances_Aggregate_Order_By>;
  bank?: Maybe<Banks_Order_By>;
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Currencies_Order_By>;
  currency_book?: Maybe<Currency_Books_Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  fixed_maturity_date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  model_balances_aggregate?: Maybe<Model_Balances_Aggregate_Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
  product_type?: Maybe<Order_By>;
};

/** primary key columns input for table: "bank_accounts" */
export type Bank_Accounts_Pk_Columns_Input = {
  account_id: Scalars["String"];
};

/** select columns of table "bank_accounts" */
export enum Bank_Accounts_Select_Column {
  /** column name */
  AccountDescription = "account_description",
  /** column name */
  AccountId = "account_id",
  /** column name */
  BankId = "bank_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  CurrencyId = "currency_id",
  /** column name */
  FixedMaturityDate = "fixed_maturity_date",
  /** column name */
  Id = "id",
  /** column name */
  NoticeDays = "notice_days",
  /** column name */
  OpeningInterestRate = "opening_interest_rate",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  ProductType = "product_type",
}

/** input type for updating data in table "bank_accounts" */
export type Bank_Accounts_Set_Input = {
  account_description?: Maybe<Scalars["String"]>;
  account_id?: Maybe<Scalars["String"]>;
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  fixed_maturity_date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["uuid"]>;
  notice_days?: Maybe<Scalars["Int"]>;
  opening_interest_rate?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  product_type?: Maybe<Product_Types_Enum_Enum>;
};

/** aggregate stddev on columns */
export type Bank_Accounts_Stddev_Fields = {
  __typename?: "bank_accounts_stddev_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  notice_days?: Maybe<Scalars["Float"]>;
  opening_interest_rate?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "bank_accounts" */
export type Bank_Accounts_Stddev_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bank_Accounts_Stddev_Pop_Fields = {
  __typename?: "bank_accounts_stddev_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  notice_days?: Maybe<Scalars["Float"]>;
  opening_interest_rate?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "bank_accounts" */
export type Bank_Accounts_Stddev_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bank_Accounts_Stddev_Samp_Fields = {
  __typename?: "bank_accounts_stddev_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  notice_days?: Maybe<Scalars["Float"]>;
  opening_interest_rate?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "bank_accounts" */
export type Bank_Accounts_Stddev_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bank_Accounts_Sum_Fields = {
  __typename?: "bank_accounts_sum_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  notice_days?: Maybe<Scalars["Int"]>;
  opening_interest_rate?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "bank_accounts" */
export type Bank_Accounts_Sum_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** update columns of table "bank_accounts" */
export enum Bank_Accounts_Update_Column {
  /** column name */
  AccountDescription = "account_description",
  /** column name */
  AccountId = "account_id",
  /** column name */
  BankId = "bank_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  CurrencyId = "currency_id",
  /** column name */
  FixedMaturityDate = "fixed_maturity_date",
  /** column name */
  Id = "id",
  /** column name */
  NoticeDays = "notice_days",
  /** column name */
  OpeningInterestRate = "opening_interest_rate",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  ProductType = "product_type",
}

/** aggregate var_pop on columns */
export type Bank_Accounts_Var_Pop_Fields = {
  __typename?: "bank_accounts_var_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  notice_days?: Maybe<Scalars["Float"]>;
  opening_interest_rate?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "bank_accounts" */
export type Bank_Accounts_Var_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bank_Accounts_Var_Samp_Fields = {
  __typename?: "bank_accounts_var_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  notice_days?: Maybe<Scalars["Float"]>;
  opening_interest_rate?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "bank_accounts" */
export type Bank_Accounts_Var_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bank_Accounts_Variance_Fields = {
  __typename?: "bank_accounts_variance_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  notice_days?: Maybe<Scalars["Float"]>;
  opening_interest_rate?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "bank_accounts" */
export type Bank_Accounts_Variance_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  notice_days?: Maybe<Order_By>;
  opening_interest_rate?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** columns and relationships of "bank_factsheets" */
export type Bank_Factsheets = {
  __typename?: "bank_factsheets";
  /** An object relationship */
  bank: Banks;
  bank_id: Scalars["Int"];
  factsheetDate?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  /** An object relationship */
  upload: Uploads;
  upload_id: Scalars["uuid"];
};

/** aggregated selection of "bank_factsheets" */
export type Bank_Factsheets_Aggregate = {
  __typename?: "bank_factsheets_aggregate";
  aggregate?: Maybe<Bank_Factsheets_Aggregate_Fields>;
  nodes: Array<Bank_Factsheets>;
};

/** aggregate fields of "bank_factsheets" */
export type Bank_Factsheets_Aggregate_Fields = {
  __typename?: "bank_factsheets_aggregate_fields";
  avg?: Maybe<Bank_Factsheets_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Bank_Factsheets_Max_Fields>;
  min?: Maybe<Bank_Factsheets_Min_Fields>;
  stddev?: Maybe<Bank_Factsheets_Stddev_Fields>;
  stddev_pop?: Maybe<Bank_Factsheets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bank_Factsheets_Stddev_Samp_Fields>;
  sum?: Maybe<Bank_Factsheets_Sum_Fields>;
  var_pop?: Maybe<Bank_Factsheets_Var_Pop_Fields>;
  var_samp?: Maybe<Bank_Factsheets_Var_Samp_Fields>;
  variance?: Maybe<Bank_Factsheets_Variance_Fields>;
};

/** aggregate fields of "bank_factsheets" */
export type Bank_Factsheets_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "bank_factsheets" */
export type Bank_Factsheets_Aggregate_Order_By = {
  avg?: Maybe<Bank_Factsheets_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Bank_Factsheets_Max_Order_By>;
  min?: Maybe<Bank_Factsheets_Min_Order_By>;
  stddev?: Maybe<Bank_Factsheets_Stddev_Order_By>;
  stddev_pop?: Maybe<Bank_Factsheets_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Bank_Factsheets_Stddev_Samp_Order_By>;
  sum?: Maybe<Bank_Factsheets_Sum_Order_By>;
  var_pop?: Maybe<Bank_Factsheets_Var_Pop_Order_By>;
  var_samp?: Maybe<Bank_Factsheets_Var_Samp_Order_By>;
  variance?: Maybe<Bank_Factsheets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bank_factsheets" */
export type Bank_Factsheets_Arr_Rel_Insert_Input = {
  data: Array<Bank_Factsheets_Insert_Input>;
  on_conflict?: Maybe<Bank_Factsheets_On_Conflict>;
};

/** aggregate avg on columns */
export type Bank_Factsheets_Avg_Fields = {
  __typename?: "bank_factsheets_avg_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Avg_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bank_factsheets". All fields are combined with a logical 'AND'. */
export type Bank_Factsheets_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bank_Factsheets_Bool_Exp>>>;
  _not?: Maybe<Bank_Factsheets_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Bank_Factsheets_Bool_Exp>>>;
  bank?: Maybe<Banks_Bool_Exp>;
  bank_id?: Maybe<Int_Comparison_Exp>;
  factsheetDate?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  upload?: Maybe<Uploads_Bool_Exp>;
  upload_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "bank_factsheets" */
export enum Bank_Factsheets_Constraint {
  /** unique or primary key constraint */
  BankFactsheetsPkey = "BankFactsheets_pkey",
}

/** input type for incrementing integer column in table "bank_factsheets" */
export type Bank_Factsheets_Inc_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "bank_factsheets" */
export type Bank_Factsheets_Insert_Input = {
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bank_id?: Maybe<Scalars["Int"]>;
  factsheetDate?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  upload?: Maybe<Uploads_Obj_Rel_Insert_Input>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** aggregate max on columns */
export type Bank_Factsheets_Max_Fields = {
  __typename?: "bank_factsheets_max_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  factsheetDate?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Max_Order_By = {
  bank_id?: Maybe<Order_By>;
  factsheetDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Bank_Factsheets_Min_Fields = {
  __typename?: "bank_factsheets_min_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  factsheetDate?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** order by min() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Min_Order_By = {
  bank_id?: Maybe<Order_By>;
  factsheetDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "bank_factsheets" */
export type Bank_Factsheets_Mutation_Response = {
  __typename?: "bank_factsheets_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Bank_Factsheets>;
};

/** input type for inserting object relation for remote table "bank_factsheets" */
export type Bank_Factsheets_Obj_Rel_Insert_Input = {
  data: Bank_Factsheets_Insert_Input;
  on_conflict?: Maybe<Bank_Factsheets_On_Conflict>;
};

/** on conflict condition type for table "bank_factsheets" */
export type Bank_Factsheets_On_Conflict = {
  constraint: Bank_Factsheets_Constraint;
  update_columns: Array<Bank_Factsheets_Update_Column>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** ordering options when selecting data from "bank_factsheets" */
export type Bank_Factsheets_Order_By = {
  bank?: Maybe<Banks_Order_By>;
  bank_id?: Maybe<Order_By>;
  factsheetDate?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  upload?: Maybe<Uploads_Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "bank_factsheets" */
export type Bank_Factsheets_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "bank_factsheets" */
export enum Bank_Factsheets_Select_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  FactsheetDate = "factsheetDate",
  /** column name */
  Id = "id",
  /** column name */
  UploadId = "upload_id",
}

/** input type for updating data in table "bank_factsheets" */
export type Bank_Factsheets_Set_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  factsheetDate?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** aggregate stddev on columns */
export type Bank_Factsheets_Stddev_Fields = {
  __typename?: "bank_factsheets_stddev_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Stddev_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bank_Factsheets_Stddev_Pop_Fields = {
  __typename?: "bank_factsheets_stddev_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Stddev_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bank_Factsheets_Stddev_Samp_Fields = {
  __typename?: "bank_factsheets_stddev_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Stddev_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Bank_Factsheets_Sum_Fields = {
  __typename?: "bank_factsheets_sum_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Sum_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "bank_factsheets" */
export enum Bank_Factsheets_Update_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  FactsheetDate = "factsheetDate",
  /** column name */
  Id = "id",
  /** column name */
  UploadId = "upload_id",
}

/** aggregate var_pop on columns */
export type Bank_Factsheets_Var_Pop_Fields = {
  __typename?: "bank_factsheets_var_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Var_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bank_Factsheets_Var_Samp_Fields = {
  __typename?: "bank_factsheets_var_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Var_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Bank_Factsheets_Variance_Fields = {
  __typename?: "bank_factsheets_variance_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "bank_factsheets" */
export type Bank_Factsheets_Variance_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "banks" */
export type Banks = {
  __typename?: "banks";
  address?: Maybe<Scalars["String"]>;
  /** An array relationship */
  bank_factsheets: Array<Bank_Factsheets>;
  /** An aggregated array relationship */
  bank_factsheets_aggregate: Bank_Factsheets_Aggregate;
  created_at: Scalars["timestamptz"];
  id: Scalars["Int"];
  /** An object relationship */
  image?: Maybe<Uploads>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name: Scalars["String"];
  notes?: Maybe<Scalars["String"]>;
  /** An array relationship */
  organisation_bank_exposure_limits: Array<Organisation_Bank_Exposure_Limits>;
  /** An aggregated array relationship */
  organisation_bank_exposure_limits_aggregate: Organisation_Bank_Exposure_Limits_Aggregate;
  /** An array relationship */
  organisations: Array<Organisation_Banks>;
  /** An aggregated array relationship */
  organisations_aggregate: Organisation_Banks_Aggregate;
  ownership?: Maybe<Scalars["String"]>;
  regulator?: Maybe<Scalars["String"]>;
  risk_5y_cds_spread?: Maybe<Scalars["numeric"]>;
  risk_base_currency?: Maybe<Scalars["Int"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["numeric"]>;
  risk_leverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_market_cap?: Maybe<Scalars["String"]>;
  risk_outlook_fitch?: Maybe<Scalars["String"]>;
  risk_outlook_moodys?: Maybe<Scalars["String"]>;
  risk_outlook_sp?: Maybe<Scalars["String"]>;
  risk_rating_fitch_date?: Maybe<Scalars["date"]>;
  risk_rating_long_fitch?: Maybe<Scalars["String"]>;
  risk_rating_long_moodys?: Maybe<Scalars["String"]>;
  risk_rating_long_sp?: Maybe<Scalars["String"]>;
  risk_rating_moodys_date?: Maybe<Scalars["date"]>;
  risk_rating_short_fitch?: Maybe<Scalars["String"]>;
  risk_rating_short_sp?: Maybe<Scalars["String"]>;
  risk_rating_sp_date?: Maybe<Scalars["date"]>;
  risk_share_movement?: Maybe<Scalars["numeric"]>;
  risk_total_equity?: Maybe<Scalars["String"]>;
};

/** columns and relationships of "banks" */
export type BanksBank_FactsheetsArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** columns and relationships of "banks" */
export type BanksBank_Factsheets_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** columns and relationships of "banks" */
export type BanksOrganisation_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "banks" */
export type BanksOrganisation_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "banks" */
export type BanksOrganisationsArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** columns and relationships of "banks" */
export type BanksOrganisations_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** aggregated selection of "banks" */
export type Banks_Aggregate = {
  __typename?: "banks_aggregate";
  aggregate?: Maybe<Banks_Aggregate_Fields>;
  nodes: Array<Banks>;
};

/** aggregate fields of "banks" */
export type Banks_Aggregate_Fields = {
  __typename?: "banks_aggregate_fields";
  avg?: Maybe<Banks_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Banks_Max_Fields>;
  min?: Maybe<Banks_Min_Fields>;
  stddev?: Maybe<Banks_Stddev_Fields>;
  stddev_pop?: Maybe<Banks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Banks_Stddev_Samp_Fields>;
  sum?: Maybe<Banks_Sum_Fields>;
  var_pop?: Maybe<Banks_Var_Pop_Fields>;
  var_samp?: Maybe<Banks_Var_Samp_Fields>;
  variance?: Maybe<Banks_Variance_Fields>;
};

/** aggregate fields of "banks" */
export type Banks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Banks_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "banks" */
export type Banks_Aggregate_Order_By = {
  avg?: Maybe<Banks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Banks_Max_Order_By>;
  min?: Maybe<Banks_Min_Order_By>;
  stddev?: Maybe<Banks_Stddev_Order_By>;
  stddev_pop?: Maybe<Banks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Banks_Stddev_Samp_Order_By>;
  sum?: Maybe<Banks_Sum_Order_By>;
  var_pop?: Maybe<Banks_Var_Pop_Order_By>;
  var_samp?: Maybe<Banks_Var_Samp_Order_By>;
  variance?: Maybe<Banks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "banks" */
export type Banks_Arr_Rel_Insert_Input = {
  data: Array<Banks_Insert_Input>;
  on_conflict?: Maybe<Banks_On_Conflict>;
};

/** aggregate avg on columns */
export type Banks_Avg_Fields = {
  __typename?: "banks_avg_fields";
  id?: Maybe<Scalars["Float"]>;
  risk_5y_cds_spread?: Maybe<Scalars["Float"]>;
  risk_base_currency?: Maybe<Scalars["Float"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["Float"]>;
  risk_leverage_ratio?: Maybe<Scalars["Float"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["Float"]>;
  risk_share_movement?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "banks" */
export type Banks_Avg_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "banks". All fields are combined with a logical 'AND'. */
export type Banks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Banks_Bool_Exp>>>;
  _not?: Maybe<Banks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Banks_Bool_Exp>>>;
  address?: Maybe<String_Comparison_Exp>;
  bank_factsheets?: Maybe<Bank_Factsheets_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  image?: Maybe<Uploads_Bool_Exp>;
  image_upload_id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
  organisation_bank_exposure_limits?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
  organisations?: Maybe<Organisation_Banks_Bool_Exp>;
  ownership?: Maybe<String_Comparison_Exp>;
  regulator?: Maybe<String_Comparison_Exp>;
  risk_5y_cds_spread?: Maybe<Numeric_Comparison_Exp>;
  risk_base_currency?: Maybe<Int_Comparison_Exp>;
  risk_cet_capital_ratio?: Maybe<Numeric_Comparison_Exp>;
  risk_leverage_ratio?: Maybe<Numeric_Comparison_Exp>;
  risk_liquidity_coverage_ratio?: Maybe<Numeric_Comparison_Exp>;
  risk_market_cap?: Maybe<String_Comparison_Exp>;
  risk_outlook_fitch?: Maybe<String_Comparison_Exp>;
  risk_outlook_moodys?: Maybe<String_Comparison_Exp>;
  risk_outlook_sp?: Maybe<String_Comparison_Exp>;
  risk_rating_fitch_date?: Maybe<Date_Comparison_Exp>;
  risk_rating_long_fitch?: Maybe<String_Comparison_Exp>;
  risk_rating_long_moodys?: Maybe<String_Comparison_Exp>;
  risk_rating_long_sp?: Maybe<String_Comparison_Exp>;
  risk_rating_moodys_date?: Maybe<Date_Comparison_Exp>;
  risk_rating_short_fitch?: Maybe<String_Comparison_Exp>;
  risk_rating_short_sp?: Maybe<String_Comparison_Exp>;
  risk_rating_sp_date?: Maybe<Date_Comparison_Exp>;
  risk_share_movement?: Maybe<Numeric_Comparison_Exp>;
  risk_total_equity?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "banks" */
export enum Banks_Constraint {
  /** unique or primary key constraint */
  BankPkey = "Bank_pkey",
}

/** input type for incrementing integer column in table "banks" */
export type Banks_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
  risk_5y_cds_spread?: Maybe<Scalars["numeric"]>;
  risk_base_currency?: Maybe<Scalars["Int"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["numeric"]>;
  risk_leverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_share_movement?: Maybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "banks" */
export type Banks_Insert_Input = {
  address?: Maybe<Scalars["String"]>;
  bank_factsheets?: Maybe<Bank_Factsheets_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  image?: Maybe<Uploads_Obj_Rel_Insert_Input>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  organisation_bank_exposure_limits?: Maybe<Organisation_Bank_Exposure_Limits_Arr_Rel_Insert_Input>;
  organisations?: Maybe<Organisation_Banks_Arr_Rel_Insert_Input>;
  ownership?: Maybe<Scalars["String"]>;
  regulator?: Maybe<Scalars["String"]>;
  risk_5y_cds_spread?: Maybe<Scalars["numeric"]>;
  risk_base_currency?: Maybe<Scalars["Int"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["numeric"]>;
  risk_leverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_market_cap?: Maybe<Scalars["String"]>;
  risk_outlook_fitch?: Maybe<Scalars["String"]>;
  risk_outlook_moodys?: Maybe<Scalars["String"]>;
  risk_outlook_sp?: Maybe<Scalars["String"]>;
  risk_rating_fitch_date?: Maybe<Scalars["date"]>;
  risk_rating_long_fitch?: Maybe<Scalars["String"]>;
  risk_rating_long_moodys?: Maybe<Scalars["String"]>;
  risk_rating_long_sp?: Maybe<Scalars["String"]>;
  risk_rating_moodys_date?: Maybe<Scalars["date"]>;
  risk_rating_short_fitch?: Maybe<Scalars["String"]>;
  risk_rating_short_sp?: Maybe<Scalars["String"]>;
  risk_rating_sp_date?: Maybe<Scalars["date"]>;
  risk_share_movement?: Maybe<Scalars["numeric"]>;
  risk_total_equity?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Banks_Max_Fields = {
  __typename?: "banks_max_fields";
  address?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  ownership?: Maybe<Scalars["String"]>;
  regulator?: Maybe<Scalars["String"]>;
  risk_5y_cds_spread?: Maybe<Scalars["numeric"]>;
  risk_base_currency?: Maybe<Scalars["Int"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["numeric"]>;
  risk_leverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_market_cap?: Maybe<Scalars["String"]>;
  risk_outlook_fitch?: Maybe<Scalars["String"]>;
  risk_outlook_moodys?: Maybe<Scalars["String"]>;
  risk_outlook_sp?: Maybe<Scalars["String"]>;
  risk_rating_fitch_date?: Maybe<Scalars["date"]>;
  risk_rating_long_fitch?: Maybe<Scalars["String"]>;
  risk_rating_long_moodys?: Maybe<Scalars["String"]>;
  risk_rating_long_sp?: Maybe<Scalars["String"]>;
  risk_rating_moodys_date?: Maybe<Scalars["date"]>;
  risk_rating_short_fitch?: Maybe<Scalars["String"]>;
  risk_rating_short_sp?: Maybe<Scalars["String"]>;
  risk_rating_sp_date?: Maybe<Scalars["date"]>;
  risk_share_movement?: Maybe<Scalars["numeric"]>;
  risk_total_equity?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "banks" */
export type Banks_Max_Order_By = {
  address?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image_upload_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  ownership?: Maybe<Order_By>;
  regulator?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_market_cap?: Maybe<Order_By>;
  risk_outlook_fitch?: Maybe<Order_By>;
  risk_outlook_moodys?: Maybe<Order_By>;
  risk_outlook_sp?: Maybe<Order_By>;
  risk_rating_fitch_date?: Maybe<Order_By>;
  risk_rating_long_fitch?: Maybe<Order_By>;
  risk_rating_long_moodys?: Maybe<Order_By>;
  risk_rating_long_sp?: Maybe<Order_By>;
  risk_rating_moodys_date?: Maybe<Order_By>;
  risk_rating_short_fitch?: Maybe<Order_By>;
  risk_rating_short_sp?: Maybe<Order_By>;
  risk_rating_sp_date?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
  risk_total_equity?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Banks_Min_Fields = {
  __typename?: "banks_min_fields";
  address?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  ownership?: Maybe<Scalars["String"]>;
  regulator?: Maybe<Scalars["String"]>;
  risk_5y_cds_spread?: Maybe<Scalars["numeric"]>;
  risk_base_currency?: Maybe<Scalars["Int"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["numeric"]>;
  risk_leverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_market_cap?: Maybe<Scalars["String"]>;
  risk_outlook_fitch?: Maybe<Scalars["String"]>;
  risk_outlook_moodys?: Maybe<Scalars["String"]>;
  risk_outlook_sp?: Maybe<Scalars["String"]>;
  risk_rating_fitch_date?: Maybe<Scalars["date"]>;
  risk_rating_long_fitch?: Maybe<Scalars["String"]>;
  risk_rating_long_moodys?: Maybe<Scalars["String"]>;
  risk_rating_long_sp?: Maybe<Scalars["String"]>;
  risk_rating_moodys_date?: Maybe<Scalars["date"]>;
  risk_rating_short_fitch?: Maybe<Scalars["String"]>;
  risk_rating_short_sp?: Maybe<Scalars["String"]>;
  risk_rating_sp_date?: Maybe<Scalars["date"]>;
  risk_share_movement?: Maybe<Scalars["numeric"]>;
  risk_total_equity?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "banks" */
export type Banks_Min_Order_By = {
  address?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image_upload_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  ownership?: Maybe<Order_By>;
  regulator?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_market_cap?: Maybe<Order_By>;
  risk_outlook_fitch?: Maybe<Order_By>;
  risk_outlook_moodys?: Maybe<Order_By>;
  risk_outlook_sp?: Maybe<Order_By>;
  risk_rating_fitch_date?: Maybe<Order_By>;
  risk_rating_long_fitch?: Maybe<Order_By>;
  risk_rating_long_moodys?: Maybe<Order_By>;
  risk_rating_long_sp?: Maybe<Order_By>;
  risk_rating_moodys_date?: Maybe<Order_By>;
  risk_rating_short_fitch?: Maybe<Order_By>;
  risk_rating_short_sp?: Maybe<Order_By>;
  risk_rating_sp_date?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
  risk_total_equity?: Maybe<Order_By>;
};

/** response of any mutation on the table "banks" */
export type Banks_Mutation_Response = {
  __typename?: "banks_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Banks>;
};

/** input type for inserting object relation for remote table "banks" */
export type Banks_Obj_Rel_Insert_Input = {
  data: Banks_Insert_Input;
  on_conflict?: Maybe<Banks_On_Conflict>;
};

/** on conflict condition type for table "banks" */
export type Banks_On_Conflict = {
  constraint: Banks_Constraint;
  update_columns: Array<Banks_Update_Column>;
  where?: Maybe<Banks_Bool_Exp>;
};

/** ordering options when selecting data from "banks" */
export type Banks_Order_By = {
  address?: Maybe<Order_By>;
  bank_factsheets_aggregate?: Maybe<Bank_Factsheets_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image?: Maybe<Uploads_Order_By>;
  image_upload_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
  organisation_bank_exposure_limits_aggregate?: Maybe<Organisation_Bank_Exposure_Limits_Aggregate_Order_By>;
  organisations_aggregate?: Maybe<Organisation_Banks_Aggregate_Order_By>;
  ownership?: Maybe<Order_By>;
  regulator?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_market_cap?: Maybe<Order_By>;
  risk_outlook_fitch?: Maybe<Order_By>;
  risk_outlook_moodys?: Maybe<Order_By>;
  risk_outlook_sp?: Maybe<Order_By>;
  risk_rating_fitch_date?: Maybe<Order_By>;
  risk_rating_long_fitch?: Maybe<Order_By>;
  risk_rating_long_moodys?: Maybe<Order_By>;
  risk_rating_long_sp?: Maybe<Order_By>;
  risk_rating_moodys_date?: Maybe<Order_By>;
  risk_rating_short_fitch?: Maybe<Order_By>;
  risk_rating_short_sp?: Maybe<Order_By>;
  risk_rating_sp_date?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
  risk_total_equity?: Maybe<Order_By>;
};

/** primary key columns input for table: "banks" */
export type Banks_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "banks" */
export enum Banks_Select_Column {
  /** column name */
  Address = "address",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  ImageUploadId = "image_upload_id",
  /** column name */
  Name = "name",
  /** column name */
  Notes = "notes",
  /** column name */
  Ownership = "ownership",
  /** column name */
  Regulator = "regulator",
  /** column name */
  Risk_5yCdsSpread = "risk_5y_cds_spread",
  /** column name */
  RiskBaseCurrency = "risk_base_currency",
  /** column name */
  RiskCetCapitalRatio = "risk_cet_capital_ratio",
  /** column name */
  RiskLeverageRatio = "risk_leverage_ratio",
  /** column name */
  RiskLiquidityCoverageRatio = "risk_liquidity_coverage_ratio",
  /** column name */
  RiskMarketCap = "risk_market_cap",
  /** column name */
  RiskOutlookFitch = "risk_outlook_fitch",
  /** column name */
  RiskOutlookMoodys = "risk_outlook_moodys",
  /** column name */
  RiskOutlookSp = "risk_outlook_sp",
  /** column name */
  RiskRatingFitchDate = "risk_rating_fitch_date",
  /** column name */
  RiskRatingLongFitch = "risk_rating_long_fitch",
  /** column name */
  RiskRatingLongMoodys = "risk_rating_long_moodys",
  /** column name */
  RiskRatingLongSp = "risk_rating_long_sp",
  /** column name */
  RiskRatingMoodysDate = "risk_rating_moodys_date",
  /** column name */
  RiskRatingShortFitch = "risk_rating_short_fitch",
  /** column name */
  RiskRatingShortSp = "risk_rating_short_sp",
  /** column name */
  RiskRatingSpDate = "risk_rating_sp_date",
  /** column name */
  RiskShareMovement = "risk_share_movement",
  /** column name */
  RiskTotalEquity = "risk_total_equity",
}

/** input type for updating data in table "banks" */
export type Banks_Set_Input = {
  address?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  ownership?: Maybe<Scalars["String"]>;
  regulator?: Maybe<Scalars["String"]>;
  risk_5y_cds_spread?: Maybe<Scalars["numeric"]>;
  risk_base_currency?: Maybe<Scalars["Int"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["numeric"]>;
  risk_leverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_market_cap?: Maybe<Scalars["String"]>;
  risk_outlook_fitch?: Maybe<Scalars["String"]>;
  risk_outlook_moodys?: Maybe<Scalars["String"]>;
  risk_outlook_sp?: Maybe<Scalars["String"]>;
  risk_rating_fitch_date?: Maybe<Scalars["date"]>;
  risk_rating_long_fitch?: Maybe<Scalars["String"]>;
  risk_rating_long_moodys?: Maybe<Scalars["String"]>;
  risk_rating_long_sp?: Maybe<Scalars["String"]>;
  risk_rating_moodys_date?: Maybe<Scalars["date"]>;
  risk_rating_short_fitch?: Maybe<Scalars["String"]>;
  risk_rating_short_sp?: Maybe<Scalars["String"]>;
  risk_rating_sp_date?: Maybe<Scalars["date"]>;
  risk_share_movement?: Maybe<Scalars["numeric"]>;
  risk_total_equity?: Maybe<Scalars["String"]>;
};

/** aggregate stddev on columns */
export type Banks_Stddev_Fields = {
  __typename?: "banks_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
  risk_5y_cds_spread?: Maybe<Scalars["Float"]>;
  risk_base_currency?: Maybe<Scalars["Float"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["Float"]>;
  risk_leverage_ratio?: Maybe<Scalars["Float"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["Float"]>;
  risk_share_movement?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "banks" */
export type Banks_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Banks_Stddev_Pop_Fields = {
  __typename?: "banks_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  risk_5y_cds_spread?: Maybe<Scalars["Float"]>;
  risk_base_currency?: Maybe<Scalars["Float"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["Float"]>;
  risk_leverage_ratio?: Maybe<Scalars["Float"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["Float"]>;
  risk_share_movement?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "banks" */
export type Banks_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Banks_Stddev_Samp_Fields = {
  __typename?: "banks_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  risk_5y_cds_spread?: Maybe<Scalars["Float"]>;
  risk_base_currency?: Maybe<Scalars["Float"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["Float"]>;
  risk_leverage_ratio?: Maybe<Scalars["Float"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["Float"]>;
  risk_share_movement?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "banks" */
export type Banks_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Banks_Sum_Fields = {
  __typename?: "banks_sum_fields";
  id?: Maybe<Scalars["Int"]>;
  risk_5y_cds_spread?: Maybe<Scalars["numeric"]>;
  risk_base_currency?: Maybe<Scalars["Int"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["numeric"]>;
  risk_leverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["numeric"]>;
  risk_share_movement?: Maybe<Scalars["numeric"]>;
};

/** order by sum() on columns of table "banks" */
export type Banks_Sum_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** update columns of table "banks" */
export enum Banks_Update_Column {
  /** column name */
  Address = "address",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  ImageUploadId = "image_upload_id",
  /** column name */
  Name = "name",
  /** column name */
  Notes = "notes",
  /** column name */
  Ownership = "ownership",
  /** column name */
  Regulator = "regulator",
  /** column name */
  Risk_5yCdsSpread = "risk_5y_cds_spread",
  /** column name */
  RiskBaseCurrency = "risk_base_currency",
  /** column name */
  RiskCetCapitalRatio = "risk_cet_capital_ratio",
  /** column name */
  RiskLeverageRatio = "risk_leverage_ratio",
  /** column name */
  RiskLiquidityCoverageRatio = "risk_liquidity_coverage_ratio",
  /** column name */
  RiskMarketCap = "risk_market_cap",
  /** column name */
  RiskOutlookFitch = "risk_outlook_fitch",
  /** column name */
  RiskOutlookMoodys = "risk_outlook_moodys",
  /** column name */
  RiskOutlookSp = "risk_outlook_sp",
  /** column name */
  RiskRatingFitchDate = "risk_rating_fitch_date",
  /** column name */
  RiskRatingLongFitch = "risk_rating_long_fitch",
  /** column name */
  RiskRatingLongMoodys = "risk_rating_long_moodys",
  /** column name */
  RiskRatingLongSp = "risk_rating_long_sp",
  /** column name */
  RiskRatingMoodysDate = "risk_rating_moodys_date",
  /** column name */
  RiskRatingShortFitch = "risk_rating_short_fitch",
  /** column name */
  RiskRatingShortSp = "risk_rating_short_sp",
  /** column name */
  RiskRatingSpDate = "risk_rating_sp_date",
  /** column name */
  RiskShareMovement = "risk_share_movement",
  /** column name */
  RiskTotalEquity = "risk_total_equity",
}

/** aggregate var_pop on columns */
export type Banks_Var_Pop_Fields = {
  __typename?: "banks_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  risk_5y_cds_spread?: Maybe<Scalars["Float"]>;
  risk_base_currency?: Maybe<Scalars["Float"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["Float"]>;
  risk_leverage_ratio?: Maybe<Scalars["Float"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["Float"]>;
  risk_share_movement?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "banks" */
export type Banks_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Banks_Var_Samp_Fields = {
  __typename?: "banks_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  risk_5y_cds_spread?: Maybe<Scalars["Float"]>;
  risk_base_currency?: Maybe<Scalars["Float"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["Float"]>;
  risk_leverage_ratio?: Maybe<Scalars["Float"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["Float"]>;
  risk_share_movement?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "banks" */
export type Banks_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Banks_Variance_Fields = {
  __typename?: "banks_variance_fields";
  id?: Maybe<Scalars["Float"]>;
  risk_5y_cds_spread?: Maybe<Scalars["Float"]>;
  risk_base_currency?: Maybe<Scalars["Float"]>;
  risk_cet_capital_ratio?: Maybe<Scalars["Float"]>;
  risk_leverage_ratio?: Maybe<Scalars["Float"]>;
  risk_liquidity_coverage_ratio?: Maybe<Scalars["Float"]>;
  risk_share_movement?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "banks" */
export type Banks_Variance_Order_By = {
  id?: Maybe<Order_By>;
  risk_5y_cds_spread?: Maybe<Order_By>;
  risk_base_currency?: Maybe<Order_By>;
  risk_cet_capital_ratio?: Maybe<Order_By>;
  risk_leverage_ratio?: Maybe<Order_By>;
  risk_liquidity_coverage_ratio?: Maybe<Order_By>;
  risk_share_movement?: Maybe<Order_By>;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars["Boolean"]>;
  _gt?: Maybe<Scalars["Boolean"]>;
  _gte?: Maybe<Scalars["Boolean"]>;
  _in?: Maybe<Array<Scalars["Boolean"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _lt?: Maybe<Scalars["Boolean"]>;
  _lte?: Maybe<Scalars["Boolean"]>;
  _neq?: Maybe<Scalars["Boolean"]>;
  _nin?: Maybe<Array<Scalars["Boolean"]>>;
};

/** columns and relationships of "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits = {
  __typename?: "business_unit_bank_exposure_limits";
  /** An object relationship */
  bank: Banks;
  bank_id: Scalars["Int"];
  /** An object relationship */
  business_unit: Business_Units;
  business_unit_id: Scalars["Int"];
  created_at: Scalars["timestamptz"];
  exposure_limit: Scalars["float8"];
  id: Scalars["Int"];
};

/** aggregated selection of "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Aggregate = {
  __typename?: "business_unit_bank_exposure_limits_aggregate";
  aggregate?: Maybe<Business_Unit_Bank_Exposure_Limits_Aggregate_Fields>;
  nodes: Array<Business_Unit_Bank_Exposure_Limits>;
};

/** aggregate fields of "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Aggregate_Fields = {
  __typename?: "business_unit_bank_exposure_limits_aggregate_fields";
  avg?: Maybe<Business_Unit_Bank_Exposure_Limits_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Business_Unit_Bank_Exposure_Limits_Max_Fields>;
  min?: Maybe<Business_Unit_Bank_Exposure_Limits_Min_Fields>;
  stddev?: Maybe<Business_Unit_Bank_Exposure_Limits_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Unit_Bank_Exposure_Limits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Unit_Bank_Exposure_Limits_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Unit_Bank_Exposure_Limits_Sum_Fields>;
  var_pop?: Maybe<Business_Unit_Bank_Exposure_Limits_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Unit_Bank_Exposure_Limits_Var_Samp_Fields>;
  variance?: Maybe<Business_Unit_Bank_Exposure_Limits_Variance_Fields>;
};

/** aggregate fields of "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Aggregate_Order_By = {
  avg?: Maybe<Business_Unit_Bank_Exposure_Limits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Business_Unit_Bank_Exposure_Limits_Max_Order_By>;
  min?: Maybe<Business_Unit_Bank_Exposure_Limits_Min_Order_By>;
  stddev?: Maybe<Business_Unit_Bank_Exposure_Limits_Stddev_Order_By>;
  stddev_pop?: Maybe<Business_Unit_Bank_Exposure_Limits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Business_Unit_Bank_Exposure_Limits_Stddev_Samp_Order_By>;
  sum?: Maybe<Business_Unit_Bank_Exposure_Limits_Sum_Order_By>;
  var_pop?: Maybe<Business_Unit_Bank_Exposure_Limits_Var_Pop_Order_By>;
  var_samp?: Maybe<Business_Unit_Bank_Exposure_Limits_Var_Samp_Order_By>;
  variance?: Maybe<Business_Unit_Bank_Exposure_Limits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Arr_Rel_Insert_Input = {
  data: Array<Business_Unit_Bank_Exposure_Limits_Insert_Input>;
  on_conflict?: Maybe<Business_Unit_Bank_Exposure_Limits_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Unit_Bank_Exposure_Limits_Avg_Fields = {
  __typename?: "business_unit_bank_exposure_limits_avg_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  business_unit_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Avg_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/**
 * Boolean expression to filter rows from the table
 * "business_unit_bank_exposure_limits". All fields are combined with a logical 'AND'.
 */
export type Business_Unit_Bank_Exposure_Limits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>>>;
  _not?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>>>;
  bank?: Maybe<Banks_Bool_Exp>;
  bank_id?: Maybe<Int_Comparison_Exp>;
  business_unit?: Maybe<Business_Units_Bool_Exp>;
  business_unit_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  exposure_limit?: Maybe<Float8_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_unit_bank_exposure_limits" */
export enum Business_Unit_Bank_Exposure_Limits_Constraint {
  /** unique or primary key constraint */
  BusinessUnitBankExposureLimitsPkey = "BusinessUnitBankExposureLimits_pkey",
  /** unique or primary key constraint */
  BusinessUnitBankExposureLimitsBusinessUnitIdBankIdKey = "business_unit_bank_exposure_limits_business_unit_id_bank_id_key",
}

/** input type for incrementing integer column in table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Inc_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Insert_Input = {
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bank_id?: Maybe<Scalars["Int"]>;
  business_unit?: Maybe<Business_Units_Obj_Rel_Insert_Input>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type Business_Unit_Bank_Exposure_Limits_Max_Fields = {
  __typename?: "business_unit_bank_exposure_limits_max_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Max_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Unit_Bank_Exposure_Limits_Min_Fields = {
  __typename?: "business_unit_bank_exposure_limits_min_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Min_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Mutation_Response = {
  __typename?: "business_unit_bank_exposure_limits_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Business_Unit_Bank_Exposure_Limits>;
};

/** input type for inserting object relation for remote table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Obj_Rel_Insert_Input = {
  data: Business_Unit_Bank_Exposure_Limits_Insert_Input;
  on_conflict?: Maybe<Business_Unit_Bank_Exposure_Limits_On_Conflict>;
};

/** on conflict condition type for table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_On_Conflict = {
  constraint: Business_Unit_Bank_Exposure_Limits_Constraint;
  update_columns: Array<Business_Unit_Bank_Exposure_Limits_Update_Column>;
  where?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
};

/** ordering options when selecting data from "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Order_By = {
  bank?: Maybe<Banks_Order_By>;
  bank_id?: Maybe<Order_By>;
  business_unit?: Maybe<Business_Units_Order_By>;
  business_unit_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "business_unit_bank_exposure_limits" */
export enum Business_Unit_Bank_Exposure_Limits_Select_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  BusinessUnitId = "business_unit_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExposureLimit = "exposure_limit",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Set_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type Business_Unit_Bank_Exposure_Limits_Stddev_Fields = {
  __typename?: "business_unit_bank_exposure_limits_stddev_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  business_unit_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Stddev_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Unit_Bank_Exposure_Limits_Stddev_Pop_Fields = {
  __typename?: "business_unit_bank_exposure_limits_stddev_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  business_unit_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Stddev_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Unit_Bank_Exposure_Limits_Stddev_Samp_Fields = {
  __typename?: "business_unit_bank_exposure_limits_stddev_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  business_unit_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Stddev_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Business_Unit_Bank_Exposure_Limits_Sum_Fields = {
  __typename?: "business_unit_bank_exposure_limits_sum_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Sum_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "business_unit_bank_exposure_limits" */
export enum Business_Unit_Bank_Exposure_Limits_Update_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  BusinessUnitId = "business_unit_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExposureLimit = "exposure_limit",
  /** column name */
  Id = "id",
}

/** aggregate var_pop on columns */
export type Business_Unit_Bank_Exposure_Limits_Var_Pop_Fields = {
  __typename?: "business_unit_bank_exposure_limits_var_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  business_unit_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Var_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Unit_Bank_Exposure_Limits_Var_Samp_Fields = {
  __typename?: "business_unit_bank_exposure_limits_var_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  business_unit_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Var_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Unit_Bank_Exposure_Limits_Variance_Fields = {
  __typename?: "business_unit_bank_exposure_limits_variance_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  business_unit_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "business_unit_bank_exposure_limits" */
export type Business_Unit_Bank_Exposure_Limits_Variance_Order_By = {
  bank_id?: Maybe<Order_By>;
  business_unit_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits = {
  __typename?: "business_unit_liquidity_limits";
  /** An object relationship */
  business_unit: Business_Units;
  business_unit_id: Scalars["Int"];
  id: Scalars["Int"];
  lower_limit_pct: Scalars["numeric"];
  notice_days_gte: Scalars["numeric"];
  notice_days_lt: Scalars["numeric"];
  upper_limit_pct: Scalars["numeric"];
};

/** aggregated selection of "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Aggregate = {
  __typename?: "business_unit_liquidity_limits_aggregate";
  aggregate?: Maybe<Business_Unit_Liquidity_Limits_Aggregate_Fields>;
  nodes: Array<Business_Unit_Liquidity_Limits>;
};

/** aggregate fields of "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Aggregate_Fields = {
  __typename?: "business_unit_liquidity_limits_aggregate_fields";
  avg?: Maybe<Business_Unit_Liquidity_Limits_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Business_Unit_Liquidity_Limits_Max_Fields>;
  min?: Maybe<Business_Unit_Liquidity_Limits_Min_Fields>;
  stddev?: Maybe<Business_Unit_Liquidity_Limits_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Unit_Liquidity_Limits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Unit_Liquidity_Limits_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Unit_Liquidity_Limits_Sum_Fields>;
  var_pop?: Maybe<Business_Unit_Liquidity_Limits_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Unit_Liquidity_Limits_Var_Samp_Fields>;
  variance?: Maybe<Business_Unit_Liquidity_Limits_Variance_Fields>;
};

/** aggregate fields of "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Business_Unit_Liquidity_Limits_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Aggregate_Order_By = {
  avg?: Maybe<Business_Unit_Liquidity_Limits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Business_Unit_Liquidity_Limits_Max_Order_By>;
  min?: Maybe<Business_Unit_Liquidity_Limits_Min_Order_By>;
  stddev?: Maybe<Business_Unit_Liquidity_Limits_Stddev_Order_By>;
  stddev_pop?: Maybe<Business_Unit_Liquidity_Limits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Business_Unit_Liquidity_Limits_Stddev_Samp_Order_By>;
  sum?: Maybe<Business_Unit_Liquidity_Limits_Sum_Order_By>;
  var_pop?: Maybe<Business_Unit_Liquidity_Limits_Var_Pop_Order_By>;
  var_samp?: Maybe<Business_Unit_Liquidity_Limits_Var_Samp_Order_By>;
  variance?: Maybe<Business_Unit_Liquidity_Limits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Arr_Rel_Insert_Input = {
  data: Array<Business_Unit_Liquidity_Limits_Insert_Input>;
  on_conflict?: Maybe<Business_Unit_Liquidity_Limits_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Unit_Liquidity_Limits_Avg_Fields = {
  __typename?: "business_unit_liquidity_limits_avg_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Avg_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/**
 * Boolean expression to filter rows from the table
 * "business_unit_liquidity_limits". All fields are combined with a logical 'AND'.
 */
export type Business_Unit_Liquidity_Limits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>>>;
  _not?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>>>;
  business_unit?: Maybe<Business_Units_Bool_Exp>;
  business_unit_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  lower_limit_pct?: Maybe<Numeric_Comparison_Exp>;
  notice_days_gte?: Maybe<Numeric_Comparison_Exp>;
  notice_days_lt?: Maybe<Numeric_Comparison_Exp>;
  upper_limit_pct?: Maybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_unit_liquidity_limits" */
export enum Business_Unit_Liquidity_Limits_Constraint {
  /** unique or primary key constraint */
  BusinessUnitLiquidityLimitsPkey = "BusinessUnitLiquidityLimits_pkey",
  /** unique or primary key constraint */
  BusinessUnitLiquidityLimitsBusinessUnitIdNoticeDaysLt = "business_unit_liquidity_limits_business_unit_id_notice_days_lt_",
}

/** input type for incrementing integer column in table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Inc_Input = {
  business_unit_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Insert_Input = {
  business_unit?: Maybe<Business_Units_Obj_Rel_Insert_Input>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** aggregate max on columns */
export type Business_Unit_Liquidity_Limits_Max_Fields = {
  __typename?: "business_unit_liquidity_limits_max_fields";
  business_unit_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by max() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Max_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Unit_Liquidity_Limits_Min_Fields = {
  __typename?: "business_unit_liquidity_limits_min_fields";
  business_unit_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by min() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Min_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** response of any mutation on the table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Mutation_Response = {
  __typename?: "business_unit_liquidity_limits_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Business_Unit_Liquidity_Limits>;
};

/** input type for inserting object relation for remote table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Obj_Rel_Insert_Input = {
  data: Business_Unit_Liquidity_Limits_Insert_Input;
  on_conflict?: Maybe<Business_Unit_Liquidity_Limits_On_Conflict>;
};

/** on conflict condition type for table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_On_Conflict = {
  constraint: Business_Unit_Liquidity_Limits_Constraint;
  update_columns: Array<Business_Unit_Liquidity_Limits_Update_Column>;
  where?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
};

/** ordering options when selecting data from "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Order_By = {
  business_unit?: Maybe<Business_Units_Order_By>;
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** primary key columns input for table: "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "business_unit_liquidity_limits" */
export enum Business_Unit_Liquidity_Limits_Select_Column {
  /** column name */
  BusinessUnitId = "business_unit_id",
  /** column name */
  Id = "id",
  /** column name */
  LowerLimitPct = "lower_limit_pct",
  /** column name */
  NoticeDaysGte = "notice_days_gte",
  /** column name */
  NoticeDaysLt = "notice_days_lt",
  /** column name */
  UpperLimitPct = "upper_limit_pct",
}

/** input type for updating data in table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Set_Input = {
  business_unit_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** aggregate stddev on columns */
export type Business_Unit_Liquidity_Limits_Stddev_Fields = {
  __typename?: "business_unit_liquidity_limits_stddev_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Stddev_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Unit_Liquidity_Limits_Stddev_Pop_Fields = {
  __typename?: "business_unit_liquidity_limits_stddev_pop_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Stddev_Pop_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Unit_Liquidity_Limits_Stddev_Samp_Fields = {
  __typename?: "business_unit_liquidity_limits_stddev_samp_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Stddev_Samp_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Business_Unit_Liquidity_Limits_Sum_Fields = {
  __typename?: "business_unit_liquidity_limits_sum_fields";
  business_unit_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by sum() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Sum_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** update columns of table "business_unit_liquidity_limits" */
export enum Business_Unit_Liquidity_Limits_Update_Column {
  /** column name */
  BusinessUnitId = "business_unit_id",
  /** column name */
  Id = "id",
  /** column name */
  LowerLimitPct = "lower_limit_pct",
  /** column name */
  NoticeDaysGte = "notice_days_gte",
  /** column name */
  NoticeDaysLt = "notice_days_lt",
  /** column name */
  UpperLimitPct = "upper_limit_pct",
}

/** aggregate var_pop on columns */
export type Business_Unit_Liquidity_Limits_Var_Pop_Fields = {
  __typename?: "business_unit_liquidity_limits_var_pop_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Var_Pop_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Unit_Liquidity_Limits_Var_Samp_Fields = {
  __typename?: "business_unit_liquidity_limits_var_samp_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Var_Samp_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Unit_Liquidity_Limits_Variance_Fields = {
  __typename?: "business_unit_liquidity_limits_variance_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "business_unit_liquidity_limits" */
export type Business_Unit_Liquidity_Limits_Variance_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** columns and relationships of "business_units" */
export type Business_Units = {
  __typename?: "business_units";
  /** An array relationship */
  business_unit_bank_exposure_limits: Array<Business_Unit_Bank_Exposure_Limits>;
  /** An aggregated array relationship */
  business_unit_bank_exposure_limits_aggregate: Business_Unit_Bank_Exposure_Limits_Aggregate;
  /** An array relationship */
  business_unit_liquidity_limits: Array<Business_Unit_Liquidity_Limits>;
  /** An aggregated array relationship */
  business_unit_liquidity_limits_aggregate: Business_Unit_Liquidity_Limits_Aggregate;
  created_at: Scalars["timestamptz"];
  /** An array relationship */
  currency_books: Array<Currency_Books>;
  /** An aggregated array relationship */
  currency_books_aggregate: Currency_Books_Aggregate;
  id: Scalars["Int"];
  is_archived: Scalars["Boolean"];
  name: Scalars["String"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
};

/** columns and relationships of "business_units" */
export type Business_UnitsBusiness_Unit_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "business_units" */
export type Business_UnitsBusiness_Unit_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "business_units" */
export type Business_UnitsBusiness_Unit_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Liquidity_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
};

/** columns and relationships of "business_units" */
export type Business_UnitsBusiness_Unit_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Liquidity_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
};

/** columns and relationships of "business_units" */
export type Business_UnitsCurrency_BooksArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** columns and relationships of "business_units" */
export type Business_UnitsCurrency_Books_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** aggregated selection of "business_units" */
export type Business_Units_Aggregate = {
  __typename?: "business_units_aggregate";
  aggregate?: Maybe<Business_Units_Aggregate_Fields>;
  nodes: Array<Business_Units>;
};

/** aggregate fields of "business_units" */
export type Business_Units_Aggregate_Fields = {
  __typename?: "business_units_aggregate_fields";
  avg?: Maybe<Business_Units_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Business_Units_Max_Fields>;
  min?: Maybe<Business_Units_Min_Fields>;
  stddev?: Maybe<Business_Units_Stddev_Fields>;
  stddev_pop?: Maybe<Business_Units_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Business_Units_Stddev_Samp_Fields>;
  sum?: Maybe<Business_Units_Sum_Fields>;
  var_pop?: Maybe<Business_Units_Var_Pop_Fields>;
  var_samp?: Maybe<Business_Units_Var_Samp_Fields>;
  variance?: Maybe<Business_Units_Variance_Fields>;
};

/** aggregate fields of "business_units" */
export type Business_Units_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Business_Units_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "business_units" */
export type Business_Units_Aggregate_Order_By = {
  avg?: Maybe<Business_Units_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Business_Units_Max_Order_By>;
  min?: Maybe<Business_Units_Min_Order_By>;
  stddev?: Maybe<Business_Units_Stddev_Order_By>;
  stddev_pop?: Maybe<Business_Units_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Business_Units_Stddev_Samp_Order_By>;
  sum?: Maybe<Business_Units_Sum_Order_By>;
  var_pop?: Maybe<Business_Units_Var_Pop_Order_By>;
  var_samp?: Maybe<Business_Units_Var_Samp_Order_By>;
  variance?: Maybe<Business_Units_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "business_units" */
export type Business_Units_Arr_Rel_Insert_Input = {
  data: Array<Business_Units_Insert_Input>;
  on_conflict?: Maybe<Business_Units_On_Conflict>;
};

/** aggregate avg on columns */
export type Business_Units_Avg_Fields = {
  __typename?: "business_units_avg_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "business_units" */
export type Business_Units_Avg_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "business_units". All fields are combined with a logical 'AND'. */
export type Business_Units_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Business_Units_Bool_Exp>>>;
  _not?: Maybe<Business_Units_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Business_Units_Bool_Exp>>>;
  business_unit_bank_exposure_limits?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
  business_unit_liquidity_limits?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency_books?: Maybe<Currency_Books_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_archived?: Maybe<Boolean_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "business_units" */
export enum Business_Units_Constraint {
  /** unique or primary key constraint */
  BusinessUnitPkey = "BusinessUnit_pkey",
}

/** input type for incrementing integer column in table "business_units" */
export type Business_Units_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "business_units" */
export type Business_Units_Insert_Input = {
  business_unit_bank_exposure_limits?: Maybe<Business_Unit_Bank_Exposure_Limits_Arr_Rel_Insert_Input>;
  business_unit_liquidity_limits?: Maybe<Business_Unit_Liquidity_Limits_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_books?: Maybe<Currency_Books_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars["Int"]>;
  is_archived?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type Business_Units_Max_Fields = {
  __typename?: "business_units_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "business_units" */
export type Business_Units_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Business_Units_Min_Fields = {
  __typename?: "business_units_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "business_units" */
export type Business_Units_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "business_units" */
export type Business_Units_Mutation_Response = {
  __typename?: "business_units_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Business_Units>;
};

/** input type for inserting object relation for remote table "business_units" */
export type Business_Units_Obj_Rel_Insert_Input = {
  data: Business_Units_Insert_Input;
  on_conflict?: Maybe<Business_Units_On_Conflict>;
};

/** on conflict condition type for table "business_units" */
export type Business_Units_On_Conflict = {
  constraint: Business_Units_Constraint;
  update_columns: Array<Business_Units_Update_Column>;
  where?: Maybe<Business_Units_Bool_Exp>;
};

/** ordering options when selecting data from "business_units" */
export type Business_Units_Order_By = {
  business_unit_bank_exposure_limits_aggregate?: Maybe<Business_Unit_Bank_Exposure_Limits_Aggregate_Order_By>;
  business_unit_liquidity_limits_aggregate?: Maybe<Business_Unit_Liquidity_Limits_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  currency_books_aggregate?: Maybe<Currency_Books_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  is_archived?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "business_units" */
export type Business_Units_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "business_units" */
export enum Business_Units_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  IsArchived = "is_archived",
  /** column name */
  Name = "name",
  /** column name */
  OrganisationId = "organisation_id",
}

/** input type for updating data in table "business_units" */
export type Business_Units_Set_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  is_archived?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type Business_Units_Stddev_Fields = {
  __typename?: "business_units_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "business_units" */
export type Business_Units_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Business_Units_Stddev_Pop_Fields = {
  __typename?: "business_units_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "business_units" */
export type Business_Units_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Business_Units_Stddev_Samp_Fields = {
  __typename?: "business_units_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "business_units" */
export type Business_Units_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Business_Units_Sum_Fields = {
  __typename?: "business_units_sum_fields";
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "business_units" */
export type Business_Units_Sum_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** update columns of table "business_units" */
export enum Business_Units_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  IsArchived = "is_archived",
  /** column name */
  Name = "name",
  /** column name */
  OrganisationId = "organisation_id",
}

/** aggregate var_pop on columns */
export type Business_Units_Var_Pop_Fields = {
  __typename?: "business_units_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "business_units" */
export type Business_Units_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Business_Units_Var_Samp_Fields = {
  __typename?: "business_units_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "business_units" */
export type Business_Units_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Business_Units_Variance_Fields = {
  __typename?: "business_units_variance_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "business_units" */
export type Business_Units_Variance_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** columns and relationships of "currencies" */
export type Currencies = {
  __typename?: "currencies";
  created_at: Scalars["timestamptz"];
  /** An array relationship */
  currency_books: Array<Currency_Books>;
  /** An aggregated array relationship */
  currency_books_aggregate: Currency_Books_Aggregate;
  id: Scalars["Int"];
  name: Scalars["String"];
  prefix?: Maybe<Scalars["String"]>;
  separator: Scalars["String"];
  suffix?: Maybe<Scalars["String"]>;
  symbol?: Maybe<Scalars["String"]>;
};

/** columns and relationships of "currencies" */
export type CurrenciesCurrency_BooksArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** columns and relationships of "currencies" */
export type CurrenciesCurrency_Books_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** aggregated selection of "currencies" */
export type Currencies_Aggregate = {
  __typename?: "currencies_aggregate";
  aggregate?: Maybe<Currencies_Aggregate_Fields>;
  nodes: Array<Currencies>;
};

/** aggregate fields of "currencies" */
export type Currencies_Aggregate_Fields = {
  __typename?: "currencies_aggregate_fields";
  avg?: Maybe<Currencies_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Currencies_Max_Fields>;
  min?: Maybe<Currencies_Min_Fields>;
  stddev?: Maybe<Currencies_Stddev_Fields>;
  stddev_pop?: Maybe<Currencies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Currencies_Stddev_Samp_Fields>;
  sum?: Maybe<Currencies_Sum_Fields>;
  var_pop?: Maybe<Currencies_Var_Pop_Fields>;
  var_samp?: Maybe<Currencies_Var_Samp_Fields>;
  variance?: Maybe<Currencies_Variance_Fields>;
};

/** aggregate fields of "currencies" */
export type Currencies_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Currencies_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "currencies" */
export type Currencies_Aggregate_Order_By = {
  avg?: Maybe<Currencies_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Currencies_Max_Order_By>;
  min?: Maybe<Currencies_Min_Order_By>;
  stddev?: Maybe<Currencies_Stddev_Order_By>;
  stddev_pop?: Maybe<Currencies_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Currencies_Stddev_Samp_Order_By>;
  sum?: Maybe<Currencies_Sum_Order_By>;
  var_pop?: Maybe<Currencies_Var_Pop_Order_By>;
  var_samp?: Maybe<Currencies_Var_Samp_Order_By>;
  variance?: Maybe<Currencies_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "currencies" */
export type Currencies_Arr_Rel_Insert_Input = {
  data: Array<Currencies_Insert_Input>;
  on_conflict?: Maybe<Currencies_On_Conflict>;
};

/** aggregate avg on columns */
export type Currencies_Avg_Fields = {
  __typename?: "currencies_avg_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "currencies" */
export type Currencies_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "currencies". All fields are combined with a logical 'AND'. */
export type Currencies_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Currencies_Bool_Exp>>>;
  _not?: Maybe<Currencies_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Currencies_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency_books?: Maybe<Currency_Books_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  prefix?: Maybe<String_Comparison_Exp>;
  separator?: Maybe<String_Comparison_Exp>;
  suffix?: Maybe<String_Comparison_Exp>;
  symbol?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "currencies" */
export enum Currencies_Constraint {
  /** unique or primary key constraint */
  CurrencyPkey = "Currency_pkey",
}

/** input type for incrementing integer column in table "currencies" */
export type Currencies_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "currencies" */
export type Currencies_Insert_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_books?: Maybe<Currency_Books_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  prefix?: Maybe<Scalars["String"]>;
  separator?: Maybe<Scalars["String"]>;
  suffix?: Maybe<Scalars["String"]>;
  symbol?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Currencies_Max_Fields = {
  __typename?: "currencies_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  prefix?: Maybe<Scalars["String"]>;
  separator?: Maybe<Scalars["String"]>;
  suffix?: Maybe<Scalars["String"]>;
  symbol?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "currencies" */
export type Currencies_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  prefix?: Maybe<Order_By>;
  separator?: Maybe<Order_By>;
  suffix?: Maybe<Order_By>;
  symbol?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Currencies_Min_Fields = {
  __typename?: "currencies_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  prefix?: Maybe<Scalars["String"]>;
  separator?: Maybe<Scalars["String"]>;
  suffix?: Maybe<Scalars["String"]>;
  symbol?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "currencies" */
export type Currencies_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  prefix?: Maybe<Order_By>;
  separator?: Maybe<Order_By>;
  suffix?: Maybe<Order_By>;
  symbol?: Maybe<Order_By>;
};

/** response of any mutation on the table "currencies" */
export type Currencies_Mutation_Response = {
  __typename?: "currencies_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Currencies>;
};

/** input type for inserting object relation for remote table "currencies" */
export type Currencies_Obj_Rel_Insert_Input = {
  data: Currencies_Insert_Input;
  on_conflict?: Maybe<Currencies_On_Conflict>;
};

/** on conflict condition type for table "currencies" */
export type Currencies_On_Conflict = {
  constraint: Currencies_Constraint;
  update_columns: Array<Currencies_Update_Column>;
  where?: Maybe<Currencies_Bool_Exp>;
};

/** ordering options when selecting data from "currencies" */
export type Currencies_Order_By = {
  created_at?: Maybe<Order_By>;
  currency_books_aggregate?: Maybe<Currency_Books_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  prefix?: Maybe<Order_By>;
  separator?: Maybe<Order_By>;
  suffix?: Maybe<Order_By>;
  symbol?: Maybe<Order_By>;
};

/** primary key columns input for table: "currencies" */
export type Currencies_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "currencies" */
export enum Currencies_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Prefix = "prefix",
  /** column name */
  Separator = "separator",
  /** column name */
  Suffix = "suffix",
  /** column name */
  Symbol = "symbol",
}

/** input type for updating data in table "currencies" */
export type Currencies_Set_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  prefix?: Maybe<Scalars["String"]>;
  separator?: Maybe<Scalars["String"]>;
  suffix?: Maybe<Scalars["String"]>;
  symbol?: Maybe<Scalars["String"]>;
};

/** aggregate stddev on columns */
export type Currencies_Stddev_Fields = {
  __typename?: "currencies_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "currencies" */
export type Currencies_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Currencies_Stddev_Pop_Fields = {
  __typename?: "currencies_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "currencies" */
export type Currencies_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Currencies_Stddev_Samp_Fields = {
  __typename?: "currencies_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "currencies" */
export type Currencies_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Currencies_Sum_Fields = {
  __typename?: "currencies_sum_fields";
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "currencies" */
export type Currencies_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "currencies" */
export enum Currencies_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  Name = "name",
  /** column name */
  Prefix = "prefix",
  /** column name */
  Separator = "separator",
  /** column name */
  Suffix = "suffix",
  /** column name */
  Symbol = "symbol",
}

/** aggregate var_pop on columns */
export type Currencies_Var_Pop_Fields = {
  __typename?: "currencies_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "currencies" */
export type Currencies_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Currencies_Var_Samp_Fields = {
  __typename?: "currencies_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "currencies" */
export type Currencies_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Currencies_Variance_Fields = {
  __typename?: "currencies_variance_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "currencies" */
export type Currencies_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits = {
  __typename?: "currency_book_bank_exposure_limits";
  /** An object relationship */
  bank: Banks;
  bank_id: Scalars["Int"];
  created_at: Scalars["timestamptz"];
  /** An object relationship */
  currency_book: Currency_Books;
  currency_book_id: Scalars["Int"];
  exposure_limit: Scalars["float8"];
  id: Scalars["Int"];
};

/** aggregated selection of "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Aggregate = {
  __typename?: "currency_book_bank_exposure_limits_aggregate";
  aggregate?: Maybe<Currency_Book_Bank_Exposure_Limits_Aggregate_Fields>;
  nodes: Array<Currency_Book_Bank_Exposure_Limits>;
};

/** aggregate fields of "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Aggregate_Fields = {
  __typename?: "currency_book_bank_exposure_limits_aggregate_fields";
  avg?: Maybe<Currency_Book_Bank_Exposure_Limits_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Currency_Book_Bank_Exposure_Limits_Max_Fields>;
  min?: Maybe<Currency_Book_Bank_Exposure_Limits_Min_Fields>;
  stddev?: Maybe<Currency_Book_Bank_Exposure_Limits_Stddev_Fields>;
  stddev_pop?: Maybe<Currency_Book_Bank_Exposure_Limits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Currency_Book_Bank_Exposure_Limits_Stddev_Samp_Fields>;
  sum?: Maybe<Currency_Book_Bank_Exposure_Limits_Sum_Fields>;
  var_pop?: Maybe<Currency_Book_Bank_Exposure_Limits_Var_Pop_Fields>;
  var_samp?: Maybe<Currency_Book_Bank_Exposure_Limits_Var_Samp_Fields>;
  variance?: Maybe<Currency_Book_Bank_Exposure_Limits_Variance_Fields>;
};

/** aggregate fields of "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Aggregate_Order_By = {
  avg?: Maybe<Currency_Book_Bank_Exposure_Limits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Currency_Book_Bank_Exposure_Limits_Max_Order_By>;
  min?: Maybe<Currency_Book_Bank_Exposure_Limits_Min_Order_By>;
  stddev?: Maybe<Currency_Book_Bank_Exposure_Limits_Stddev_Order_By>;
  stddev_pop?: Maybe<Currency_Book_Bank_Exposure_Limits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Currency_Book_Bank_Exposure_Limits_Stddev_Samp_Order_By>;
  sum?: Maybe<Currency_Book_Bank_Exposure_Limits_Sum_Order_By>;
  var_pop?: Maybe<Currency_Book_Bank_Exposure_Limits_Var_Pop_Order_By>;
  var_samp?: Maybe<Currency_Book_Bank_Exposure_Limits_Var_Samp_Order_By>;
  variance?: Maybe<Currency_Book_Bank_Exposure_Limits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Arr_Rel_Insert_Input = {
  data: Array<Currency_Book_Bank_Exposure_Limits_Insert_Input>;
  on_conflict?: Maybe<Currency_Book_Bank_Exposure_Limits_On_Conflict>;
};

/** aggregate avg on columns */
export type Currency_Book_Bank_Exposure_Limits_Avg_Fields = {
  __typename?: "currency_book_bank_exposure_limits_avg_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Avg_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/**
 * Boolean expression to filter rows from the table
 * "currency_book_bank_exposure_limits". All fields are combined with a logical 'AND'.
 */
export type Currency_Book_Bank_Exposure_Limits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>>>;
  _not?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>>>;
  bank?: Maybe<Banks_Bool_Exp>;
  bank_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency_book?: Maybe<Currency_Books_Bool_Exp>;
  currency_book_id?: Maybe<Int_Comparison_Exp>;
  exposure_limit?: Maybe<Float8_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "currency_book_bank_exposure_limits" */
export enum Currency_Book_Bank_Exposure_Limits_Constraint {
  /** unique or primary key constraint */
  CurrencyBookBankExposureLimitsPkey = "CurrencyBookBankExposureLimits_pkey",
  /** unique or primary key constraint */
  CurrencyBookBankExposureLimitsCurrencyBookIdBankIdKey = "currency_book_bank_exposure_limits_currency_book_id_bank_id_key",
}

/** input type for incrementing integer column in table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Inc_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Insert_Input = {
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book?: Maybe<Currency_Books_Obj_Rel_Insert_Input>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type Currency_Book_Bank_Exposure_Limits_Max_Fields = {
  __typename?: "currency_book_bank_exposure_limits_max_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Max_Order_By = {
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Currency_Book_Bank_Exposure_Limits_Min_Fields = {
  __typename?: "currency_book_bank_exposure_limits_min_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Min_Order_By = {
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Mutation_Response = {
  __typename?: "currency_book_bank_exposure_limits_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Currency_Book_Bank_Exposure_Limits>;
};

/** input type for inserting object relation for remote table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Obj_Rel_Insert_Input = {
  data: Currency_Book_Bank_Exposure_Limits_Insert_Input;
  on_conflict?: Maybe<Currency_Book_Bank_Exposure_Limits_On_Conflict>;
};

/** on conflict condition type for table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_On_Conflict = {
  constraint: Currency_Book_Bank_Exposure_Limits_Constraint;
  update_columns: Array<Currency_Book_Bank_Exposure_Limits_Update_Column>;
  where?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
};

/** ordering options when selecting data from "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Order_By = {
  bank?: Maybe<Banks_Order_By>;
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency_book?: Maybe<Currency_Books_Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "currency_book_bank_exposure_limits" */
export enum Currency_Book_Bank_Exposure_Limits_Select_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  ExposureLimit = "exposure_limit",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Set_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type Currency_Book_Bank_Exposure_Limits_Stddev_Fields = {
  __typename?: "currency_book_bank_exposure_limits_stddev_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Stddev_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Currency_Book_Bank_Exposure_Limits_Stddev_Pop_Fields = {
  __typename?: "currency_book_bank_exposure_limits_stddev_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Stddev_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Currency_Book_Bank_Exposure_Limits_Stddev_Samp_Fields = {
  __typename?: "currency_book_bank_exposure_limits_stddev_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Stddev_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Currency_Book_Bank_Exposure_Limits_Sum_Fields = {
  __typename?: "currency_book_bank_exposure_limits_sum_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["float8"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Sum_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "currency_book_bank_exposure_limits" */
export enum Currency_Book_Bank_Exposure_Limits_Update_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  ExposureLimit = "exposure_limit",
  /** column name */
  Id = "id",
}

/** aggregate var_pop on columns */
export type Currency_Book_Bank_Exposure_Limits_Var_Pop_Fields = {
  __typename?: "currency_book_bank_exposure_limits_var_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Var_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Currency_Book_Bank_Exposure_Limits_Var_Samp_Fields = {
  __typename?: "currency_book_bank_exposure_limits_var_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Var_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Currency_Book_Bank_Exposure_Limits_Variance_Fields = {
  __typename?: "currency_book_bank_exposure_limits_variance_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  currency_book_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "currency_book_bank_exposure_limits" */
export type Currency_Book_Bank_Exposure_Limits_Variance_Order_By = {
  bank_id?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits = {
  __typename?: "currency_book_liquidity_limits";
  /** An object relationship */
  currency_book: Currency_Books;
  currency_book_id: Scalars["Int"];
  id: Scalars["Int"];
  lower_limit_pct: Scalars["numeric"];
  notice_days_gte: Scalars["numeric"];
  notice_days_lt: Scalars["numeric"];
  upper_limit_pct: Scalars["numeric"];
};

/** aggregated selection of "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Aggregate = {
  __typename?: "currency_book_liquidity_limits_aggregate";
  aggregate?: Maybe<Currency_Book_Liquidity_Limits_Aggregate_Fields>;
  nodes: Array<Currency_Book_Liquidity_Limits>;
};

/** aggregate fields of "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Aggregate_Fields = {
  __typename?: "currency_book_liquidity_limits_aggregate_fields";
  avg?: Maybe<Currency_Book_Liquidity_Limits_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Currency_Book_Liquidity_Limits_Max_Fields>;
  min?: Maybe<Currency_Book_Liquidity_Limits_Min_Fields>;
  stddev?: Maybe<Currency_Book_Liquidity_Limits_Stddev_Fields>;
  stddev_pop?: Maybe<Currency_Book_Liquidity_Limits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Currency_Book_Liquidity_Limits_Stddev_Samp_Fields>;
  sum?: Maybe<Currency_Book_Liquidity_Limits_Sum_Fields>;
  var_pop?: Maybe<Currency_Book_Liquidity_Limits_Var_Pop_Fields>;
  var_samp?: Maybe<Currency_Book_Liquidity_Limits_Var_Samp_Fields>;
  variance?: Maybe<Currency_Book_Liquidity_Limits_Variance_Fields>;
};

/** aggregate fields of "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Currency_Book_Liquidity_Limits_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Aggregate_Order_By = {
  avg?: Maybe<Currency_Book_Liquidity_Limits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Currency_Book_Liquidity_Limits_Max_Order_By>;
  min?: Maybe<Currency_Book_Liquidity_Limits_Min_Order_By>;
  stddev?: Maybe<Currency_Book_Liquidity_Limits_Stddev_Order_By>;
  stddev_pop?: Maybe<Currency_Book_Liquidity_Limits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Currency_Book_Liquidity_Limits_Stddev_Samp_Order_By>;
  sum?: Maybe<Currency_Book_Liquidity_Limits_Sum_Order_By>;
  var_pop?: Maybe<Currency_Book_Liquidity_Limits_Var_Pop_Order_By>;
  var_samp?: Maybe<Currency_Book_Liquidity_Limits_Var_Samp_Order_By>;
  variance?: Maybe<Currency_Book_Liquidity_Limits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Arr_Rel_Insert_Input = {
  data: Array<Currency_Book_Liquidity_Limits_Insert_Input>;
  on_conflict?: Maybe<Currency_Book_Liquidity_Limits_On_Conflict>;
};

/** aggregate avg on columns */
export type Currency_Book_Liquidity_Limits_Avg_Fields = {
  __typename?: "currency_book_liquidity_limits_avg_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Avg_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/**
 * Boolean expression to filter rows from the table
 * "currency_book_liquidity_limits". All fields are combined with a logical 'AND'.
 */
export type Currency_Book_Liquidity_Limits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>>>;
  _not?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>>>;
  currency_book?: Maybe<Currency_Books_Bool_Exp>;
  currency_book_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  lower_limit_pct?: Maybe<Numeric_Comparison_Exp>;
  notice_days_gte?: Maybe<Numeric_Comparison_Exp>;
  notice_days_lt?: Maybe<Numeric_Comparison_Exp>;
  upper_limit_pct?: Maybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "currency_book_liquidity_limits" */
export enum Currency_Book_Liquidity_Limits_Constraint {
  /** unique or primary key constraint */
  CurrencyBookLiquidityLimitsPkey = "CurrencyBookLiquidityLimits_pkey",
  /** unique or primary key constraint */
  CurrencyBookLiquidityLimitsCurrencyBookIdNoticeDaysLt = "currency_book_liquidity_limits_currency_book_id_notice_days_lt_",
}

/** input type for incrementing integer column in table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Inc_Input = {
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Insert_Input = {
  currency_book?: Maybe<Currency_Books_Obj_Rel_Insert_Input>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** aggregate max on columns */
export type Currency_Book_Liquidity_Limits_Max_Fields = {
  __typename?: "currency_book_liquidity_limits_max_fields";
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by max() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Max_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Currency_Book_Liquidity_Limits_Min_Fields = {
  __typename?: "currency_book_liquidity_limits_min_fields";
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by min() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Min_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** response of any mutation on the table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Mutation_Response = {
  __typename?: "currency_book_liquidity_limits_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Currency_Book_Liquidity_Limits>;
};

/** input type for inserting object relation for remote table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Obj_Rel_Insert_Input = {
  data: Currency_Book_Liquidity_Limits_Insert_Input;
  on_conflict?: Maybe<Currency_Book_Liquidity_Limits_On_Conflict>;
};

/** on conflict condition type for table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_On_Conflict = {
  constraint: Currency_Book_Liquidity_Limits_Constraint;
  update_columns: Array<Currency_Book_Liquidity_Limits_Update_Column>;
  where?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
};

/** ordering options when selecting data from "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Order_By = {
  currency_book?: Maybe<Currency_Books_Order_By>;
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** primary key columns input for table: "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "currency_book_liquidity_limits" */
export enum Currency_Book_Liquidity_Limits_Select_Column {
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  Id = "id",
  /** column name */
  LowerLimitPct = "lower_limit_pct",
  /** column name */
  NoticeDaysGte = "notice_days_gte",
  /** column name */
  NoticeDaysLt = "notice_days_lt",
  /** column name */
  UpperLimitPct = "upper_limit_pct",
}

/** input type for updating data in table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Set_Input = {
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** aggregate stddev on columns */
export type Currency_Book_Liquidity_Limits_Stddev_Fields = {
  __typename?: "currency_book_liquidity_limits_stddev_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Stddev_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Currency_Book_Liquidity_Limits_Stddev_Pop_Fields = {
  __typename?: "currency_book_liquidity_limits_stddev_pop_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Stddev_Pop_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Currency_Book_Liquidity_Limits_Stddev_Samp_Fields = {
  __typename?: "currency_book_liquidity_limits_stddev_samp_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Stddev_Samp_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Currency_Book_Liquidity_Limits_Sum_Fields = {
  __typename?: "currency_book_liquidity_limits_sum_fields";
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by sum() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Sum_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** update columns of table "currency_book_liquidity_limits" */
export enum Currency_Book_Liquidity_Limits_Update_Column {
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  Id = "id",
  /** column name */
  LowerLimitPct = "lower_limit_pct",
  /** column name */
  NoticeDaysGte = "notice_days_gte",
  /** column name */
  NoticeDaysLt = "notice_days_lt",
  /** column name */
  UpperLimitPct = "upper_limit_pct",
}

/** aggregate var_pop on columns */
export type Currency_Book_Liquidity_Limits_Var_Pop_Fields = {
  __typename?: "currency_book_liquidity_limits_var_pop_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Var_Pop_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Currency_Book_Liquidity_Limits_Var_Samp_Fields = {
  __typename?: "currency_book_liquidity_limits_var_samp_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Var_Samp_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Currency_Book_Liquidity_Limits_Variance_Fields = {
  __typename?: "currency_book_liquidity_limits_variance_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "currency_book_liquidity_limits" */
export type Currency_Book_Liquidity_Limits_Variance_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** columns and relationships of "currency_books" */
export type Currency_Books = {
  __typename?: "currency_books";
  /** An array relationship */
  bank_accounts: Array<Bank_Accounts>;
  /** An aggregated array relationship */
  bank_accounts_aggregate: Bank_Accounts_Aggregate;
  /** An object relationship */
  business_unit: Business_Units;
  business_unit_id: Scalars["Int"];
  created_at: Scalars["timestamptz"];
  /** An object relationship */
  currency: Currencies;
  /** An array relationship */
  currency_book_bank_exposure_limits: Array<Currency_Book_Bank_Exposure_Limits>;
  /** An aggregated array relationship */
  currency_book_bank_exposure_limits_aggregate: Currency_Book_Bank_Exposure_Limits_Aggregate;
  /** An array relationship */
  currency_book_liquidity_limits: Array<Currency_Book_Liquidity_Limits>;
  /** An aggregated array relationship */
  currency_book_liquidity_limits_aggregate: Currency_Book_Liquidity_Limits_Aggregate;
  currency_id: Scalars["Int"];
  id: Scalars["Int"];
  is_archived: Scalars["Boolean"];
  /** An array relationship */
  models: Array<Models>;
  /** An aggregated array relationship */
  models_aggregate: Models_Aggregate;
  name: Scalars["String"];
};

/** columns and relationships of "currency_books" */
export type Currency_BooksBank_AccountsArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** columns and relationships of "currency_books" */
export type Currency_BooksBank_Accounts_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** columns and relationships of "currency_books" */
export type Currency_BooksCurrency_Book_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "currency_books" */
export type Currency_BooksCurrency_Book_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "currency_books" */
export type Currency_BooksCurrency_Book_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Liquidity_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
};

/** columns and relationships of "currency_books" */
export type Currency_BooksCurrency_Book_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Liquidity_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
};

/** columns and relationships of "currency_books" */
export type Currency_BooksModelsArgs = {
  distinct_on?: Maybe<Array<Models_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Models_Order_By>>;
  where?: Maybe<Models_Bool_Exp>;
};

/** columns and relationships of "currency_books" */
export type Currency_BooksModels_AggregateArgs = {
  distinct_on?: Maybe<Array<Models_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Models_Order_By>>;
  where?: Maybe<Models_Bool_Exp>;
};

/** aggregated selection of "currency_books" */
export type Currency_Books_Aggregate = {
  __typename?: "currency_books_aggregate";
  aggregate?: Maybe<Currency_Books_Aggregate_Fields>;
  nodes: Array<Currency_Books>;
};

/** aggregate fields of "currency_books" */
export type Currency_Books_Aggregate_Fields = {
  __typename?: "currency_books_aggregate_fields";
  avg?: Maybe<Currency_Books_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Currency_Books_Max_Fields>;
  min?: Maybe<Currency_Books_Min_Fields>;
  stddev?: Maybe<Currency_Books_Stddev_Fields>;
  stddev_pop?: Maybe<Currency_Books_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Currency_Books_Stddev_Samp_Fields>;
  sum?: Maybe<Currency_Books_Sum_Fields>;
  var_pop?: Maybe<Currency_Books_Var_Pop_Fields>;
  var_samp?: Maybe<Currency_Books_Var_Samp_Fields>;
  variance?: Maybe<Currency_Books_Variance_Fields>;
};

/** aggregate fields of "currency_books" */
export type Currency_Books_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Currency_Books_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "currency_books" */
export type Currency_Books_Aggregate_Order_By = {
  avg?: Maybe<Currency_Books_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Currency_Books_Max_Order_By>;
  min?: Maybe<Currency_Books_Min_Order_By>;
  stddev?: Maybe<Currency_Books_Stddev_Order_By>;
  stddev_pop?: Maybe<Currency_Books_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Currency_Books_Stddev_Samp_Order_By>;
  sum?: Maybe<Currency_Books_Sum_Order_By>;
  var_pop?: Maybe<Currency_Books_Var_Pop_Order_By>;
  var_samp?: Maybe<Currency_Books_Var_Samp_Order_By>;
  variance?: Maybe<Currency_Books_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "currency_books" */
export type Currency_Books_Arr_Rel_Insert_Input = {
  data: Array<Currency_Books_Insert_Input>;
  on_conflict?: Maybe<Currency_Books_On_Conflict>;
};

/** aggregate avg on columns */
export type Currency_Books_Avg_Fields = {
  __typename?: "currency_books_avg_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "currency_books" */
export type Currency_Books_Avg_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "currency_books". All fields are combined with a logical 'AND'. */
export type Currency_Books_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Currency_Books_Bool_Exp>>>;
  _not?: Maybe<Currency_Books_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Currency_Books_Bool_Exp>>>;
  bank_accounts?: Maybe<Bank_Accounts_Bool_Exp>;
  business_unit?: Maybe<Business_Units_Bool_Exp>;
  business_unit_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency?: Maybe<Currencies_Bool_Exp>;
  currency_book_bank_exposure_limits?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
  currency_book_liquidity_limits?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
  currency_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_archived?: Maybe<Boolean_Comparison_Exp>;
  models?: Maybe<Models_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "currency_books" */
export enum Currency_Books_Constraint {
  /** unique or primary key constraint */
  CurrencyBookPkey = "CurrencyBook_pkey",
}

/** input type for incrementing integer column in table "currency_books" */
export type Currency_Books_Inc_Input = {
  business_unit_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "currency_books" */
export type Currency_Books_Insert_Input = {
  bank_accounts?: Maybe<Bank_Accounts_Arr_Rel_Insert_Input>;
  business_unit?: Maybe<Business_Units_Obj_Rel_Insert_Input>;
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency?: Maybe<Currencies_Obj_Rel_Insert_Input>;
  currency_book_bank_exposure_limits?: Maybe<Currency_Book_Bank_Exposure_Limits_Arr_Rel_Insert_Input>;
  currency_book_liquidity_limits?: Maybe<Currency_Book_Liquidity_Limits_Arr_Rel_Insert_Input>;
  currency_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  is_archived?: Maybe<Scalars["Boolean"]>;
  models?: Maybe<Models_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Currency_Books_Max_Fields = {
  __typename?: "currency_books_max_fields";
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "currency_books" */
export type Currency_Books_Max_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Currency_Books_Min_Fields = {
  __typename?: "currency_books_min_fields";
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "currency_books" */
export type Currency_Books_Min_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
};

/** response of any mutation on the table "currency_books" */
export type Currency_Books_Mutation_Response = {
  __typename?: "currency_books_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Currency_Books>;
};

/** input type for inserting object relation for remote table "currency_books" */
export type Currency_Books_Obj_Rel_Insert_Input = {
  data: Currency_Books_Insert_Input;
  on_conflict?: Maybe<Currency_Books_On_Conflict>;
};

/** on conflict condition type for table "currency_books" */
export type Currency_Books_On_Conflict = {
  constraint: Currency_Books_Constraint;
  update_columns: Array<Currency_Books_Update_Column>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** ordering options when selecting data from "currency_books" */
export type Currency_Books_Order_By = {
  bank_accounts_aggregate?: Maybe<Bank_Accounts_Aggregate_Order_By>;
  business_unit?: Maybe<Business_Units_Order_By>;
  business_unit_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  currency?: Maybe<Currencies_Order_By>;
  currency_book_bank_exposure_limits_aggregate?: Maybe<Currency_Book_Bank_Exposure_Limits_Aggregate_Order_By>;
  currency_book_liquidity_limits_aggregate?: Maybe<Currency_Book_Liquidity_Limits_Aggregate_Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_archived?: Maybe<Order_By>;
  models_aggregate?: Maybe<Models_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
};

/** primary key columns input for table: "currency_books" */
export type Currency_Books_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "currency_books" */
export enum Currency_Books_Select_Column {
  /** column name */
  BusinessUnitId = "business_unit_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyId = "currency_id",
  /** column name */
  Id = "id",
  /** column name */
  IsArchived = "is_archived",
  /** column name */
  Name = "name",
}

/** input type for updating data in table "currency_books" */
export type Currency_Books_Set_Input = {
  business_unit_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  is_archived?: Maybe<Scalars["Boolean"]>;
  name?: Maybe<Scalars["String"]>;
};

/** aggregate stddev on columns */
export type Currency_Books_Stddev_Fields = {
  __typename?: "currency_books_stddev_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "currency_books" */
export type Currency_Books_Stddev_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Currency_Books_Stddev_Pop_Fields = {
  __typename?: "currency_books_stddev_pop_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "currency_books" */
export type Currency_Books_Stddev_Pop_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Currency_Books_Stddev_Samp_Fields = {
  __typename?: "currency_books_stddev_samp_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "currency_books" */
export type Currency_Books_Stddev_Samp_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Currency_Books_Sum_Fields = {
  __typename?: "currency_books_sum_fields";
  business_unit_id?: Maybe<Scalars["Int"]>;
  currency_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "currency_books" */
export type Currency_Books_Sum_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "currency_books" */
export enum Currency_Books_Update_Column {
  /** column name */
  BusinessUnitId = "business_unit_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyId = "currency_id",
  /** column name */
  Id = "id",
  /** column name */
  IsArchived = "is_archived",
  /** column name */
  Name = "name",
}

/** aggregate var_pop on columns */
export type Currency_Books_Var_Pop_Fields = {
  __typename?: "currency_books_var_pop_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "currency_books" */
export type Currency_Books_Var_Pop_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Currency_Books_Var_Samp_Fields = {
  __typename?: "currency_books_var_samp_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "currency_books" */
export type Currency_Books_Var_Samp_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Currency_Books_Variance_Fields = {
  __typename?: "currency_books_variance_fields";
  business_unit_id?: Maybe<Scalars["Float"]>;
  currency_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "currency_books" */
export type Currency_Books_Variance_Order_By = {
  business_unit_id?: Maybe<Order_By>;
  currency_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** expression to compare columns of type date. All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: Maybe<Scalars["date"]>;
  _gt?: Maybe<Scalars["date"]>;
  _gte?: Maybe<Scalars["date"]>;
  _in?: Maybe<Array<Scalars["date"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _lt?: Maybe<Scalars["date"]>;
  _lte?: Maybe<Scalars["date"]>;
  _neq?: Maybe<Scalars["date"]>;
  _nin?: Maybe<Array<Scalars["date"]>>;
};

/** expression to compare columns of type float8. All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars["float8"]>;
  _gt?: Maybe<Scalars["float8"]>;
  _gte?: Maybe<Scalars["float8"]>;
  _in?: Maybe<Array<Scalars["float8"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _lt?: Maybe<Scalars["float8"]>;
  _lte?: Maybe<Scalars["float8"]>;
  _neq?: Maybe<Scalars["float8"]>;
  _nin?: Maybe<Array<Scalars["float8"]>>;
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars["Int"]>;
  _gt?: Maybe<Scalars["Int"]>;
  _gte?: Maybe<Scalars["Int"]>;
  _in?: Maybe<Array<Scalars["Int"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _lt?: Maybe<Scalars["Int"]>;
  _lte?: Maybe<Scalars["Int"]>;
  _neq?: Maybe<Scalars["Int"]>;
  _nin?: Maybe<Array<Scalars["Int"]>>;
};

/** columns and relationships of "model_balances" */
export type Model_Balances = {
  __typename?: "model_balances";
  balance: Scalars["numeric"];
  balance_gbp: Scalars["numeric"];
  /** An object relationship */
  bank_account: Bank_Accounts;
  bank_account_id: Scalars["uuid"];
  created_at: Scalars["timestamptz"];
  id: Scalars["Int"];
};

/** aggregated selection of "model_balances" */
export type Model_Balances_Aggregate = {
  __typename?: "model_balances_aggregate";
  aggregate?: Maybe<Model_Balances_Aggregate_Fields>;
  nodes: Array<Model_Balances>;
};

/** aggregate fields of "model_balances" */
export type Model_Balances_Aggregate_Fields = {
  __typename?: "model_balances_aggregate_fields";
  avg?: Maybe<Model_Balances_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Model_Balances_Max_Fields>;
  min?: Maybe<Model_Balances_Min_Fields>;
  stddev?: Maybe<Model_Balances_Stddev_Fields>;
  stddev_pop?: Maybe<Model_Balances_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Model_Balances_Stddev_Samp_Fields>;
  sum?: Maybe<Model_Balances_Sum_Fields>;
  var_pop?: Maybe<Model_Balances_Var_Pop_Fields>;
  var_samp?: Maybe<Model_Balances_Var_Samp_Fields>;
  variance?: Maybe<Model_Balances_Variance_Fields>;
};

/** aggregate fields of "model_balances" */
export type Model_Balances_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Model_Balances_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "model_balances" */
export type Model_Balances_Aggregate_Order_By = {
  avg?: Maybe<Model_Balances_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Model_Balances_Max_Order_By>;
  min?: Maybe<Model_Balances_Min_Order_By>;
  stddev?: Maybe<Model_Balances_Stddev_Order_By>;
  stddev_pop?: Maybe<Model_Balances_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Model_Balances_Stddev_Samp_Order_By>;
  sum?: Maybe<Model_Balances_Sum_Order_By>;
  var_pop?: Maybe<Model_Balances_Var_Pop_Order_By>;
  var_samp?: Maybe<Model_Balances_Var_Samp_Order_By>;
  variance?: Maybe<Model_Balances_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "model_balances" */
export type Model_Balances_Arr_Rel_Insert_Input = {
  data: Array<Model_Balances_Insert_Input>;
  on_conflict?: Maybe<Model_Balances_On_Conflict>;
};

/** aggregate avg on columns */
export type Model_Balances_Avg_Fields = {
  __typename?: "model_balances_avg_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "model_balances" */
export type Model_Balances_Avg_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_balances". All fields are combined with a logical 'AND'. */
export type Model_Balances_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Model_Balances_Bool_Exp>>>;
  _not?: Maybe<Model_Balances_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Model_Balances_Bool_Exp>>>;
  balance?: Maybe<Numeric_Comparison_Exp>;
  balance_gbp?: Maybe<Numeric_Comparison_Exp>;
  bank_account?: Maybe<Bank_Accounts_Bool_Exp>;
  bank_account_id?: Maybe<Uuid_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "model_balances" */
export enum Model_Balances_Constraint {
  /** unique or primary key constraint */
  ModelBalancePkey = "ModelBalance_pkey",
  /** unique or primary key constraint */
  ModelBalancesBankAccountIdKey = "model_balances_bank_account_id_key",
}

/** input type for incrementing integer column in table "model_balances" */
export type Model_Balances_Inc_Input = {
  balance?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "model_balances" */
export type Model_Balances_Insert_Input = {
  balance?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  bank_account?: Maybe<Bank_Accounts_Obj_Rel_Insert_Input>;
  bank_account_id?: Maybe<Scalars["uuid"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type Model_Balances_Max_Fields = {
  __typename?: "model_balances_max_fields";
  balance?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  bank_account_id?: Maybe<Scalars["uuid"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "model_balances" */
export type Model_Balances_Max_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  bank_account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Model_Balances_Min_Fields = {
  __typename?: "model_balances_min_fields";
  balance?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  bank_account_id?: Maybe<Scalars["uuid"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "model_balances" */
export type Model_Balances_Min_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  bank_account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "model_balances" */
export type Model_Balances_Mutation_Response = {
  __typename?: "model_balances_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Model_Balances>;
};

/** input type for inserting object relation for remote table "model_balances" */
export type Model_Balances_Obj_Rel_Insert_Input = {
  data: Model_Balances_Insert_Input;
  on_conflict?: Maybe<Model_Balances_On_Conflict>;
};

/** on conflict condition type for table "model_balances" */
export type Model_Balances_On_Conflict = {
  constraint: Model_Balances_Constraint;
  update_columns: Array<Model_Balances_Update_Column>;
  where?: Maybe<Model_Balances_Bool_Exp>;
};

/** ordering options when selecting data from "model_balances" */
export type Model_Balances_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  bank_account?: Maybe<Bank_Accounts_Order_By>;
  bank_account_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: "model_balances" */
export type Model_Balances_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "model_balances" */
export enum Model_Balances_Select_Column {
  /** column name */
  Balance = "balance",
  /** column name */
  BalanceGbp = "balance_gbp",
  /** column name */
  BankAccountId = "bank_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

/** input type for updating data in table "model_balances" */
export type Model_Balances_Set_Input = {
  balance?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  bank_account_id?: Maybe<Scalars["uuid"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type Model_Balances_Stddev_Fields = {
  __typename?: "model_balances_stddev_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "model_balances" */
export type Model_Balances_Stddev_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Model_Balances_Stddev_Pop_Fields = {
  __typename?: "model_balances_stddev_pop_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "model_balances" */
export type Model_Balances_Stddev_Pop_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Model_Balances_Stddev_Samp_Fields = {
  __typename?: "model_balances_stddev_samp_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "model_balances" */
export type Model_Balances_Stddev_Samp_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Model_Balances_Sum_Fields = {
  __typename?: "model_balances_sum_fields";
  balance?: Maybe<Scalars["numeric"]>;
  balance_gbp?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "model_balances" */
export type Model_Balances_Sum_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "model_balances" */
export enum Model_Balances_Update_Column {
  /** column name */
  Balance = "balance",
  /** column name */
  BalanceGbp = "balance_gbp",
  /** column name */
  BankAccountId = "bank_account_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
}

/** aggregate var_pop on columns */
export type Model_Balances_Var_Pop_Fields = {
  __typename?: "model_balances_var_pop_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "model_balances" */
export type Model_Balances_Var_Pop_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Model_Balances_Var_Samp_Fields = {
  __typename?: "model_balances_var_samp_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "model_balances" */
export type Model_Balances_Var_Samp_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Model_Balances_Variance_Fields = {
  __typename?: "model_balances_variance_fields";
  balance?: Maybe<Scalars["Float"]>;
  balance_gbp?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "model_balances" */
export type Model_Balances_Variance_Order_By = {
  balance?: Maybe<Order_By>;
  balance_gbp?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** columns and relationships of "models" */
export type Models = {
  __typename?: "models";
  created_at: Scalars["timestamptz"];
  /** An object relationship */
  currency_book: Currency_Books;
  currency_book_id: Scalars["Int"];
  date: Scalars["date"];
  id: Scalars["Int"];
  is_hidden: Scalars["Boolean"];
  notes: Scalars["String"];
};

/** aggregated selection of "models" */
export type Models_Aggregate = {
  __typename?: "models_aggregate";
  aggregate?: Maybe<Models_Aggregate_Fields>;
  nodes: Array<Models>;
};

/** aggregate fields of "models" */
export type Models_Aggregate_Fields = {
  __typename?: "models_aggregate_fields";
  avg?: Maybe<Models_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Models_Max_Fields>;
  min?: Maybe<Models_Min_Fields>;
  stddev?: Maybe<Models_Stddev_Fields>;
  stddev_pop?: Maybe<Models_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Models_Stddev_Samp_Fields>;
  sum?: Maybe<Models_Sum_Fields>;
  var_pop?: Maybe<Models_Var_Pop_Fields>;
  var_samp?: Maybe<Models_Var_Samp_Fields>;
  variance?: Maybe<Models_Variance_Fields>;
};

/** aggregate fields of "models" */
export type Models_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Models_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "models" */
export type Models_Aggregate_Order_By = {
  avg?: Maybe<Models_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Models_Max_Order_By>;
  min?: Maybe<Models_Min_Order_By>;
  stddev?: Maybe<Models_Stddev_Order_By>;
  stddev_pop?: Maybe<Models_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Models_Stddev_Samp_Order_By>;
  sum?: Maybe<Models_Sum_Order_By>;
  var_pop?: Maybe<Models_Var_Pop_Order_By>;
  var_samp?: Maybe<Models_Var_Samp_Order_By>;
  variance?: Maybe<Models_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "models" */
export type Models_Arr_Rel_Insert_Input = {
  data: Array<Models_Insert_Input>;
  on_conflict?: Maybe<Models_On_Conflict>;
};

/** aggregate avg on columns */
export type Models_Avg_Fields = {
  __typename?: "models_avg_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "models" */
export type Models_Avg_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "models". All fields are combined with a logical 'AND'. */
export type Models_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Models_Bool_Exp>>>;
  _not?: Maybe<Models_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Models_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  currency_book?: Maybe<Currency_Books_Bool_Exp>;
  currency_book_id?: Maybe<Int_Comparison_Exp>;
  date?: Maybe<Date_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_hidden?: Maybe<Boolean_Comparison_Exp>;
  notes?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "models" */
export enum Models_Constraint {
  /** unique or primary key constraint */
  ModelPkey = "Model_pkey",
}

/** input type for incrementing integer column in table "models" */
export type Models_Inc_Input = {
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "models" */
export type Models_Insert_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book?: Maybe<Currency_Books_Obj_Rel_Insert_Input>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  is_hidden?: Maybe<Scalars["Boolean"]>;
  notes?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Models_Max_Fields = {
  __typename?: "models_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  notes?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "models" */
export type Models_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Models_Min_Fields = {
  __typename?: "models_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  notes?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "models" */
export type Models_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  currency_book_id?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
};

/** response of any mutation on the table "models" */
export type Models_Mutation_Response = {
  __typename?: "models_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Models>;
};

/** input type for inserting object relation for remote table "models" */
export type Models_Obj_Rel_Insert_Input = {
  data: Models_Insert_Input;
  on_conflict?: Maybe<Models_On_Conflict>;
};

/** on conflict condition type for table "models" */
export type Models_On_Conflict = {
  constraint: Models_Constraint;
  update_columns: Array<Models_Update_Column>;
  where?: Maybe<Models_Bool_Exp>;
};

/** ordering options when selecting data from "models" */
export type Models_Order_By = {
  created_at?: Maybe<Order_By>;
  currency_book?: Maybe<Currency_Books_Order_By>;
  currency_book_id?: Maybe<Order_By>;
  date?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_hidden?: Maybe<Order_By>;
  notes?: Maybe<Order_By>;
};

/** primary key columns input for table: "models" */
export type Models_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "models" */
export enum Models_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  Date = "date",
  /** column name */
  Id = "id",
  /** column name */
  IsHidden = "is_hidden",
  /** column name */
  Notes = "notes",
}

/** input type for updating data in table "models" */
export type Models_Set_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  currency_book_id?: Maybe<Scalars["Int"]>;
  date?: Maybe<Scalars["date"]>;
  id?: Maybe<Scalars["Int"]>;
  is_hidden?: Maybe<Scalars["Boolean"]>;
  notes?: Maybe<Scalars["String"]>;
};

/** aggregate stddev on columns */
export type Models_Stddev_Fields = {
  __typename?: "models_stddev_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "models" */
export type Models_Stddev_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Models_Stddev_Pop_Fields = {
  __typename?: "models_stddev_pop_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "models" */
export type Models_Stddev_Pop_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Models_Stddev_Samp_Fields = {
  __typename?: "models_stddev_samp_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "models" */
export type Models_Stddev_Samp_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Models_Sum_Fields = {
  __typename?: "models_sum_fields";
  currency_book_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "models" */
export type Models_Sum_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** update columns of table "models" */
export enum Models_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  CurrencyBookId = "currency_book_id",
  /** column name */
  Date = "date",
  /** column name */
  Id = "id",
  /** column name */
  IsHidden = "is_hidden",
  /** column name */
  Notes = "notes",
}

/** aggregate var_pop on columns */
export type Models_Var_Pop_Fields = {
  __typename?: "models_var_pop_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "models" */
export type Models_Var_Pop_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Models_Var_Samp_Fields = {
  __typename?: "models_var_samp_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "models" */
export type Models_Var_Samp_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Models_Variance_Fields = {
  __typename?: "models_variance_fields";
  currency_book_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "models" */
export type Models_Variance_Order_By = {
  currency_book_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: "mutation_root";
  /** delete data from the table: "actual_balances" */
  delete_actual_balances?: Maybe<Actual_Balances_Mutation_Response>;
  /** delete single row from the table: "actual_balances" */
  delete_actual_balances_by_pk?: Maybe<Actual_Balances>;
  /** delete data from the table: "app_users" */
  delete_app_users?: Maybe<App_Users_Mutation_Response>;
  /** delete single row from the table: "app_users" */
  delete_app_users_by_pk?: Maybe<App_Users>;
  /** delete data from the table: "bank_accounts" */
  delete_bank_accounts?: Maybe<Bank_Accounts_Mutation_Response>;
  /** delete single row from the table: "bank_accounts" */
  delete_bank_accounts_by_pk?: Maybe<Bank_Accounts>;
  /** delete data from the table: "bank_factsheets" */
  delete_bank_factsheets?: Maybe<Bank_Factsheets_Mutation_Response>;
  /** delete single row from the table: "bank_factsheets" */
  delete_bank_factsheets_by_pk?: Maybe<Bank_Factsheets>;
  /** delete data from the table: "banks" */
  delete_banks?: Maybe<Banks_Mutation_Response>;
  /** delete single row from the table: "banks" */
  delete_banks_by_pk?: Maybe<Banks>;
  /** delete data from the table: "business_unit_bank_exposure_limits" */
  delete_business_unit_bank_exposure_limits?: Maybe<Business_Unit_Bank_Exposure_Limits_Mutation_Response>;
  /** delete single row from the table: "business_unit_bank_exposure_limits" */
  delete_business_unit_bank_exposure_limits_by_pk?: Maybe<Business_Unit_Bank_Exposure_Limits>;
  /** delete data from the table: "business_unit_liquidity_limits" */
  delete_business_unit_liquidity_limits?: Maybe<Business_Unit_Liquidity_Limits_Mutation_Response>;
  /** delete single row from the table: "business_unit_liquidity_limits" */
  delete_business_unit_liquidity_limits_by_pk?: Maybe<Business_Unit_Liquidity_Limits>;
  /** delete data from the table: "business_units" */
  delete_business_units?: Maybe<Business_Units_Mutation_Response>;
  /** delete single row from the table: "business_units" */
  delete_business_units_by_pk?: Maybe<Business_Units>;
  /** delete data from the table: "currencies" */
  delete_currencies?: Maybe<Currencies_Mutation_Response>;
  /** delete single row from the table: "currencies" */
  delete_currencies_by_pk?: Maybe<Currencies>;
  /** delete data from the table: "currency_book_bank_exposure_limits" */
  delete_currency_book_bank_exposure_limits?: Maybe<Currency_Book_Bank_Exposure_Limits_Mutation_Response>;
  /** delete single row from the table: "currency_book_bank_exposure_limits" */
  delete_currency_book_bank_exposure_limits_by_pk?: Maybe<Currency_Book_Bank_Exposure_Limits>;
  /** delete data from the table: "currency_book_liquidity_limits" */
  delete_currency_book_liquidity_limits?: Maybe<Currency_Book_Liquidity_Limits_Mutation_Response>;
  /** delete single row from the table: "currency_book_liquidity_limits" */
  delete_currency_book_liquidity_limits_by_pk?: Maybe<Currency_Book_Liquidity_Limits>;
  /** delete data from the table: "currency_books" */
  delete_currency_books?: Maybe<Currency_Books_Mutation_Response>;
  /** delete single row from the table: "currency_books" */
  delete_currency_books_by_pk?: Maybe<Currency_Books>;
  /** delete data from the table: "model_balances" */
  delete_model_balances?: Maybe<Model_Balances_Mutation_Response>;
  /** delete single row from the table: "model_balances" */
  delete_model_balances_by_pk?: Maybe<Model_Balances>;
  /** delete data from the table: "models" */
  delete_models?: Maybe<Models_Mutation_Response>;
  /** delete single row from the table: "models" */
  delete_models_by_pk?: Maybe<Models>;
  /** delete data from the table: "organisation_bank_exposure_limits" */
  delete_organisation_bank_exposure_limits?: Maybe<Organisation_Bank_Exposure_Limits_Mutation_Response>;
  /** delete single row from the table: "organisation_bank_exposure_limits" */
  delete_organisation_bank_exposure_limits_by_pk?: Maybe<Organisation_Bank_Exposure_Limits>;
  /** delete data from the table: "organisation_banks" */
  delete_organisation_banks?: Maybe<Organisation_Banks_Mutation_Response>;
  /** delete single row from the table: "organisation_banks" */
  delete_organisation_banks_by_pk?: Maybe<Organisation_Banks>;
  /** delete data from the table: "organisation_liquidity_limits" */
  delete_organisation_liquidity_limits?: Maybe<Organisation_Liquidity_Limits_Mutation_Response>;
  /** delete single row from the table: "organisation_liquidity_limits" */
  delete_organisation_liquidity_limits_by_pk?: Maybe<Organisation_Liquidity_Limits>;
  /** delete data from the table: "organisation_reports" */
  delete_organisation_reports?: Maybe<Organisation_Reports_Mutation_Response>;
  /** delete single row from the table: "organisation_reports" */
  delete_organisation_reports_by_pk?: Maybe<Organisation_Reports>;
  /** delete data from the table: "organisation_research" */
  delete_organisation_research?: Maybe<Organisation_Research_Mutation_Response>;
  /** delete single row from the table: "organisation_research" */
  delete_organisation_research_by_pk?: Maybe<Organisation_Research>;
  /** delete data from the table: "organisation_users" */
  delete_organisation_users?: Maybe<Organisation_Users_Mutation_Response>;
  /** delete single row from the table: "organisation_users" */
  delete_organisation_users_by_pk?: Maybe<Organisation_Users>;
  /** delete data from the table: "organisations" */
  delete_organisations?: Maybe<Organisations_Mutation_Response>;
  /** delete single row from the table: "organisations" */
  delete_organisations_by_pk?: Maybe<Organisations>;
  /** delete data from the table: "product_types_enum" */
  delete_product_types_enum?: Maybe<Product_Types_Enum_Mutation_Response>;
  /** delete single row from the table: "product_types_enum" */
  delete_product_types_enum_by_pk?: Maybe<Product_Types_Enum>;
  /** delete data from the table: "research" */
  delete_research?: Maybe<Research_Mutation_Response>;
  /** delete single row from the table: "research" */
  delete_research_by_pk?: Maybe<Research>;
  /** delete data from the table: "uploads" */
  delete_uploads?: Maybe<Uploads_Mutation_Response>;
  /** delete single row from the table: "uploads" */
  delete_uploads_by_pk?: Maybe<Uploads>;
  /** insert data into the table: "actual_balances" */
  insert_actual_balances?: Maybe<Actual_Balances_Mutation_Response>;
  /** insert a single row into the table: "actual_balances" */
  insert_actual_balances_one?: Maybe<Actual_Balances>;
  /** insert data into the table: "app_users" */
  insert_app_users?: Maybe<App_Users_Mutation_Response>;
  /** insert a single row into the table: "app_users" */
  insert_app_users_one?: Maybe<App_Users>;
  /** insert data into the table: "bank_accounts" */
  insert_bank_accounts?: Maybe<Bank_Accounts_Mutation_Response>;
  /** insert a single row into the table: "bank_accounts" */
  insert_bank_accounts_one?: Maybe<Bank_Accounts>;
  /** insert data into the table: "bank_factsheets" */
  insert_bank_factsheets?: Maybe<Bank_Factsheets_Mutation_Response>;
  /** insert a single row into the table: "bank_factsheets" */
  insert_bank_factsheets_one?: Maybe<Bank_Factsheets>;
  /** insert data into the table: "banks" */
  insert_banks?: Maybe<Banks_Mutation_Response>;
  /** insert a single row into the table: "banks" */
  insert_banks_one?: Maybe<Banks>;
  /** insert data into the table: "business_unit_bank_exposure_limits" */
  insert_business_unit_bank_exposure_limits?: Maybe<Business_Unit_Bank_Exposure_Limits_Mutation_Response>;
  /** insert a single row into the table: "business_unit_bank_exposure_limits" */
  insert_business_unit_bank_exposure_limits_one?: Maybe<Business_Unit_Bank_Exposure_Limits>;
  /** insert data into the table: "business_unit_liquidity_limits" */
  insert_business_unit_liquidity_limits?: Maybe<Business_Unit_Liquidity_Limits_Mutation_Response>;
  /** insert a single row into the table: "business_unit_liquidity_limits" */
  insert_business_unit_liquidity_limits_one?: Maybe<Business_Unit_Liquidity_Limits>;
  /** insert data into the table: "business_units" */
  insert_business_units?: Maybe<Business_Units_Mutation_Response>;
  /** insert a single row into the table: "business_units" */
  insert_business_units_one?: Maybe<Business_Units>;
  /** insert data into the table: "currencies" */
  insert_currencies?: Maybe<Currencies_Mutation_Response>;
  /** insert a single row into the table: "currencies" */
  insert_currencies_one?: Maybe<Currencies>;
  /** insert data into the table: "currency_book_bank_exposure_limits" */
  insert_currency_book_bank_exposure_limits?: Maybe<Currency_Book_Bank_Exposure_Limits_Mutation_Response>;
  /** insert a single row into the table: "currency_book_bank_exposure_limits" */
  insert_currency_book_bank_exposure_limits_one?: Maybe<Currency_Book_Bank_Exposure_Limits>;
  /** insert data into the table: "currency_book_liquidity_limits" */
  insert_currency_book_liquidity_limits?: Maybe<Currency_Book_Liquidity_Limits_Mutation_Response>;
  /** insert a single row into the table: "currency_book_liquidity_limits" */
  insert_currency_book_liquidity_limits_one?: Maybe<Currency_Book_Liquidity_Limits>;
  /** insert data into the table: "currency_books" */
  insert_currency_books?: Maybe<Currency_Books_Mutation_Response>;
  /** insert a single row into the table: "currency_books" */
  insert_currency_books_one?: Maybe<Currency_Books>;
  /** insert data into the table: "model_balances" */
  insert_model_balances?: Maybe<Model_Balances_Mutation_Response>;
  /** insert a single row into the table: "model_balances" */
  insert_model_balances_one?: Maybe<Model_Balances>;
  /** insert data into the table: "models" */
  insert_models?: Maybe<Models_Mutation_Response>;
  /** insert a single row into the table: "models" */
  insert_models_one?: Maybe<Models>;
  /** insert data into the table: "organisation_bank_exposure_limits" */
  insert_organisation_bank_exposure_limits?: Maybe<Organisation_Bank_Exposure_Limits_Mutation_Response>;
  /** insert a single row into the table: "organisation_bank_exposure_limits" */
  insert_organisation_bank_exposure_limits_one?: Maybe<Organisation_Bank_Exposure_Limits>;
  /** insert data into the table: "organisation_banks" */
  insert_organisation_banks?: Maybe<Organisation_Banks_Mutation_Response>;
  /** insert a single row into the table: "organisation_banks" */
  insert_organisation_banks_one?: Maybe<Organisation_Banks>;
  /** insert data into the table: "organisation_liquidity_limits" */
  insert_organisation_liquidity_limits?: Maybe<Organisation_Liquidity_Limits_Mutation_Response>;
  /** insert a single row into the table: "organisation_liquidity_limits" */
  insert_organisation_liquidity_limits_one?: Maybe<Organisation_Liquidity_Limits>;
  /** insert data into the table: "organisation_reports" */
  insert_organisation_reports?: Maybe<Organisation_Reports_Mutation_Response>;
  /** insert a single row into the table: "organisation_reports" */
  insert_organisation_reports_one?: Maybe<Organisation_Reports>;
  /** insert data into the table: "organisation_research" */
  insert_organisation_research?: Maybe<Organisation_Research_Mutation_Response>;
  /** insert a single row into the table: "organisation_research" */
  insert_organisation_research_one?: Maybe<Organisation_Research>;
  /** insert data into the table: "organisation_users" */
  insert_organisation_users?: Maybe<Organisation_Users_Mutation_Response>;
  /** insert a single row into the table: "organisation_users" */
  insert_organisation_users_one?: Maybe<Organisation_Users>;
  /** insert data into the table: "organisations" */
  insert_organisations?: Maybe<Organisations_Mutation_Response>;
  /** insert a single row into the table: "organisations" */
  insert_organisations_one?: Maybe<Organisations>;
  /** insert data into the table: "product_types_enum" */
  insert_product_types_enum?: Maybe<Product_Types_Enum_Mutation_Response>;
  /** insert a single row into the table: "product_types_enum" */
  insert_product_types_enum_one?: Maybe<Product_Types_Enum>;
  /** insert data into the table: "research" */
  insert_research?: Maybe<Research_Mutation_Response>;
  /** insert a single row into the table: "research" */
  insert_research_one?: Maybe<Research>;
  /** insert data into the table: "uploads" */
  insert_uploads?: Maybe<Uploads_Mutation_Response>;
  /** insert a single row into the table: "uploads" */
  insert_uploads_one?: Maybe<Uploads>;
  /** update data of the table: "actual_balances" */
  update_actual_balances?: Maybe<Actual_Balances_Mutation_Response>;
  /** update single row of the table: "actual_balances" */
  update_actual_balances_by_pk?: Maybe<Actual_Balances>;
  /** update data of the table: "app_users" */
  update_app_users?: Maybe<App_Users_Mutation_Response>;
  /** update single row of the table: "app_users" */
  update_app_users_by_pk?: Maybe<App_Users>;
  /** update data of the table: "bank_accounts" */
  update_bank_accounts?: Maybe<Bank_Accounts_Mutation_Response>;
  /** update single row of the table: "bank_accounts" */
  update_bank_accounts_by_pk?: Maybe<Bank_Accounts>;
  /** update data of the table: "bank_factsheets" */
  update_bank_factsheets?: Maybe<Bank_Factsheets_Mutation_Response>;
  /** update single row of the table: "bank_factsheets" */
  update_bank_factsheets_by_pk?: Maybe<Bank_Factsheets>;
  /** update data of the table: "banks" */
  update_banks?: Maybe<Banks_Mutation_Response>;
  /** update single row of the table: "banks" */
  update_banks_by_pk?: Maybe<Banks>;
  /** update data of the table: "business_unit_bank_exposure_limits" */
  update_business_unit_bank_exposure_limits?: Maybe<Business_Unit_Bank_Exposure_Limits_Mutation_Response>;
  /** update single row of the table: "business_unit_bank_exposure_limits" */
  update_business_unit_bank_exposure_limits_by_pk?: Maybe<Business_Unit_Bank_Exposure_Limits>;
  /** update data of the table: "business_unit_liquidity_limits" */
  update_business_unit_liquidity_limits?: Maybe<Business_Unit_Liquidity_Limits_Mutation_Response>;
  /** update single row of the table: "business_unit_liquidity_limits" */
  update_business_unit_liquidity_limits_by_pk?: Maybe<Business_Unit_Liquidity_Limits>;
  /** update data of the table: "business_units" */
  update_business_units?: Maybe<Business_Units_Mutation_Response>;
  /** update single row of the table: "business_units" */
  update_business_units_by_pk?: Maybe<Business_Units>;
  /** update data of the table: "currencies" */
  update_currencies?: Maybe<Currencies_Mutation_Response>;
  /** update single row of the table: "currencies" */
  update_currencies_by_pk?: Maybe<Currencies>;
  /** update data of the table: "currency_book_bank_exposure_limits" */
  update_currency_book_bank_exposure_limits?: Maybe<Currency_Book_Bank_Exposure_Limits_Mutation_Response>;
  /** update single row of the table: "currency_book_bank_exposure_limits" */
  update_currency_book_bank_exposure_limits_by_pk?: Maybe<Currency_Book_Bank_Exposure_Limits>;
  /** update data of the table: "currency_book_liquidity_limits" */
  update_currency_book_liquidity_limits?: Maybe<Currency_Book_Liquidity_Limits_Mutation_Response>;
  /** update single row of the table: "currency_book_liquidity_limits" */
  update_currency_book_liquidity_limits_by_pk?: Maybe<Currency_Book_Liquidity_Limits>;
  /** update data of the table: "currency_books" */
  update_currency_books?: Maybe<Currency_Books_Mutation_Response>;
  /** update single row of the table: "currency_books" */
  update_currency_books_by_pk?: Maybe<Currency_Books>;
  /** update data of the table: "model_balances" */
  update_model_balances?: Maybe<Model_Balances_Mutation_Response>;
  /** update single row of the table: "model_balances" */
  update_model_balances_by_pk?: Maybe<Model_Balances>;
  /** update data of the table: "models" */
  update_models?: Maybe<Models_Mutation_Response>;
  /** update single row of the table: "models" */
  update_models_by_pk?: Maybe<Models>;
  /** update data of the table: "organisation_bank_exposure_limits" */
  update_organisation_bank_exposure_limits?: Maybe<Organisation_Bank_Exposure_Limits_Mutation_Response>;
  /** update single row of the table: "organisation_bank_exposure_limits" */
  update_organisation_bank_exposure_limits_by_pk?: Maybe<Organisation_Bank_Exposure_Limits>;
  /** update data of the table: "organisation_banks" */
  update_organisation_banks?: Maybe<Organisation_Banks_Mutation_Response>;
  /** update single row of the table: "organisation_banks" */
  update_organisation_banks_by_pk?: Maybe<Organisation_Banks>;
  /** update data of the table: "organisation_liquidity_limits" */
  update_organisation_liquidity_limits?: Maybe<Organisation_Liquidity_Limits_Mutation_Response>;
  /** update single row of the table: "organisation_liquidity_limits" */
  update_organisation_liquidity_limits_by_pk?: Maybe<Organisation_Liquidity_Limits>;
  /** update data of the table: "organisation_reports" */
  update_organisation_reports?: Maybe<Organisation_Reports_Mutation_Response>;
  /** update single row of the table: "organisation_reports" */
  update_organisation_reports_by_pk?: Maybe<Organisation_Reports>;
  /** update data of the table: "organisation_research" */
  update_organisation_research?: Maybe<Organisation_Research_Mutation_Response>;
  /** update single row of the table: "organisation_research" */
  update_organisation_research_by_pk?: Maybe<Organisation_Research>;
  /** update data of the table: "organisation_users" */
  update_organisation_users?: Maybe<Organisation_Users_Mutation_Response>;
  /** update single row of the table: "organisation_users" */
  update_organisation_users_by_pk?: Maybe<Organisation_Users>;
  /** update data of the table: "organisations" */
  update_organisations?: Maybe<Organisations_Mutation_Response>;
  /** update single row of the table: "organisations" */
  update_organisations_by_pk?: Maybe<Organisations>;
  /** update data of the table: "product_types_enum" */
  update_product_types_enum?: Maybe<Product_Types_Enum_Mutation_Response>;
  /** update single row of the table: "product_types_enum" */
  update_product_types_enum_by_pk?: Maybe<Product_Types_Enum>;
  /** update data of the table: "research" */
  update_research?: Maybe<Research_Mutation_Response>;
  /** update single row of the table: "research" */
  update_research_by_pk?: Maybe<Research>;
  /** update data of the table: "uploads" */
  update_uploads?: Maybe<Uploads_Mutation_Response>;
  /** update single row of the table: "uploads" */
  update_uploads_by_pk?: Maybe<Uploads>;
};

/** mutation root */
export type Mutation_RootDelete_Actual_BalancesArgs = {
  where: Actual_Balances_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Actual_Balances_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_App_UsersArgs = {
  where: App_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_App_Users_By_PkArgs = {
  id: Scalars["String"];
};

/** mutation root */
export type Mutation_RootDelete_Bank_AccountsArgs = {
  where: Bank_Accounts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Bank_Accounts_By_PkArgs = {
  account_id: Scalars["String"];
};

/** mutation root */
export type Mutation_RootDelete_Bank_FactsheetsArgs = {
  where: Bank_Factsheets_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Bank_Factsheets_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_BanksArgs = {
  where: Banks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Banks_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Business_Unit_Bank_Exposure_LimitsArgs = {
  where: Business_Unit_Bank_Exposure_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Business_Unit_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Business_Unit_Liquidity_LimitsArgs = {
  where: Business_Unit_Liquidity_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Business_Unit_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Business_UnitsArgs = {
  where: Business_Units_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Business_Units_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_CurrenciesArgs = {
  where: Currencies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Currencies_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Currency_Book_Bank_Exposure_LimitsArgs = {
  where: Currency_Book_Bank_Exposure_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Currency_Book_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Currency_Book_Liquidity_LimitsArgs = {
  where: Currency_Book_Liquidity_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Currency_Book_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Currency_BooksArgs = {
  where: Currency_Books_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Currency_Books_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Model_BalancesArgs = {
  where: Model_Balances_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Model_Balances_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_ModelsArgs = {
  where: Models_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Models_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Bank_Exposure_LimitsArgs = {
  where: Organisation_Bank_Exposure_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Organisation_BanksArgs = {
  where: Organisation_Banks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Banks_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Liquidity_LimitsArgs = {
  where: Organisation_Liquidity_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Organisation_ReportsArgs = {
  where: Organisation_Reports_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Reports_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Organisation_ResearchArgs = {
  where: Organisation_Research_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Research_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Organisation_UsersArgs = {
  where: Organisation_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organisation_Users_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_OrganisationsArgs = {
  where: Organisations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Organisations_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_Product_Types_EnumArgs = {
  where: Product_Types_Enum_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Product_Types_Enum_By_PkArgs = {
  id: Scalars["String"];
};

/** mutation root */
export type Mutation_RootDelete_ResearchArgs = {
  where: Research_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Research_By_PkArgs = {
  id: Scalars["Int"];
};

/** mutation root */
export type Mutation_RootDelete_UploadsArgs = {
  where: Uploads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootDelete_Uploads_By_PkArgs = {
  id: Scalars["uuid"];
};

/** mutation root */
export type Mutation_RootInsert_Actual_BalancesArgs = {
  objects: Array<Actual_Balances_Insert_Input>;
  on_conflict?: Maybe<Actual_Balances_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Actual_Balances_OneArgs = {
  object: Actual_Balances_Insert_Input;
  on_conflict?: Maybe<Actual_Balances_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_App_UsersArgs = {
  objects: Array<App_Users_Insert_Input>;
  on_conflict?: Maybe<App_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_App_Users_OneArgs = {
  object: App_Users_Insert_Input;
  on_conflict?: Maybe<App_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Bank_AccountsArgs = {
  objects: Array<Bank_Accounts_Insert_Input>;
  on_conflict?: Maybe<Bank_Accounts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Bank_Accounts_OneArgs = {
  object: Bank_Accounts_Insert_Input;
  on_conflict?: Maybe<Bank_Accounts_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Bank_FactsheetsArgs = {
  objects: Array<Bank_Factsheets_Insert_Input>;
  on_conflict?: Maybe<Bank_Factsheets_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Bank_Factsheets_OneArgs = {
  object: Bank_Factsheets_Insert_Input;
  on_conflict?: Maybe<Bank_Factsheets_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_BanksArgs = {
  objects: Array<Banks_Insert_Input>;
  on_conflict?: Maybe<Banks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Banks_OneArgs = {
  object: Banks_Insert_Input;
  on_conflict?: Maybe<Banks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Business_Unit_Bank_Exposure_LimitsArgs = {
  objects: Array<Business_Unit_Bank_Exposure_Limits_Insert_Input>;
  on_conflict?: Maybe<Business_Unit_Bank_Exposure_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Business_Unit_Bank_Exposure_Limits_OneArgs = {
  object: Business_Unit_Bank_Exposure_Limits_Insert_Input;
  on_conflict?: Maybe<Business_Unit_Bank_Exposure_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Business_Unit_Liquidity_LimitsArgs = {
  objects: Array<Business_Unit_Liquidity_Limits_Insert_Input>;
  on_conflict?: Maybe<Business_Unit_Liquidity_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Business_Unit_Liquidity_Limits_OneArgs = {
  object: Business_Unit_Liquidity_Limits_Insert_Input;
  on_conflict?: Maybe<Business_Unit_Liquidity_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Business_UnitsArgs = {
  objects: Array<Business_Units_Insert_Input>;
  on_conflict?: Maybe<Business_Units_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Business_Units_OneArgs = {
  object: Business_Units_Insert_Input;
  on_conflict?: Maybe<Business_Units_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_CurrenciesArgs = {
  objects: Array<Currencies_Insert_Input>;
  on_conflict?: Maybe<Currencies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Currencies_OneArgs = {
  object: Currencies_Insert_Input;
  on_conflict?: Maybe<Currencies_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Currency_Book_Bank_Exposure_LimitsArgs = {
  objects: Array<Currency_Book_Bank_Exposure_Limits_Insert_Input>;
  on_conflict?: Maybe<Currency_Book_Bank_Exposure_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Currency_Book_Bank_Exposure_Limits_OneArgs = {
  object: Currency_Book_Bank_Exposure_Limits_Insert_Input;
  on_conflict?: Maybe<Currency_Book_Bank_Exposure_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Currency_Book_Liquidity_LimitsArgs = {
  objects: Array<Currency_Book_Liquidity_Limits_Insert_Input>;
  on_conflict?: Maybe<Currency_Book_Liquidity_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Currency_Book_Liquidity_Limits_OneArgs = {
  object: Currency_Book_Liquidity_Limits_Insert_Input;
  on_conflict?: Maybe<Currency_Book_Liquidity_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Currency_BooksArgs = {
  objects: Array<Currency_Books_Insert_Input>;
  on_conflict?: Maybe<Currency_Books_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Currency_Books_OneArgs = {
  object: Currency_Books_Insert_Input;
  on_conflict?: Maybe<Currency_Books_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Model_BalancesArgs = {
  objects: Array<Model_Balances_Insert_Input>;
  on_conflict?: Maybe<Model_Balances_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Model_Balances_OneArgs = {
  object: Model_Balances_Insert_Input;
  on_conflict?: Maybe<Model_Balances_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ModelsArgs = {
  objects: Array<Models_Insert_Input>;
  on_conflict?: Maybe<Models_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Models_OneArgs = {
  object: Models_Insert_Input;
  on_conflict?: Maybe<Models_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Bank_Exposure_LimitsArgs = {
  objects: Array<Organisation_Bank_Exposure_Limits_Insert_Input>;
  on_conflict?: Maybe<Organisation_Bank_Exposure_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Bank_Exposure_Limits_OneArgs = {
  object: Organisation_Bank_Exposure_Limits_Insert_Input;
  on_conflict?: Maybe<Organisation_Bank_Exposure_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_BanksArgs = {
  objects: Array<Organisation_Banks_Insert_Input>;
  on_conflict?: Maybe<Organisation_Banks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Banks_OneArgs = {
  object: Organisation_Banks_Insert_Input;
  on_conflict?: Maybe<Organisation_Banks_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Liquidity_LimitsArgs = {
  objects: Array<Organisation_Liquidity_Limits_Insert_Input>;
  on_conflict?: Maybe<Organisation_Liquidity_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Liquidity_Limits_OneArgs = {
  object: Organisation_Liquidity_Limits_Insert_Input;
  on_conflict?: Maybe<Organisation_Liquidity_Limits_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_ReportsArgs = {
  objects: Array<Organisation_Reports_Insert_Input>;
  on_conflict?: Maybe<Organisation_Reports_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Reports_OneArgs = {
  object: Organisation_Reports_Insert_Input;
  on_conflict?: Maybe<Organisation_Reports_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_ResearchArgs = {
  objects: Array<Organisation_Research_Insert_Input>;
  on_conflict?: Maybe<Organisation_Research_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Research_OneArgs = {
  object: Organisation_Research_Insert_Input;
  on_conflict?: Maybe<Organisation_Research_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_UsersArgs = {
  objects: Array<Organisation_Users_Insert_Input>;
  on_conflict?: Maybe<Organisation_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisation_Users_OneArgs = {
  object: Organisation_Users_Insert_Input;
  on_conflict?: Maybe<Organisation_Users_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_OrganisationsArgs = {
  objects: Array<Organisations_Insert_Input>;
  on_conflict?: Maybe<Organisations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Organisations_OneArgs = {
  object: Organisations_Insert_Input;
  on_conflict?: Maybe<Organisations_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Product_Types_EnumArgs = {
  objects: Array<Product_Types_Enum_Insert_Input>;
  on_conflict?: Maybe<Product_Types_Enum_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Product_Types_Enum_OneArgs = {
  object: Product_Types_Enum_Insert_Input;
  on_conflict?: Maybe<Product_Types_Enum_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_ResearchArgs = {
  objects: Array<Research_Insert_Input>;
  on_conflict?: Maybe<Research_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Research_OneArgs = {
  object: Research_Insert_Input;
  on_conflict?: Maybe<Research_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_UploadsArgs = {
  objects: Array<Uploads_Insert_Input>;
  on_conflict?: Maybe<Uploads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootInsert_Uploads_OneArgs = {
  object: Uploads_Insert_Input;
  on_conflict?: Maybe<Uploads_On_Conflict>;
};

/** mutation root */
export type Mutation_RootUpdate_Actual_BalancesArgs = {
  _inc?: Maybe<Actual_Balances_Inc_Input>;
  _set?: Maybe<Actual_Balances_Set_Input>;
  where: Actual_Balances_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Actual_Balances_By_PkArgs = {
  _inc?: Maybe<Actual_Balances_Inc_Input>;
  _set?: Maybe<Actual_Balances_Set_Input>;
  pk_columns: Actual_Balances_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_App_UsersArgs = {
  _inc?: Maybe<App_Users_Inc_Input>;
  _set?: Maybe<App_Users_Set_Input>;
  where: App_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_App_Users_By_PkArgs = {
  _inc?: Maybe<App_Users_Inc_Input>;
  _set?: Maybe<App_Users_Set_Input>;
  pk_columns: App_Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Bank_AccountsArgs = {
  _inc?: Maybe<Bank_Accounts_Inc_Input>;
  _set?: Maybe<Bank_Accounts_Set_Input>;
  where: Bank_Accounts_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Bank_Accounts_By_PkArgs = {
  _inc?: Maybe<Bank_Accounts_Inc_Input>;
  _set?: Maybe<Bank_Accounts_Set_Input>;
  pk_columns: Bank_Accounts_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Bank_FactsheetsArgs = {
  _inc?: Maybe<Bank_Factsheets_Inc_Input>;
  _set?: Maybe<Bank_Factsheets_Set_Input>;
  where: Bank_Factsheets_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Bank_Factsheets_By_PkArgs = {
  _inc?: Maybe<Bank_Factsheets_Inc_Input>;
  _set?: Maybe<Bank_Factsheets_Set_Input>;
  pk_columns: Bank_Factsheets_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_BanksArgs = {
  _inc?: Maybe<Banks_Inc_Input>;
  _set?: Maybe<Banks_Set_Input>;
  where: Banks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Banks_By_PkArgs = {
  _inc?: Maybe<Banks_Inc_Input>;
  _set?: Maybe<Banks_Set_Input>;
  pk_columns: Banks_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Business_Unit_Bank_Exposure_LimitsArgs = {
  _inc?: Maybe<Business_Unit_Bank_Exposure_Limits_Inc_Input>;
  _set?: Maybe<Business_Unit_Bank_Exposure_Limits_Set_Input>;
  where: Business_Unit_Bank_Exposure_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Business_Unit_Bank_Exposure_Limits_By_PkArgs = {
  _inc?: Maybe<Business_Unit_Bank_Exposure_Limits_Inc_Input>;
  _set?: Maybe<Business_Unit_Bank_Exposure_Limits_Set_Input>;
  pk_columns: Business_Unit_Bank_Exposure_Limits_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Business_Unit_Liquidity_LimitsArgs = {
  _inc?: Maybe<Business_Unit_Liquidity_Limits_Inc_Input>;
  _set?: Maybe<Business_Unit_Liquidity_Limits_Set_Input>;
  where: Business_Unit_Liquidity_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Business_Unit_Liquidity_Limits_By_PkArgs = {
  _inc?: Maybe<Business_Unit_Liquidity_Limits_Inc_Input>;
  _set?: Maybe<Business_Unit_Liquidity_Limits_Set_Input>;
  pk_columns: Business_Unit_Liquidity_Limits_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Business_UnitsArgs = {
  _inc?: Maybe<Business_Units_Inc_Input>;
  _set?: Maybe<Business_Units_Set_Input>;
  where: Business_Units_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Business_Units_By_PkArgs = {
  _inc?: Maybe<Business_Units_Inc_Input>;
  _set?: Maybe<Business_Units_Set_Input>;
  pk_columns: Business_Units_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_CurrenciesArgs = {
  _inc?: Maybe<Currencies_Inc_Input>;
  _set?: Maybe<Currencies_Set_Input>;
  where: Currencies_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Currencies_By_PkArgs = {
  _inc?: Maybe<Currencies_Inc_Input>;
  _set?: Maybe<Currencies_Set_Input>;
  pk_columns: Currencies_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Currency_Book_Bank_Exposure_LimitsArgs = {
  _inc?: Maybe<Currency_Book_Bank_Exposure_Limits_Inc_Input>;
  _set?: Maybe<Currency_Book_Bank_Exposure_Limits_Set_Input>;
  where: Currency_Book_Bank_Exposure_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Currency_Book_Bank_Exposure_Limits_By_PkArgs = {
  _inc?: Maybe<Currency_Book_Bank_Exposure_Limits_Inc_Input>;
  _set?: Maybe<Currency_Book_Bank_Exposure_Limits_Set_Input>;
  pk_columns: Currency_Book_Bank_Exposure_Limits_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Currency_Book_Liquidity_LimitsArgs = {
  _inc?: Maybe<Currency_Book_Liquidity_Limits_Inc_Input>;
  _set?: Maybe<Currency_Book_Liquidity_Limits_Set_Input>;
  where: Currency_Book_Liquidity_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Currency_Book_Liquidity_Limits_By_PkArgs = {
  _inc?: Maybe<Currency_Book_Liquidity_Limits_Inc_Input>;
  _set?: Maybe<Currency_Book_Liquidity_Limits_Set_Input>;
  pk_columns: Currency_Book_Liquidity_Limits_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Currency_BooksArgs = {
  _inc?: Maybe<Currency_Books_Inc_Input>;
  _set?: Maybe<Currency_Books_Set_Input>;
  where: Currency_Books_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Currency_Books_By_PkArgs = {
  _inc?: Maybe<Currency_Books_Inc_Input>;
  _set?: Maybe<Currency_Books_Set_Input>;
  pk_columns: Currency_Books_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Model_BalancesArgs = {
  _inc?: Maybe<Model_Balances_Inc_Input>;
  _set?: Maybe<Model_Balances_Set_Input>;
  where: Model_Balances_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Model_Balances_By_PkArgs = {
  _inc?: Maybe<Model_Balances_Inc_Input>;
  _set?: Maybe<Model_Balances_Set_Input>;
  pk_columns: Model_Balances_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_ModelsArgs = {
  _inc?: Maybe<Models_Inc_Input>;
  _set?: Maybe<Models_Set_Input>;
  where: Models_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Models_By_PkArgs = {
  _inc?: Maybe<Models_Inc_Input>;
  _set?: Maybe<Models_Set_Input>;
  pk_columns: Models_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Bank_Exposure_LimitsArgs = {
  _inc?: Maybe<Organisation_Bank_Exposure_Limits_Inc_Input>;
  _set?: Maybe<Organisation_Bank_Exposure_Limits_Set_Input>;
  where: Organisation_Bank_Exposure_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Bank_Exposure_Limits_By_PkArgs = {
  _inc?: Maybe<Organisation_Bank_Exposure_Limits_Inc_Input>;
  _set?: Maybe<Organisation_Bank_Exposure_Limits_Set_Input>;
  pk_columns: Organisation_Bank_Exposure_Limits_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_BanksArgs = {
  _inc?: Maybe<Organisation_Banks_Inc_Input>;
  _set?: Maybe<Organisation_Banks_Set_Input>;
  where: Organisation_Banks_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Banks_By_PkArgs = {
  _inc?: Maybe<Organisation_Banks_Inc_Input>;
  _set?: Maybe<Organisation_Banks_Set_Input>;
  pk_columns: Organisation_Banks_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Liquidity_LimitsArgs = {
  _inc?: Maybe<Organisation_Liquidity_Limits_Inc_Input>;
  _set?: Maybe<Organisation_Liquidity_Limits_Set_Input>;
  where: Organisation_Liquidity_Limits_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Liquidity_Limits_By_PkArgs = {
  _inc?: Maybe<Organisation_Liquidity_Limits_Inc_Input>;
  _set?: Maybe<Organisation_Liquidity_Limits_Set_Input>;
  pk_columns: Organisation_Liquidity_Limits_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_ReportsArgs = {
  _inc?: Maybe<Organisation_Reports_Inc_Input>;
  _set?: Maybe<Organisation_Reports_Set_Input>;
  where: Organisation_Reports_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Reports_By_PkArgs = {
  _inc?: Maybe<Organisation_Reports_Inc_Input>;
  _set?: Maybe<Organisation_Reports_Set_Input>;
  pk_columns: Organisation_Reports_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_ResearchArgs = {
  _inc?: Maybe<Organisation_Research_Inc_Input>;
  _set?: Maybe<Organisation_Research_Set_Input>;
  where: Organisation_Research_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Research_By_PkArgs = {
  _inc?: Maybe<Organisation_Research_Inc_Input>;
  _set?: Maybe<Organisation_Research_Set_Input>;
  pk_columns: Organisation_Research_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_UsersArgs = {
  _inc?: Maybe<Organisation_Users_Inc_Input>;
  _set?: Maybe<Organisation_Users_Set_Input>;
  where: Organisation_Users_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organisation_Users_By_PkArgs = {
  _inc?: Maybe<Organisation_Users_Inc_Input>;
  _set?: Maybe<Organisation_Users_Set_Input>;
  pk_columns: Organisation_Users_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_OrganisationsArgs = {
  _inc?: Maybe<Organisations_Inc_Input>;
  _set?: Maybe<Organisations_Set_Input>;
  where: Organisations_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Organisations_By_PkArgs = {
  _inc?: Maybe<Organisations_Inc_Input>;
  _set?: Maybe<Organisations_Set_Input>;
  pk_columns: Organisations_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_Product_Types_EnumArgs = {
  _set?: Maybe<Product_Types_Enum_Set_Input>;
  where: Product_Types_Enum_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Product_Types_Enum_By_PkArgs = {
  _set?: Maybe<Product_Types_Enum_Set_Input>;
  pk_columns: Product_Types_Enum_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_ResearchArgs = {
  _inc?: Maybe<Research_Inc_Input>;
  _set?: Maybe<Research_Set_Input>;
  where: Research_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Research_By_PkArgs = {
  _inc?: Maybe<Research_Inc_Input>;
  _set?: Maybe<Research_Set_Input>;
  pk_columns: Research_Pk_Columns_Input;
};

/** mutation root */
export type Mutation_RootUpdate_UploadsArgs = {
  _set?: Maybe<Uploads_Set_Input>;
  where: Uploads_Bool_Exp;
};

/** mutation root */
export type Mutation_RootUpdate_Uploads_By_PkArgs = {
  _set?: Maybe<Uploads_Set_Input>;
  pk_columns: Uploads_Pk_Columns_Input;
};

/** expression to compare columns of type numeric. All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars["numeric"]>;
  _gt?: Maybe<Scalars["numeric"]>;
  _gte?: Maybe<Scalars["numeric"]>;
  _in?: Maybe<Array<Scalars["numeric"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _lt?: Maybe<Scalars["numeric"]>;
  _lte?: Maybe<Scalars["numeric"]>;
  _neq?: Maybe<Scalars["numeric"]>;
  _nin?: Maybe<Array<Scalars["numeric"]>>;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = "asc",
  /** in the ascending order, nulls first */
  AscNullsFirst = "asc_nulls_first",
  /** in the ascending order, nulls last */
  AscNullsLast = "asc_nulls_last",
  /** in the descending order, nulls first */
  Desc = "desc",
  /** in the descending order, nulls first */
  DescNullsFirst = "desc_nulls_first",
  /** in the descending order, nulls last */
  DescNullsLast = "desc_nulls_last",
}

/** columns and relationships of "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits = {
  __typename?: "organisation_bank_exposure_limits";
  /** An object relationship */
  bank: Banks;
  bank_id: Scalars["Int"];
  created_at: Scalars["timestamptz"];
  exposure_limit: Scalars["numeric"];
  id: Scalars["Int"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
};

/** aggregated selection of "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Aggregate = {
  __typename?: "organisation_bank_exposure_limits_aggregate";
  aggregate?: Maybe<Organisation_Bank_Exposure_Limits_Aggregate_Fields>;
  nodes: Array<Organisation_Bank_Exposure_Limits>;
};

/** aggregate fields of "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Aggregate_Fields = {
  __typename?: "organisation_bank_exposure_limits_aggregate_fields";
  avg?: Maybe<Organisation_Bank_Exposure_Limits_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Organisation_Bank_Exposure_Limits_Max_Fields>;
  min?: Maybe<Organisation_Bank_Exposure_Limits_Min_Fields>;
  stddev?: Maybe<Organisation_Bank_Exposure_Limits_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Bank_Exposure_Limits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Bank_Exposure_Limits_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Bank_Exposure_Limits_Sum_Fields>;
  var_pop?: Maybe<Organisation_Bank_Exposure_Limits_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Bank_Exposure_Limits_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Bank_Exposure_Limits_Variance_Fields>;
};

/** aggregate fields of "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Aggregate_Order_By = {
  avg?: Maybe<Organisation_Bank_Exposure_Limits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Organisation_Bank_Exposure_Limits_Max_Order_By>;
  min?: Maybe<Organisation_Bank_Exposure_Limits_Min_Order_By>;
  stddev?: Maybe<Organisation_Bank_Exposure_Limits_Stddev_Order_By>;
  stddev_pop?: Maybe<Organisation_Bank_Exposure_Limits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Organisation_Bank_Exposure_Limits_Stddev_Samp_Order_By>;
  sum?: Maybe<Organisation_Bank_Exposure_Limits_Sum_Order_By>;
  var_pop?: Maybe<Organisation_Bank_Exposure_Limits_Var_Pop_Order_By>;
  var_samp?: Maybe<Organisation_Bank_Exposure_Limits_Var_Samp_Order_By>;
  variance?: Maybe<Organisation_Bank_Exposure_Limits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Bank_Exposure_Limits_Insert_Input>;
  on_conflict?: Maybe<Organisation_Bank_Exposure_Limits_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Bank_Exposure_Limits_Avg_Fields = {
  __typename?: "organisation_bank_exposure_limits_avg_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Avg_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/**
 * Boolean expression to filter rows from the table
 * "organisation_bank_exposure_limits". All fields are combined with a logical 'AND'.
 */
export type Organisation_Bank_Exposure_Limits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>>>;
  _not?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>>>;
  bank?: Maybe<Banks_Bool_Exp>;
  bank_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  exposure_limit?: Maybe<Numeric_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_bank_exposure_limits" */
export enum Organisation_Bank_Exposure_Limits_Constraint {
  /** unique or primary key constraint */
  OrganisationBankExposureLimitPkey = "OrganisationBankExposureLimit_pkey",
  /** unique or primary key constraint */
  OrganisationBankExposureLimitsOrganisationIdBankIdKey = "organisation_bank_exposure_limits_organisation_id_bank_id_key",
}

/** input type for incrementing integer column in table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Inc_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Insert_Input = {
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type Organisation_Bank_Exposure_Limits_Max_Fields = {
  __typename?: "organisation_bank_exposure_limits_max_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Max_Order_By = {
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Bank_Exposure_Limits_Min_Fields = {
  __typename?: "organisation_bank_exposure_limits_min_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Min_Order_By = {
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Mutation_Response = {
  __typename?: "organisation_bank_exposure_limits_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Organisation_Bank_Exposure_Limits>;
};

/** input type for inserting object relation for remote table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Obj_Rel_Insert_Input = {
  data: Organisation_Bank_Exposure_Limits_Insert_Input;
  on_conflict?: Maybe<Organisation_Bank_Exposure_Limits_On_Conflict>;
};

/** on conflict condition type for table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_On_Conflict = {
  constraint: Organisation_Bank_Exposure_Limits_Constraint;
  update_columns: Array<Organisation_Bank_Exposure_Limits_Update_Column>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** ordering options when selecting data from "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Order_By = {
  bank?: Maybe<Banks_Order_By>;
  bank_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "organisation_bank_exposure_limits" */
export enum Organisation_Bank_Exposure_Limits_Select_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExposureLimit = "exposure_limit",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
}

/** input type for updating data in table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Set_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  exposure_limit?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type Organisation_Bank_Exposure_Limits_Stddev_Fields = {
  __typename?: "organisation_bank_exposure_limits_stddev_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Stddev_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Bank_Exposure_Limits_Stddev_Pop_Fields = {
  __typename?: "organisation_bank_exposure_limits_stddev_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Stddev_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Bank_Exposure_Limits_Stddev_Samp_Fields = {
  __typename?: "organisation_bank_exposure_limits_stddev_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Stddev_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Organisation_Bank_Exposure_Limits_Sum_Fields = {
  __typename?: "organisation_bank_exposure_limits_sum_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  exposure_limit?: Maybe<Scalars["numeric"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Sum_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** update columns of table "organisation_bank_exposure_limits" */
export enum Organisation_Bank_Exposure_Limits_Update_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  ExposureLimit = "exposure_limit",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
}

/** aggregate var_pop on columns */
export type Organisation_Bank_Exposure_Limits_Var_Pop_Fields = {
  __typename?: "organisation_bank_exposure_limits_var_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Var_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Bank_Exposure_Limits_Var_Samp_Fields = {
  __typename?: "organisation_bank_exposure_limits_var_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Var_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Bank_Exposure_Limits_Variance_Fields = {
  __typename?: "organisation_bank_exposure_limits_variance_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  exposure_limit?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "organisation_bank_exposure_limits" */
export type Organisation_Bank_Exposure_Limits_Variance_Order_By = {
  bank_id?: Maybe<Order_By>;
  exposure_limit?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** columns and relationships of "organisation_banks" */
export type Organisation_Banks = {
  __typename?: "organisation_banks";
  /** An object relationship */
  bank: Banks;
  bank_id: Scalars["Int"];
  id: Scalars["Int"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
};

/** aggregated selection of "organisation_banks" */
export type Organisation_Banks_Aggregate = {
  __typename?: "organisation_banks_aggregate";
  aggregate?: Maybe<Organisation_Banks_Aggregate_Fields>;
  nodes: Array<Organisation_Banks>;
};

/** aggregate fields of "organisation_banks" */
export type Organisation_Banks_Aggregate_Fields = {
  __typename?: "organisation_banks_aggregate_fields";
  avg?: Maybe<Organisation_Banks_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Organisation_Banks_Max_Fields>;
  min?: Maybe<Organisation_Banks_Min_Fields>;
  stddev?: Maybe<Organisation_Banks_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Banks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Banks_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Banks_Sum_Fields>;
  var_pop?: Maybe<Organisation_Banks_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Banks_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Banks_Variance_Fields>;
};

/** aggregate fields of "organisation_banks" */
export type Organisation_Banks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organisation_Banks_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "organisation_banks" */
export type Organisation_Banks_Aggregate_Order_By = {
  avg?: Maybe<Organisation_Banks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Organisation_Banks_Max_Order_By>;
  min?: Maybe<Organisation_Banks_Min_Order_By>;
  stddev?: Maybe<Organisation_Banks_Stddev_Order_By>;
  stddev_pop?: Maybe<Organisation_Banks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Organisation_Banks_Stddev_Samp_Order_By>;
  sum?: Maybe<Organisation_Banks_Sum_Order_By>;
  var_pop?: Maybe<Organisation_Banks_Var_Pop_Order_By>;
  var_samp?: Maybe<Organisation_Banks_Var_Samp_Order_By>;
  variance?: Maybe<Organisation_Banks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_banks" */
export type Organisation_Banks_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Banks_Insert_Input>;
  on_conflict?: Maybe<Organisation_Banks_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Banks_Avg_Fields = {
  __typename?: "organisation_banks_avg_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "organisation_banks" */
export type Organisation_Banks_Avg_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_banks". All fields are combined with a logical 'AND'. */
export type Organisation_Banks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organisation_Banks_Bool_Exp>>>;
  _not?: Maybe<Organisation_Banks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organisation_Banks_Bool_Exp>>>;
  bank?: Maybe<Banks_Bool_Exp>;
  bank_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_banks" */
export enum Organisation_Banks_Constraint {
  /** unique or primary key constraint */
  OrganisationBanksPkey = "OrganisationBanks_pkey",
}

/** input type for incrementing integer column in table "organisation_banks" */
export type Organisation_Banks_Inc_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "organisation_banks" */
export type Organisation_Banks_Insert_Input = {
  bank?: Maybe<Banks_Obj_Rel_Insert_Input>;
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type Organisation_Banks_Max_Fields = {
  __typename?: "organisation_banks_max_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "organisation_banks" */
export type Organisation_Banks_Max_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Banks_Min_Fields = {
  __typename?: "organisation_banks_min_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "organisation_banks" */
export type Organisation_Banks_Min_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "organisation_banks" */
export type Organisation_Banks_Mutation_Response = {
  __typename?: "organisation_banks_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Organisation_Banks>;
};

/** input type for inserting object relation for remote table "organisation_banks" */
export type Organisation_Banks_Obj_Rel_Insert_Input = {
  data: Organisation_Banks_Insert_Input;
  on_conflict?: Maybe<Organisation_Banks_On_Conflict>;
};

/** on conflict condition type for table "organisation_banks" */
export type Organisation_Banks_On_Conflict = {
  constraint: Organisation_Banks_Constraint;
  update_columns: Array<Organisation_Banks_Update_Column>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** ordering options when selecting data from "organisation_banks" */
export type Organisation_Banks_Order_By = {
  bank?: Maybe<Banks_Order_By>;
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "organisation_banks" */
export type Organisation_Banks_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "organisation_banks" */
export enum Organisation_Banks_Select_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
}

/** input type for updating data in table "organisation_banks" */
export type Organisation_Banks_Set_Input = {
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type Organisation_Banks_Stddev_Fields = {
  __typename?: "organisation_banks_stddev_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "organisation_banks" */
export type Organisation_Banks_Stddev_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Banks_Stddev_Pop_Fields = {
  __typename?: "organisation_banks_stddev_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "organisation_banks" */
export type Organisation_Banks_Stddev_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Banks_Stddev_Samp_Fields = {
  __typename?: "organisation_banks_stddev_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "organisation_banks" */
export type Organisation_Banks_Stddev_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Organisation_Banks_Sum_Fields = {
  __typename?: "organisation_banks_sum_fields";
  bank_id?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "organisation_banks" */
export type Organisation_Banks_Sum_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** update columns of table "organisation_banks" */
export enum Organisation_Banks_Update_Column {
  /** column name */
  BankId = "bank_id",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
}

/** aggregate var_pop on columns */
export type Organisation_Banks_Var_Pop_Fields = {
  __typename?: "organisation_banks_var_pop_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "organisation_banks" */
export type Organisation_Banks_Var_Pop_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Banks_Var_Samp_Fields = {
  __typename?: "organisation_banks_var_samp_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "organisation_banks" */
export type Organisation_Banks_Var_Samp_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Banks_Variance_Fields = {
  __typename?: "organisation_banks_variance_fields";
  bank_id?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "organisation_banks" */
export type Organisation_Banks_Variance_Order_By = {
  bank_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** columns and relationships of "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits = {
  __typename?: "organisation_liquidity_limits";
  id: Scalars["Int"];
  lower_limit_pct: Scalars["numeric"];
  notice_days_gte: Scalars["numeric"];
  notice_days_lt: Scalars["numeric"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
  upper_limit_pct: Scalars["numeric"];
};

/** aggregated selection of "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Aggregate = {
  __typename?: "organisation_liquidity_limits_aggregate";
  aggregate?: Maybe<Organisation_Liquidity_Limits_Aggregate_Fields>;
  nodes: Array<Organisation_Liquidity_Limits>;
};

/** aggregate fields of "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Aggregate_Fields = {
  __typename?: "organisation_liquidity_limits_aggregate_fields";
  avg?: Maybe<Organisation_Liquidity_Limits_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Organisation_Liquidity_Limits_Max_Fields>;
  min?: Maybe<Organisation_Liquidity_Limits_Min_Fields>;
  stddev?: Maybe<Organisation_Liquidity_Limits_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Liquidity_Limits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Liquidity_Limits_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Liquidity_Limits_Sum_Fields>;
  var_pop?: Maybe<Organisation_Liquidity_Limits_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Liquidity_Limits_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Liquidity_Limits_Variance_Fields>;
};

/** aggregate fields of "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organisation_Liquidity_Limits_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Aggregate_Order_By = {
  avg?: Maybe<Organisation_Liquidity_Limits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Organisation_Liquidity_Limits_Max_Order_By>;
  min?: Maybe<Organisation_Liquidity_Limits_Min_Order_By>;
  stddev?: Maybe<Organisation_Liquidity_Limits_Stddev_Order_By>;
  stddev_pop?: Maybe<Organisation_Liquidity_Limits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Organisation_Liquidity_Limits_Stddev_Samp_Order_By>;
  sum?: Maybe<Organisation_Liquidity_Limits_Sum_Order_By>;
  var_pop?: Maybe<Organisation_Liquidity_Limits_Var_Pop_Order_By>;
  var_samp?: Maybe<Organisation_Liquidity_Limits_Var_Samp_Order_By>;
  variance?: Maybe<Organisation_Liquidity_Limits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Liquidity_Limits_Insert_Input>;
  on_conflict?: Maybe<Organisation_Liquidity_Limits_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Liquidity_Limits_Avg_Fields = {
  __typename?: "organisation_liquidity_limits_avg_fields";
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Avg_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/**
 * Boolean expression to filter rows from the table
 * "organisation_liquidity_limits". All fields are combined with a logical 'AND'.
 */
export type Organisation_Liquidity_Limits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organisation_Liquidity_Limits_Bool_Exp>>>;
  _not?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organisation_Liquidity_Limits_Bool_Exp>>>;
  id?: Maybe<Int_Comparison_Exp>;
  lower_limit_pct?: Maybe<Numeric_Comparison_Exp>;
  notice_days_gte?: Maybe<Numeric_Comparison_Exp>;
  notice_days_lt?: Maybe<Numeric_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
  upper_limit_pct?: Maybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_liquidity_limits" */
export enum Organisation_Liquidity_Limits_Constraint {
  /** unique or primary key constraint */
  OrganisationLiquidityLimitsOrganisationIdNoticeDaysLtNo = "organisation_liquidity_limits_organisation_id_notice_days_lt_no",
  /** unique or primary key constraint */
  OrganisationLiquidityLimitsPkey = "organisation_liquidity_limits_pkey",
}

/** input type for incrementing integer column in table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** input type for inserting data into table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Insert_Input = {
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** aggregate max on columns */
export type Organisation_Liquidity_Limits_Max_Fields = {
  __typename?: "organisation_liquidity_limits_max_fields";
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by max() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Max_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Liquidity_Limits_Min_Fields = {
  __typename?: "organisation_liquidity_limits_min_fields";
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by min() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Min_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** response of any mutation on the table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Mutation_Response = {
  __typename?: "organisation_liquidity_limits_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Organisation_Liquidity_Limits>;
};

/** input type for inserting object relation for remote table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Obj_Rel_Insert_Input = {
  data: Organisation_Liquidity_Limits_Insert_Input;
  on_conflict?: Maybe<Organisation_Liquidity_Limits_On_Conflict>;
};

/** on conflict condition type for table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_On_Conflict = {
  constraint: Organisation_Liquidity_Limits_Constraint;
  update_columns: Array<Organisation_Liquidity_Limits_Update_Column>;
  where?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
};

/** ordering options when selecting data from "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** primary key columns input for table: "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "organisation_liquidity_limits" */
export enum Organisation_Liquidity_Limits_Select_Column {
  /** column name */
  Id = "id",
  /** column name */
  LowerLimitPct = "lower_limit_pct",
  /** column name */
  NoticeDaysGte = "notice_days_gte",
  /** column name */
  NoticeDaysLt = "notice_days_lt",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  UpperLimitPct = "upper_limit_pct",
}

/** input type for updating data in table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Set_Input = {
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** aggregate stddev on columns */
export type Organisation_Liquidity_Limits_Stddev_Fields = {
  __typename?: "organisation_liquidity_limits_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Liquidity_Limits_Stddev_Pop_Fields = {
  __typename?: "organisation_liquidity_limits_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Liquidity_Limits_Stddev_Samp_Fields = {
  __typename?: "organisation_liquidity_limits_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Organisation_Liquidity_Limits_Sum_Fields = {
  __typename?: "organisation_liquidity_limits_sum_fields";
  id?: Maybe<Scalars["Int"]>;
  lower_limit_pct?: Maybe<Scalars["numeric"]>;
  notice_days_gte?: Maybe<Scalars["numeric"]>;
  notice_days_lt?: Maybe<Scalars["numeric"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  upper_limit_pct?: Maybe<Scalars["numeric"]>;
};

/** order by sum() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Sum_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** update columns of table "organisation_liquidity_limits" */
export enum Organisation_Liquidity_Limits_Update_Column {
  /** column name */
  Id = "id",
  /** column name */
  LowerLimitPct = "lower_limit_pct",
  /** column name */
  NoticeDaysGte = "notice_days_gte",
  /** column name */
  NoticeDaysLt = "notice_days_lt",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  UpperLimitPct = "upper_limit_pct",
}

/** aggregate var_pop on columns */
export type Organisation_Liquidity_Limits_Var_Pop_Fields = {
  __typename?: "organisation_liquidity_limits_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Liquidity_Limits_Var_Samp_Fields = {
  __typename?: "organisation_liquidity_limits_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Liquidity_Limits_Variance_Fields = {
  __typename?: "organisation_liquidity_limits_variance_fields";
  id?: Maybe<Scalars["Float"]>;
  lower_limit_pct?: Maybe<Scalars["Float"]>;
  notice_days_gte?: Maybe<Scalars["Float"]>;
  notice_days_lt?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  upper_limit_pct?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "organisation_liquidity_limits" */
export type Organisation_Liquidity_Limits_Variance_Order_By = {
  id?: Maybe<Order_By>;
  lower_limit_pct?: Maybe<Order_By>;
  notice_days_gte?: Maybe<Order_By>;
  notice_days_lt?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  upper_limit_pct?: Maybe<Order_By>;
};

/** columns and relationships of "organisation_reports" */
export type Organisation_Reports = {
  __typename?: "organisation_reports";
  archived: Scalars["Boolean"];
  created_at: Scalars["timestamptz"];
  id: Scalars["Int"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
  report_date?: Maybe<Scalars["String"]>;
  report_title?: Maybe<Scalars["String"]>;
  /** An object relationship */
  upload: Uploads;
  upload_id: Scalars["uuid"];
};

/** aggregated selection of "organisation_reports" */
export type Organisation_Reports_Aggregate = {
  __typename?: "organisation_reports_aggregate";
  aggregate?: Maybe<Organisation_Reports_Aggregate_Fields>;
  nodes: Array<Organisation_Reports>;
};

/** aggregate fields of "organisation_reports" */
export type Organisation_Reports_Aggregate_Fields = {
  __typename?: "organisation_reports_aggregate_fields";
  avg?: Maybe<Organisation_Reports_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Organisation_Reports_Max_Fields>;
  min?: Maybe<Organisation_Reports_Min_Fields>;
  stddev?: Maybe<Organisation_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Reports_Sum_Fields>;
  var_pop?: Maybe<Organisation_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Reports_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Reports_Variance_Fields>;
};

/** aggregate fields of "organisation_reports" */
export type Organisation_Reports_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organisation_Reports_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "organisation_reports" */
export type Organisation_Reports_Aggregate_Order_By = {
  avg?: Maybe<Organisation_Reports_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Organisation_Reports_Max_Order_By>;
  min?: Maybe<Organisation_Reports_Min_Order_By>;
  stddev?: Maybe<Organisation_Reports_Stddev_Order_By>;
  stddev_pop?: Maybe<Organisation_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Organisation_Reports_Stddev_Samp_Order_By>;
  sum?: Maybe<Organisation_Reports_Sum_Order_By>;
  var_pop?: Maybe<Organisation_Reports_Var_Pop_Order_By>;
  var_samp?: Maybe<Organisation_Reports_Var_Samp_Order_By>;
  variance?: Maybe<Organisation_Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_reports" */
export type Organisation_Reports_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Reports_Insert_Input>;
  on_conflict?: Maybe<Organisation_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Reports_Avg_Fields = {
  __typename?: "organisation_reports_avg_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "organisation_reports" */
export type Organisation_Reports_Avg_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_reports". All fields are combined with a logical 'AND'. */
export type Organisation_Reports_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organisation_Reports_Bool_Exp>>>;
  _not?: Maybe<Organisation_Reports_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organisation_Reports_Bool_Exp>>>;
  archived?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
  report_date?: Maybe<String_Comparison_Exp>;
  report_title?: Maybe<String_Comparison_Exp>;
  upload?: Maybe<Uploads_Bool_Exp>;
  upload_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_reports" */
export enum Organisation_Reports_Constraint {
  /** unique or primary key constraint */
  OrganisationReportsPkey = "OrganisationReports_pkey",
}

/** input type for incrementing integer column in table "organisation_reports" */
export type Organisation_Reports_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "organisation_reports" */
export type Organisation_Reports_Insert_Input = {
  archived?: Maybe<Scalars["Boolean"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
  report_date?: Maybe<Scalars["String"]>;
  report_title?: Maybe<Scalars["String"]>;
  upload?: Maybe<Uploads_Obj_Rel_Insert_Input>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** aggregate max on columns */
export type Organisation_Reports_Max_Fields = {
  __typename?: "organisation_reports_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  report_date?: Maybe<Scalars["String"]>;
  report_title?: Maybe<Scalars["String"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "organisation_reports" */
export type Organisation_Reports_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  report_date?: Maybe<Order_By>;
  report_title?: Maybe<Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Reports_Min_Fields = {
  __typename?: "organisation_reports_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  report_date?: Maybe<Scalars["String"]>;
  report_title?: Maybe<Scalars["String"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** order by min() on columns of table "organisation_reports" */
export type Organisation_Reports_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  report_date?: Maybe<Order_By>;
  report_title?: Maybe<Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "organisation_reports" */
export type Organisation_Reports_Mutation_Response = {
  __typename?: "organisation_reports_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Organisation_Reports>;
};

/** input type for inserting object relation for remote table "organisation_reports" */
export type Organisation_Reports_Obj_Rel_Insert_Input = {
  data: Organisation_Reports_Insert_Input;
  on_conflict?: Maybe<Organisation_Reports_On_Conflict>;
};

/** on conflict condition type for table "organisation_reports" */
export type Organisation_Reports_On_Conflict = {
  constraint: Organisation_Reports_Constraint;
  update_columns: Array<Organisation_Reports_Update_Column>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** ordering options when selecting data from "organisation_reports" */
export type Organisation_Reports_Order_By = {
  archived?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
  report_date?: Maybe<Order_By>;
  report_title?: Maybe<Order_By>;
  upload?: Maybe<Uploads_Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "organisation_reports" */
export type Organisation_Reports_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "organisation_reports" */
export enum Organisation_Reports_Select_Column {
  /** column name */
  Archived = "archived",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  ReportDate = "report_date",
  /** column name */
  ReportTitle = "report_title",
  /** column name */
  UploadId = "upload_id",
}

/** input type for updating data in table "organisation_reports" */
export type Organisation_Reports_Set_Input = {
  archived?: Maybe<Scalars["Boolean"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  report_date?: Maybe<Scalars["String"]>;
  report_title?: Maybe<Scalars["String"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** aggregate stddev on columns */
export type Organisation_Reports_Stddev_Fields = {
  __typename?: "organisation_reports_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "organisation_reports" */
export type Organisation_Reports_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Reports_Stddev_Pop_Fields = {
  __typename?: "organisation_reports_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "organisation_reports" */
export type Organisation_Reports_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Reports_Stddev_Samp_Fields = {
  __typename?: "organisation_reports_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "organisation_reports" */
export type Organisation_Reports_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Organisation_Reports_Sum_Fields = {
  __typename?: "organisation_reports_sum_fields";
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "organisation_reports" */
export type Organisation_Reports_Sum_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** update columns of table "organisation_reports" */
export enum Organisation_Reports_Update_Column {
  /** column name */
  Archived = "archived",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  ReportDate = "report_date",
  /** column name */
  ReportTitle = "report_title",
  /** column name */
  UploadId = "upload_id",
}

/** aggregate var_pop on columns */
export type Organisation_Reports_Var_Pop_Fields = {
  __typename?: "organisation_reports_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "organisation_reports" */
export type Organisation_Reports_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Reports_Var_Samp_Fields = {
  __typename?: "organisation_reports_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "organisation_reports" */
export type Organisation_Reports_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Reports_Variance_Fields = {
  __typename?: "organisation_reports_variance_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "organisation_reports" */
export type Organisation_Reports_Variance_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** columns and relationships of "organisation_research" */
export type Organisation_Research = {
  __typename?: "organisation_research";
  id: Scalars["Int"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
  /** An object relationship */
  research: Research;
  research_id: Scalars["Int"];
};

/** aggregated selection of "organisation_research" */
export type Organisation_Research_Aggregate = {
  __typename?: "organisation_research_aggregate";
  aggregate?: Maybe<Organisation_Research_Aggregate_Fields>;
  nodes: Array<Organisation_Research>;
};

/** aggregate fields of "organisation_research" */
export type Organisation_Research_Aggregate_Fields = {
  __typename?: "organisation_research_aggregate_fields";
  avg?: Maybe<Organisation_Research_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Organisation_Research_Max_Fields>;
  min?: Maybe<Organisation_Research_Min_Fields>;
  stddev?: Maybe<Organisation_Research_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Research_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Research_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Research_Sum_Fields>;
  var_pop?: Maybe<Organisation_Research_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Research_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Research_Variance_Fields>;
};

/** aggregate fields of "organisation_research" */
export type Organisation_Research_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organisation_Research_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "organisation_research" */
export type Organisation_Research_Aggregate_Order_By = {
  avg?: Maybe<Organisation_Research_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Organisation_Research_Max_Order_By>;
  min?: Maybe<Organisation_Research_Min_Order_By>;
  stddev?: Maybe<Organisation_Research_Stddev_Order_By>;
  stddev_pop?: Maybe<Organisation_Research_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Organisation_Research_Stddev_Samp_Order_By>;
  sum?: Maybe<Organisation_Research_Sum_Order_By>;
  var_pop?: Maybe<Organisation_Research_Var_Pop_Order_By>;
  var_samp?: Maybe<Organisation_Research_Var_Samp_Order_By>;
  variance?: Maybe<Organisation_Research_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_research" */
export type Organisation_Research_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Research_Insert_Input>;
  on_conflict?: Maybe<Organisation_Research_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Research_Avg_Fields = {
  __typename?: "organisation_research_avg_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  research_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "organisation_research" */
export type Organisation_Research_Avg_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_research". All fields are combined with a logical 'AND'. */
export type Organisation_Research_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organisation_Research_Bool_Exp>>>;
  _not?: Maybe<Organisation_Research_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organisation_Research_Bool_Exp>>>;
  id?: Maybe<Int_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
  research?: Maybe<Research_Bool_Exp>;
  research_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_research" */
export enum Organisation_Research_Constraint {
  /** unique or primary key constraint */
  OrganisationResearchPkey = "OrganisationResearch_pkey",
}

/** input type for incrementing integer column in table "organisation_research" */
export type Organisation_Research_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  research_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "organisation_research" */
export type Organisation_Research_Insert_Input = {
  id?: Maybe<Scalars["Int"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
  research?: Maybe<Research_Obj_Rel_Insert_Input>;
  research_id?: Maybe<Scalars["Int"]>;
};

/** aggregate max on columns */
export type Organisation_Research_Max_Fields = {
  __typename?: "organisation_research_max_fields";
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  research_id?: Maybe<Scalars["Int"]>;
};

/** order by max() on columns of table "organisation_research" */
export type Organisation_Research_Max_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Research_Min_Fields = {
  __typename?: "organisation_research_min_fields";
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  research_id?: Maybe<Scalars["Int"]>;
};

/** order by min() on columns of table "organisation_research" */
export type Organisation_Research_Min_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "organisation_research" */
export type Organisation_Research_Mutation_Response = {
  __typename?: "organisation_research_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Organisation_Research>;
};

/** input type for inserting object relation for remote table "organisation_research" */
export type Organisation_Research_Obj_Rel_Insert_Input = {
  data: Organisation_Research_Insert_Input;
  on_conflict?: Maybe<Organisation_Research_On_Conflict>;
};

/** on conflict condition type for table "organisation_research" */
export type Organisation_Research_On_Conflict = {
  constraint: Organisation_Research_Constraint;
  update_columns: Array<Organisation_Research_Update_Column>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** ordering options when selecting data from "organisation_research" */
export type Organisation_Research_Order_By = {
  id?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
  research?: Maybe<Research_Order_By>;
  research_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "organisation_research" */
export type Organisation_Research_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "organisation_research" */
export enum Organisation_Research_Select_Column {
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  ResearchId = "research_id",
}

/** input type for updating data in table "organisation_research" */
export type Organisation_Research_Set_Input = {
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  research_id?: Maybe<Scalars["Int"]>;
};

/** aggregate stddev on columns */
export type Organisation_Research_Stddev_Fields = {
  __typename?: "organisation_research_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  research_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "organisation_research" */
export type Organisation_Research_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Research_Stddev_Pop_Fields = {
  __typename?: "organisation_research_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  research_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "organisation_research" */
export type Organisation_Research_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Research_Stddev_Samp_Fields = {
  __typename?: "organisation_research_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  research_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "organisation_research" */
export type Organisation_Research_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Organisation_Research_Sum_Fields = {
  __typename?: "organisation_research_sum_fields";
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  research_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "organisation_research" */
export type Organisation_Research_Sum_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** update columns of table "organisation_research" */
export enum Organisation_Research_Update_Column {
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  ResearchId = "research_id",
}

/** aggregate var_pop on columns */
export type Organisation_Research_Var_Pop_Fields = {
  __typename?: "organisation_research_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  research_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "organisation_research" */
export type Organisation_Research_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Research_Var_Samp_Fields = {
  __typename?: "organisation_research_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  research_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "organisation_research" */
export type Organisation_Research_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Research_Variance_Fields = {
  __typename?: "organisation_research_variance_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
  research_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "organisation_research" */
export type Organisation_Research_Variance_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  research_id?: Maybe<Order_By>;
};

/**
 * Join table between users and organisations.
 *
 *
 * columns and relationships of "organisation_users"
 */
export type Organisation_Users = {
  __typename?: "organisation_users";
  created_at: Scalars["timestamptz"];
  id: Scalars["Int"];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars["Int"];
  /** An object relationship */
  user: App_Users;
  user_id: Scalars["String"];
};

/** aggregated selection of "organisation_users" */
export type Organisation_Users_Aggregate = {
  __typename?: "organisation_users_aggregate";
  aggregate?: Maybe<Organisation_Users_Aggregate_Fields>;
  nodes: Array<Organisation_Users>;
};

/** aggregate fields of "organisation_users" */
export type Organisation_Users_Aggregate_Fields = {
  __typename?: "organisation_users_aggregate_fields";
  avg?: Maybe<Organisation_Users_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Organisation_Users_Max_Fields>;
  min?: Maybe<Organisation_Users_Min_Fields>;
  stddev?: Maybe<Organisation_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Organisation_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisation_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Organisation_Users_Sum_Fields>;
  var_pop?: Maybe<Organisation_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Organisation_Users_Var_Samp_Fields>;
  variance?: Maybe<Organisation_Users_Variance_Fields>;
};

/** aggregate fields of "organisation_users" */
export type Organisation_Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organisation_Users_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "organisation_users" */
export type Organisation_Users_Aggregate_Order_By = {
  avg?: Maybe<Organisation_Users_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Organisation_Users_Max_Order_By>;
  min?: Maybe<Organisation_Users_Min_Order_By>;
  stddev?: Maybe<Organisation_Users_Stddev_Order_By>;
  stddev_pop?: Maybe<Organisation_Users_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Organisation_Users_Stddev_Samp_Order_By>;
  sum?: Maybe<Organisation_Users_Sum_Order_By>;
  var_pop?: Maybe<Organisation_Users_Var_Pop_Order_By>;
  var_samp?: Maybe<Organisation_Users_Var_Samp_Order_By>;
  variance?: Maybe<Organisation_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_users" */
export type Organisation_Users_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Users_Insert_Input>;
  on_conflict?: Maybe<Organisation_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisation_Users_Avg_Fields = {
  __typename?: "organisation_users_avg_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "organisation_users" */
export type Organisation_Users_Avg_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_users". All fields are combined with a logical 'AND'. */
export type Organisation_Users_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organisation_Users_Bool_Exp>>>;
  _not?: Maybe<Organisation_Users_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organisation_Users_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  organisation?: Maybe<Organisations_Bool_Exp>;
  organisation_id?: Maybe<Int_Comparison_Exp>;
  user?: Maybe<App_Users_Bool_Exp>;
  user_id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_users" */
export enum Organisation_Users_Constraint {
  /** unique or primary key constraint */
  OrganisationUsersPkey = "OrganisationUsers_pkey",
  /** unique or primary key constraint */
  OrganisationUsersOrganisationIdUserIdKey = "organisation_users_organisation_id_user_id_key",
}

/** input type for incrementing integer column in table "organisation_users" */
export type Organisation_Users_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "organisation_users" */
export type Organisation_Users_Insert_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation?: Maybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: Maybe<Scalars["Int"]>;
  user?: Maybe<App_Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Organisation_Users_Max_Fields = {
  __typename?: "organisation_users_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  user_id?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "organisation_users" */
export type Organisation_Users_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Users_Min_Fields = {
  __typename?: "organisation_users_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  user_id?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "organisation_users" */
export type Organisation_Users_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "organisation_users" */
export type Organisation_Users_Mutation_Response = {
  __typename?: "organisation_users_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Organisation_Users>;
};

/** input type for inserting object relation for remote table "organisation_users" */
export type Organisation_Users_Obj_Rel_Insert_Input = {
  data: Organisation_Users_Insert_Input;
  on_conflict?: Maybe<Organisation_Users_On_Conflict>;
};

/** on conflict condition type for table "organisation_users" */
export type Organisation_Users_On_Conflict = {
  constraint: Organisation_Users_Constraint;
  update_columns: Array<Organisation_Users_Update_Column>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** ordering options when selecting data from "organisation_users" */
export type Organisation_Users_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation?: Maybe<Organisations_Order_By>;
  organisation_id?: Maybe<Order_By>;
  user?: Maybe<App_Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "organisation_users" */
export type Organisation_Users_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "organisation_users" */
export enum Organisation_Users_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  UserId = "user_id",
}

/** input type for updating data in table "organisation_users" */
export type Organisation_Users_Set_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
  user_id?: Maybe<Scalars["String"]>;
};

/** aggregate stddev on columns */
export type Organisation_Users_Stddev_Fields = {
  __typename?: "organisation_users_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "organisation_users" */
export type Organisation_Users_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisation_Users_Stddev_Pop_Fields = {
  __typename?: "organisation_users_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "organisation_users" */
export type Organisation_Users_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisation_Users_Stddev_Samp_Fields = {
  __typename?: "organisation_users_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "organisation_users" */
export type Organisation_Users_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Organisation_Users_Sum_Fields = {
  __typename?: "organisation_users_sum_fields";
  id?: Maybe<Scalars["Int"]>;
  organisation_id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "organisation_users" */
export type Organisation_Users_Sum_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** update columns of table "organisation_users" */
export enum Organisation_Users_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  OrganisationId = "organisation_id",
  /** column name */
  UserId = "user_id",
}

/** aggregate var_pop on columns */
export type Organisation_Users_Var_Pop_Fields = {
  __typename?: "organisation_users_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "organisation_users" */
export type Organisation_Users_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisation_Users_Var_Samp_Fields = {
  __typename?: "organisation_users_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "organisation_users" */
export type Organisation_Users_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisation_Users_Variance_Fields = {
  __typename?: "organisation_users_variance_fields";
  id?: Maybe<Scalars["Float"]>;
  organisation_id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "organisation_users" */
export type Organisation_Users_Variance_Order_By = {
  id?: Maybe<Order_By>;
  organisation_id?: Maybe<Order_By>;
};

/** columns and relationships of "organisations" */
export type Organisations = {
  __typename?: "organisations";
  /** An array relationship */
  bank_accounts: Array<Bank_Accounts>;
  /** An aggregated array relationship */
  bank_accounts_aggregate: Bank_Accounts_Aggregate;
  /** An array relationship */
  banks: Array<Organisation_Banks>;
  /** An aggregated array relationship */
  banks_aggregate: Organisation_Banks_Aggregate;
  /** An array relationship */
  business_units: Array<Business_Units>;
  /** An aggregated array relationship */
  business_units_aggregate: Business_Units_Aggregate;
  created_at: Scalars["timestamptz"];
  /** An array relationship */
  current_app_users: Array<App_Users>;
  /** An aggregated array relationship */
  current_app_users_aggregate: App_Users_Aggregate;
  demo_dashboard: Scalars["Boolean"];
  id: Scalars["Int"];
  /** An object relationship */
  image?: Maybe<Uploads>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name: Scalars["String"];
  /** An array relationship */
  organisation_bank_exposure_limits: Array<Organisation_Bank_Exposure_Limits>;
  /** An aggregated array relationship */
  organisation_bank_exposure_limits_aggregate: Organisation_Bank_Exposure_Limits_Aggregate;
  /** An array relationship */
  organisation_liquidity_limits: Array<Organisation_Liquidity_Limits>;
  /** An aggregated array relationship */
  organisation_liquidity_limits_aggregate: Organisation_Liquidity_Limits_Aggregate;
  /** An array relationship */
  organisation_reports: Array<Organisation_Reports>;
  /** An aggregated array relationship */
  organisation_reports_aggregate: Organisation_Reports_Aggregate;
  /** An array relationship */
  organisation_research: Array<Organisation_Research>;
  /** An aggregated array relationship */
  organisation_research_aggregate: Organisation_Research_Aggregate;
  /** An array relationship */
  organisation_users: Array<Organisation_Users>;
  /** An aggregated array relationship */
  organisation_users_aggregate: Organisation_Users_Aggregate;
  short_name: Scalars["String"];
};

/** columns and relationships of "organisations" */
export type OrganisationsBank_AccountsArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsBank_Accounts_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsBanksArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsBanks_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsBusiness_UnitsArgs = {
  distinct_on?: Maybe<Array<Business_Units_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Units_Order_By>>;
  where?: Maybe<Business_Units_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsBusiness_Units_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Units_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Units_Order_By>>;
  where?: Maybe<Business_Units_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsCurrent_App_UsersArgs = {
  distinct_on?: Maybe<Array<App_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<App_Users_Order_By>>;
  where?: Maybe<App_Users_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsCurrent_App_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<App_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<App_Users_Order_By>>;
  where?: Maybe<App_Users_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Organisation_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Liquidity_Limits_Order_By>>;
  where?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Liquidity_Limits_Order_By>>;
  where?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_ReportsArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_Reports_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_ResearchArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_Research_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_UsersArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** columns and relationships of "organisations" */
export type OrganisationsOrganisation_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** aggregated selection of "organisations" */
export type Organisations_Aggregate = {
  __typename?: "organisations_aggregate";
  aggregate?: Maybe<Organisations_Aggregate_Fields>;
  nodes: Array<Organisations>;
};

/** aggregate fields of "organisations" */
export type Organisations_Aggregate_Fields = {
  __typename?: "organisations_aggregate_fields";
  avg?: Maybe<Organisations_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Organisations_Max_Fields>;
  min?: Maybe<Organisations_Min_Fields>;
  stddev?: Maybe<Organisations_Stddev_Fields>;
  stddev_pop?: Maybe<Organisations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisations_Stddev_Samp_Fields>;
  sum?: Maybe<Organisations_Sum_Fields>;
  var_pop?: Maybe<Organisations_Var_Pop_Fields>;
  var_samp?: Maybe<Organisations_Var_Samp_Fields>;
  variance?: Maybe<Organisations_Variance_Fields>;
};

/** aggregate fields of "organisations" */
export type Organisations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organisations_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "organisations" */
export type Organisations_Aggregate_Order_By = {
  avg?: Maybe<Organisations_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Organisations_Max_Order_By>;
  min?: Maybe<Organisations_Min_Order_By>;
  stddev?: Maybe<Organisations_Stddev_Order_By>;
  stddev_pop?: Maybe<Organisations_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Organisations_Stddev_Samp_Order_By>;
  sum?: Maybe<Organisations_Sum_Order_By>;
  var_pop?: Maybe<Organisations_Var_Pop_Order_By>;
  var_samp?: Maybe<Organisations_Var_Samp_Order_By>;
  variance?: Maybe<Organisations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisations" */
export type Organisations_Arr_Rel_Insert_Input = {
  data: Array<Organisations_Insert_Input>;
  on_conflict?: Maybe<Organisations_On_Conflict>;
};

/** aggregate avg on columns */
export type Organisations_Avg_Fields = {
  __typename?: "organisations_avg_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "organisations" */
export type Organisations_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisations". All fields are combined with a logical 'AND'. */
export type Organisations_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organisations_Bool_Exp>>>;
  _not?: Maybe<Organisations_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organisations_Bool_Exp>>>;
  bank_accounts?: Maybe<Bank_Accounts_Bool_Exp>;
  banks?: Maybe<Organisation_Banks_Bool_Exp>;
  business_units?: Maybe<Business_Units_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  current_app_users?: Maybe<App_Users_Bool_Exp>;
  demo_dashboard?: Maybe<Boolean_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  image?: Maybe<Uploads_Bool_Exp>;
  image_upload_id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  organisation_bank_exposure_limits?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
  organisation_liquidity_limits?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
  organisation_reports?: Maybe<Organisation_Reports_Bool_Exp>;
  organisation_research?: Maybe<Organisation_Research_Bool_Exp>;
  organisation_users?: Maybe<Organisation_Users_Bool_Exp>;
  short_name?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisations" */
export enum Organisations_Constraint {
  /** unique or primary key constraint */
  OrganisationsShortNameKey = "Organisations_shortName_key",
  /** unique or primary key constraint */
  OrganisationPkey = "organisation_pkey",
}

/** input type for incrementing integer column in table "organisations" */
export type Organisations_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "organisations" */
export type Organisations_Insert_Input = {
  bank_accounts?: Maybe<Bank_Accounts_Arr_Rel_Insert_Input>;
  banks?: Maybe<Organisation_Banks_Arr_Rel_Insert_Input>;
  business_units?: Maybe<Business_Units_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  current_app_users?: Maybe<App_Users_Arr_Rel_Insert_Input>;
  demo_dashboard?: Maybe<Scalars["Boolean"]>;
  id?: Maybe<Scalars["Int"]>;
  image?: Maybe<Uploads_Obj_Rel_Insert_Input>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  organisation_bank_exposure_limits?: Maybe<Organisation_Bank_Exposure_Limits_Arr_Rel_Insert_Input>;
  organisation_liquidity_limits?: Maybe<Organisation_Liquidity_Limits_Arr_Rel_Insert_Input>;
  organisation_reports?: Maybe<Organisation_Reports_Arr_Rel_Insert_Input>;
  organisation_research?: Maybe<Organisation_Research_Arr_Rel_Insert_Input>;
  organisation_users?: Maybe<Organisation_Users_Arr_Rel_Insert_Input>;
  short_name?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Organisations_Max_Fields = {
  __typename?: "organisations_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  short_name?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "organisations" */
export type Organisations_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image_upload_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  short_name?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organisations_Min_Fields = {
  __typename?: "organisations_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  short_name?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "organisations" */
export type Organisations_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image_upload_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  short_name?: Maybe<Order_By>;
};

/** response of any mutation on the table "organisations" */
export type Organisations_Mutation_Response = {
  __typename?: "organisations_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Organisations>;
};

/** input type for inserting object relation for remote table "organisations" */
export type Organisations_Obj_Rel_Insert_Input = {
  data: Organisations_Insert_Input;
  on_conflict?: Maybe<Organisations_On_Conflict>;
};

/** on conflict condition type for table "organisations" */
export type Organisations_On_Conflict = {
  constraint: Organisations_Constraint;
  update_columns: Array<Organisations_Update_Column>;
  where?: Maybe<Organisations_Bool_Exp>;
};

/** ordering options when selecting data from "organisations" */
export type Organisations_Order_By = {
  bank_accounts_aggregate?: Maybe<Bank_Accounts_Aggregate_Order_By>;
  banks_aggregate?: Maybe<Organisation_Banks_Aggregate_Order_By>;
  business_units_aggregate?: Maybe<Business_Units_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  current_app_users_aggregate?: Maybe<App_Users_Aggregate_Order_By>;
  demo_dashboard?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  image?: Maybe<Uploads_Order_By>;
  image_upload_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  organisation_bank_exposure_limits_aggregate?: Maybe<Organisation_Bank_Exposure_Limits_Aggregate_Order_By>;
  organisation_liquidity_limits_aggregate?: Maybe<Organisation_Liquidity_Limits_Aggregate_Order_By>;
  organisation_reports_aggregate?: Maybe<Organisation_Reports_Aggregate_Order_By>;
  organisation_research_aggregate?: Maybe<Organisation_Research_Aggregate_Order_By>;
  organisation_users_aggregate?: Maybe<Organisation_Users_Aggregate_Order_By>;
  short_name?: Maybe<Order_By>;
};

/** primary key columns input for table: "organisations" */
export type Organisations_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "organisations" */
export enum Organisations_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DemoDashboard = "demo_dashboard",
  /** column name */
  Id = "id",
  /** column name */
  ImageUploadId = "image_upload_id",
  /** column name */
  Name = "name",
  /** column name */
  ShortName = "short_name",
}

/** input type for updating data in table "organisations" */
export type Organisations_Set_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  demo_dashboard?: Maybe<Scalars["Boolean"]>;
  id?: Maybe<Scalars["Int"]>;
  image_upload_id?: Maybe<Scalars["uuid"]>;
  name?: Maybe<Scalars["String"]>;
  short_name?: Maybe<Scalars["String"]>;
};

/** aggregate stddev on columns */
export type Organisations_Stddev_Fields = {
  __typename?: "organisations_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "organisations" */
export type Organisations_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organisations_Stddev_Pop_Fields = {
  __typename?: "organisations_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "organisations" */
export type Organisations_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organisations_Stddev_Samp_Fields = {
  __typename?: "organisations_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "organisations" */
export type Organisations_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Organisations_Sum_Fields = {
  __typename?: "organisations_sum_fields";
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "organisations" */
export type Organisations_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "organisations" */
export enum Organisations_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  DemoDashboard = "demo_dashboard",
  /** column name */
  Id = "id",
  /** column name */
  ImageUploadId = "image_upload_id",
  /** column name */
  Name = "name",
  /** column name */
  ShortName = "short_name",
}

/** aggregate var_pop on columns */
export type Organisations_Var_Pop_Fields = {
  __typename?: "organisations_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "organisations" */
export type Organisations_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organisations_Var_Samp_Fields = {
  __typename?: "organisations_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "organisations" */
export type Organisations_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Organisations_Variance_Fields = {
  __typename?: "organisations_variance_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "organisations" */
export type Organisations_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** columns and relationships of "product_types_enum" */
export type Product_Types_Enum = {
  __typename?: "product_types_enum";
  id: Scalars["String"];
};

/** aggregated selection of "product_types_enum" */
export type Product_Types_Enum_Aggregate = {
  __typename?: "product_types_enum_aggregate";
  aggregate?: Maybe<Product_Types_Enum_Aggregate_Fields>;
  nodes: Array<Product_Types_Enum>;
};

/** aggregate fields of "product_types_enum" */
export type Product_Types_Enum_Aggregate_Fields = {
  __typename?: "product_types_enum_aggregate_fields";
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Product_Types_Enum_Max_Fields>;
  min?: Maybe<Product_Types_Enum_Min_Fields>;
};

/** aggregate fields of "product_types_enum" */
export type Product_Types_Enum_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Product_Types_Enum_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "product_types_enum" */
export type Product_Types_Enum_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Product_Types_Enum_Max_Order_By>;
  min?: Maybe<Product_Types_Enum_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product_types_enum" */
export type Product_Types_Enum_Arr_Rel_Insert_Input = {
  data: Array<Product_Types_Enum_Insert_Input>;
  on_conflict?: Maybe<Product_Types_Enum_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_types_enum". All fields are combined with a logical 'AND'. */
export type Product_Types_Enum_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Product_Types_Enum_Bool_Exp>>>;
  _not?: Maybe<Product_Types_Enum_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Product_Types_Enum_Bool_Exp>>>;
  id?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_types_enum" */
export enum Product_Types_Enum_Constraint {
  /** unique or primary key constraint */
  ProductTypesEnumPkey = "ProductTypesEnum_pkey",
}

export enum Product_Types_Enum_Enum {
  Call = "CALL",
  Fixed = "FIXED",
  Notice = "NOTICE",
}

/** expression to compare columns of type product_types_enum_enum. All fields are combined with logical 'AND'. */
export type Product_Types_Enum_Enum_Comparison_Exp = {
  _eq?: Maybe<Product_Types_Enum_Enum>;
  _in?: Maybe<Array<Product_Types_Enum_Enum>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _neq?: Maybe<Product_Types_Enum_Enum>;
  _nin?: Maybe<Array<Product_Types_Enum_Enum>>;
};

/** input type for inserting data into table "product_types_enum" */
export type Product_Types_Enum_Insert_Input = {
  id?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Product_Types_Enum_Max_Fields = {
  __typename?: "product_types_enum_max_fields";
  id?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "product_types_enum" */
export type Product_Types_Enum_Max_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Types_Enum_Min_Fields = {
  __typename?: "product_types_enum_min_fields";
  id?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "product_types_enum" */
export type Product_Types_Enum_Min_Order_By = {
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "product_types_enum" */
export type Product_Types_Enum_Mutation_Response = {
  __typename?: "product_types_enum_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Product_Types_Enum>;
};

/** input type for inserting object relation for remote table "product_types_enum" */
export type Product_Types_Enum_Obj_Rel_Insert_Input = {
  data: Product_Types_Enum_Insert_Input;
  on_conflict?: Maybe<Product_Types_Enum_On_Conflict>;
};

/** on conflict condition type for table "product_types_enum" */
export type Product_Types_Enum_On_Conflict = {
  constraint: Product_Types_Enum_Constraint;
  update_columns: Array<Product_Types_Enum_Update_Column>;
  where?: Maybe<Product_Types_Enum_Bool_Exp>;
};

/** ordering options when selecting data from "product_types_enum" */
export type Product_Types_Enum_Order_By = {
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: "product_types_enum" */
export type Product_Types_Enum_Pk_Columns_Input = {
  id: Scalars["String"];
};

/** select columns of table "product_types_enum" */
export enum Product_Types_Enum_Select_Column {
  /** column name */
  Id = "id",
}

/** input type for updating data in table "product_types_enum" */
export type Product_Types_Enum_Set_Input = {
  id?: Maybe<Scalars["String"]>;
};

/** update columns of table "product_types_enum" */
export enum Product_Types_Enum_Update_Column {
  /** column name */
  Id = "id",
}

/** query root */
export type Query_Root = {
  __typename?: "query_root";
  /** fetch data from the table: "actual_balances" */
  actual_balances: Array<Actual_Balances>;
  /** fetch aggregated fields from the table: "actual_balances" */
  actual_balances_aggregate: Actual_Balances_Aggregate;
  /** fetch data from the table: "actual_balances" using primary key columns */
  actual_balances_by_pk?: Maybe<Actual_Balances>;
  /** fetch data from the table: "app_users" */
  app_users: Array<App_Users>;
  /** fetch aggregated fields from the table: "app_users" */
  app_users_aggregate: App_Users_Aggregate;
  /** fetch data from the table: "app_users" using primary key columns */
  app_users_by_pk?: Maybe<App_Users>;
  /** fetch data from the table: "bank_accounts" */
  bank_accounts: Array<Bank_Accounts>;
  /** fetch aggregated fields from the table: "bank_accounts" */
  bank_accounts_aggregate: Bank_Accounts_Aggregate;
  /** fetch data from the table: "bank_accounts" using primary key columns */
  bank_accounts_by_pk?: Maybe<Bank_Accounts>;
  /** fetch data from the table: "bank_factsheets" */
  bank_factsheets: Array<Bank_Factsheets>;
  /** fetch aggregated fields from the table: "bank_factsheets" */
  bank_factsheets_aggregate: Bank_Factsheets_Aggregate;
  /** fetch data from the table: "bank_factsheets" using primary key columns */
  bank_factsheets_by_pk?: Maybe<Bank_Factsheets>;
  /** fetch data from the table: "banks" */
  banks: Array<Banks>;
  /** fetch aggregated fields from the table: "banks" */
  banks_aggregate: Banks_Aggregate;
  /** fetch data from the table: "banks" using primary key columns */
  banks_by_pk?: Maybe<Banks>;
  /** fetch data from the table: "business_unit_bank_exposure_limits" */
  business_unit_bank_exposure_limits: Array<Business_Unit_Bank_Exposure_Limits>;
  /** fetch aggregated fields from the table: "business_unit_bank_exposure_limits" */
  business_unit_bank_exposure_limits_aggregate: Business_Unit_Bank_Exposure_Limits_Aggregate;
  /** fetch data from the table: "business_unit_bank_exposure_limits" using primary key columns */
  business_unit_bank_exposure_limits_by_pk?: Maybe<Business_Unit_Bank_Exposure_Limits>;
  /** fetch data from the table: "business_unit_liquidity_limits" */
  business_unit_liquidity_limits: Array<Business_Unit_Liquidity_Limits>;
  /** fetch aggregated fields from the table: "business_unit_liquidity_limits" */
  business_unit_liquidity_limits_aggregate: Business_Unit_Liquidity_Limits_Aggregate;
  /** fetch data from the table: "business_unit_liquidity_limits" using primary key columns */
  business_unit_liquidity_limits_by_pk?: Maybe<Business_Unit_Liquidity_Limits>;
  /** fetch data from the table: "business_units" */
  business_units: Array<Business_Units>;
  /** fetch aggregated fields from the table: "business_units" */
  business_units_aggregate: Business_Units_Aggregate;
  /** fetch data from the table: "business_units" using primary key columns */
  business_units_by_pk?: Maybe<Business_Units>;
  /** fetch data from the table: "currencies" */
  currencies: Array<Currencies>;
  /** fetch aggregated fields from the table: "currencies" */
  currencies_aggregate: Currencies_Aggregate;
  /** fetch data from the table: "currencies" using primary key columns */
  currencies_by_pk?: Maybe<Currencies>;
  /** fetch data from the table: "currency_book_bank_exposure_limits" */
  currency_book_bank_exposure_limits: Array<Currency_Book_Bank_Exposure_Limits>;
  /** fetch aggregated fields from the table: "currency_book_bank_exposure_limits" */
  currency_book_bank_exposure_limits_aggregate: Currency_Book_Bank_Exposure_Limits_Aggregate;
  /** fetch data from the table: "currency_book_bank_exposure_limits" using primary key columns */
  currency_book_bank_exposure_limits_by_pk?: Maybe<Currency_Book_Bank_Exposure_Limits>;
  /** fetch data from the table: "currency_book_liquidity_limits" */
  currency_book_liquidity_limits: Array<Currency_Book_Liquidity_Limits>;
  /** fetch aggregated fields from the table: "currency_book_liquidity_limits" */
  currency_book_liquidity_limits_aggregate: Currency_Book_Liquidity_Limits_Aggregate;
  /** fetch data from the table: "currency_book_liquidity_limits" using primary key columns */
  currency_book_liquidity_limits_by_pk?: Maybe<Currency_Book_Liquidity_Limits>;
  /** fetch data from the table: "currency_books" */
  currency_books: Array<Currency_Books>;
  /** fetch aggregated fields from the table: "currency_books" */
  currency_books_aggregate: Currency_Books_Aggregate;
  /** fetch data from the table: "currency_books" using primary key columns */
  currency_books_by_pk?: Maybe<Currency_Books>;
  /** fetch data from the table: "model_balances" */
  model_balances: Array<Model_Balances>;
  /** fetch aggregated fields from the table: "model_balances" */
  model_balances_aggregate: Model_Balances_Aggregate;
  /** fetch data from the table: "model_balances" using primary key columns */
  model_balances_by_pk?: Maybe<Model_Balances>;
  /** fetch data from the table: "models" */
  models: Array<Models>;
  /** fetch aggregated fields from the table: "models" */
  models_aggregate: Models_Aggregate;
  /** fetch data from the table: "models" using primary key columns */
  models_by_pk?: Maybe<Models>;
  /** fetch data from the table: "organisation_bank_exposure_limits" */
  organisation_bank_exposure_limits: Array<Organisation_Bank_Exposure_Limits>;
  /** fetch aggregated fields from the table: "organisation_bank_exposure_limits" */
  organisation_bank_exposure_limits_aggregate: Organisation_Bank_Exposure_Limits_Aggregate;
  /** fetch data from the table: "organisation_bank_exposure_limits" using primary key columns */
  organisation_bank_exposure_limits_by_pk?: Maybe<Organisation_Bank_Exposure_Limits>;
  /** fetch data from the table: "organisation_banks" */
  organisation_banks: Array<Organisation_Banks>;
  /** fetch aggregated fields from the table: "organisation_banks" */
  organisation_banks_aggregate: Organisation_Banks_Aggregate;
  /** fetch data from the table: "organisation_banks" using primary key columns */
  organisation_banks_by_pk?: Maybe<Organisation_Banks>;
  /** fetch data from the table: "organisation_liquidity_limits" */
  organisation_liquidity_limits: Array<Organisation_Liquidity_Limits>;
  /** fetch aggregated fields from the table: "organisation_liquidity_limits" */
  organisation_liquidity_limits_aggregate: Organisation_Liquidity_Limits_Aggregate;
  /** fetch data from the table: "organisation_liquidity_limits" using primary key columns */
  organisation_liquidity_limits_by_pk?: Maybe<Organisation_Liquidity_Limits>;
  /** fetch data from the table: "organisation_reports" */
  organisation_reports: Array<Organisation_Reports>;
  /** fetch aggregated fields from the table: "organisation_reports" */
  organisation_reports_aggregate: Organisation_Reports_Aggregate;
  /** fetch data from the table: "organisation_reports" using primary key columns */
  organisation_reports_by_pk?: Maybe<Organisation_Reports>;
  /** fetch data from the table: "organisation_research" */
  organisation_research: Array<Organisation_Research>;
  /** fetch aggregated fields from the table: "organisation_research" */
  organisation_research_aggregate: Organisation_Research_Aggregate;
  /** fetch data from the table: "organisation_research" using primary key columns */
  organisation_research_by_pk?: Maybe<Organisation_Research>;
  /** fetch data from the table: "organisation_users" */
  organisation_users: Array<Organisation_Users>;
  /** fetch aggregated fields from the table: "organisation_users" */
  organisation_users_aggregate: Organisation_Users_Aggregate;
  /** fetch data from the table: "organisation_users" using primary key columns */
  organisation_users_by_pk?: Maybe<Organisation_Users>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** fetch data from the table: "product_types_enum" */
  product_types_enum: Array<Product_Types_Enum>;
  /** fetch aggregated fields from the table: "product_types_enum" */
  product_types_enum_aggregate: Product_Types_Enum_Aggregate;
  /** fetch data from the table: "product_types_enum" using primary key columns */
  product_types_enum_by_pk?: Maybe<Product_Types_Enum>;
  /** fetch data from the table: "research" */
  research: Array<Research>;
  /** fetch aggregated fields from the table: "research" */
  research_aggregate: Research_Aggregate;
  /** fetch data from the table: "research" using primary key columns */
  research_by_pk?: Maybe<Research>;
  /** fetch data from the table: "uploads" */
  uploads: Array<Uploads>;
  /** fetch aggregated fields from the table: "uploads" */
  uploads_aggregate: Uploads_Aggregate;
  /** fetch data from the table: "uploads" using primary key columns */
  uploads_by_pk?: Maybe<Uploads>;
};

/** query root */
export type Query_RootActual_BalancesArgs = {
  distinct_on?: Maybe<Array<Actual_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Actual_Balances_Order_By>>;
  where?: Maybe<Actual_Balances_Bool_Exp>;
};

/** query root */
export type Query_RootActual_Balances_AggregateArgs = {
  distinct_on?: Maybe<Array<Actual_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Actual_Balances_Order_By>>;
  where?: Maybe<Actual_Balances_Bool_Exp>;
};

/** query root */
export type Query_RootActual_Balances_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootApp_UsersArgs = {
  distinct_on?: Maybe<Array<App_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<App_Users_Order_By>>;
  where?: Maybe<App_Users_Bool_Exp>;
};

/** query root */
export type Query_RootApp_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<App_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<App_Users_Order_By>>;
  where?: Maybe<App_Users_Bool_Exp>;
};

/** query root */
export type Query_RootApp_Users_By_PkArgs = {
  id: Scalars["String"];
};

/** query root */
export type Query_RootBank_AccountsArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** query root */
export type Query_RootBank_Accounts_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** query root */
export type Query_RootBank_Accounts_By_PkArgs = {
  account_id: Scalars["String"];
};

/** query root */
export type Query_RootBank_FactsheetsArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** query root */
export type Query_RootBank_Factsheets_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** query root */
export type Query_RootBank_Factsheets_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootBanksArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};

/** query root */
export type Query_RootBanks_AggregateArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};

/** query root */
export type Query_RootBanks_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootBusiness_Unit_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootBusiness_Unit_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootBusiness_Unit_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootBusiness_Unit_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Liquidity_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootBusiness_Unit_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Liquidity_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootBusiness_Unit_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootBusiness_UnitsArgs = {
  distinct_on?: Maybe<Array<Business_Units_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Units_Order_By>>;
  where?: Maybe<Business_Units_Bool_Exp>;
};

/** query root */
export type Query_RootBusiness_Units_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Units_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Units_Order_By>>;
  where?: Maybe<Business_Units_Bool_Exp>;
};

/** query root */
export type Query_RootBusiness_Units_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootCurrenciesArgs = {
  distinct_on?: Maybe<Array<Currencies_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currencies_Order_By>>;
  where?: Maybe<Currencies_Bool_Exp>;
};

/** query root */
export type Query_RootCurrencies_AggregateArgs = {
  distinct_on?: Maybe<Array<Currencies_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currencies_Order_By>>;
  where?: Maybe<Currencies_Bool_Exp>;
};

/** query root */
export type Query_RootCurrencies_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootCurrency_Book_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootCurrency_Book_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootCurrency_Book_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootCurrency_Book_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Liquidity_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootCurrency_Book_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Liquidity_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootCurrency_Book_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootCurrency_BooksArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** query root */
export type Query_RootCurrency_Books_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** query root */
export type Query_RootCurrency_Books_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootModel_BalancesArgs = {
  distinct_on?: Maybe<Array<Model_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Model_Balances_Order_By>>;
  where?: Maybe<Model_Balances_Bool_Exp>;
};

/** query root */
export type Query_RootModel_Balances_AggregateArgs = {
  distinct_on?: Maybe<Array<Model_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Model_Balances_Order_By>>;
  where?: Maybe<Model_Balances_Bool_Exp>;
};

/** query root */
export type Query_RootModel_Balances_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootModelsArgs = {
  distinct_on?: Maybe<Array<Models_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Models_Order_By>>;
  where?: Maybe<Models_Bool_Exp>;
};

/** query root */
export type Query_RootModels_AggregateArgs = {
  distinct_on?: Maybe<Array<Models_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Models_Order_By>>;
  where?: Maybe<Models_Bool_Exp>;
};

/** query root */
export type Query_RootModels_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootOrganisation_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootOrganisation_BanksArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Banks_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Banks_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootOrganisation_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Organisation_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Liquidity_Limits_Order_By>>;
  where?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Liquidity_Limits_Order_By>>;
  where?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootOrganisation_ReportsArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Reports_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Reports_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootOrganisation_ResearchArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Research_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Research_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootOrganisation_UsersArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisation_Users_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootOrganisationsArgs = {
  distinct_on?: Maybe<Array<Organisations_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisations_Order_By>>;
  where?: Maybe<Organisations_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisations_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisations_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisations_Order_By>>;
  where?: Maybe<Organisations_Bool_Exp>;
};

/** query root */
export type Query_RootOrganisations_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootProduct_Types_EnumArgs = {
  distinct_on?: Maybe<Array<Product_Types_Enum_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Product_Types_Enum_Order_By>>;
  where?: Maybe<Product_Types_Enum_Bool_Exp>;
};

/** query root */
export type Query_RootProduct_Types_Enum_AggregateArgs = {
  distinct_on?: Maybe<Array<Product_Types_Enum_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Product_Types_Enum_Order_By>>;
  where?: Maybe<Product_Types_Enum_Bool_Exp>;
};

/** query root */
export type Query_RootProduct_Types_Enum_By_PkArgs = {
  id: Scalars["String"];
};

/** query root */
export type Query_RootResearchArgs = {
  distinct_on?: Maybe<Array<Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Research_Order_By>>;
  where?: Maybe<Research_Bool_Exp>;
};

/** query root */
export type Query_RootResearch_AggregateArgs = {
  distinct_on?: Maybe<Array<Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Research_Order_By>>;
  where?: Maybe<Research_Bool_Exp>;
};

/** query root */
export type Query_RootResearch_By_PkArgs = {
  id: Scalars["Int"];
};

/** query root */
export type Query_RootUploadsArgs = {
  distinct_on?: Maybe<Array<Uploads_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Uploads_Order_By>>;
  where?: Maybe<Uploads_Bool_Exp>;
};

/** query root */
export type Query_RootUploads_AggregateArgs = {
  distinct_on?: Maybe<Array<Uploads_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Uploads_Order_By>>;
  where?: Maybe<Uploads_Bool_Exp>;
};

/** query root */
export type Query_RootUploads_By_PkArgs = {
  id: Scalars["uuid"];
};

/** columns and relationships of "research" */
export type Research = {
  __typename?: "research";
  archived: Scalars["Boolean"];
  created_at: Scalars["timestamptz"];
  id: Scalars["Int"];
  /** An array relationship */
  organisations: Array<Organisation_Research>;
  /** An aggregated array relationship */
  organisations_aggregate: Organisation_Research_Aggregate;
  research_date: Scalars["String"];
  research_title: Scalars["String"];
  /** An object relationship */
  upload: Uploads;
  upload_id: Scalars["uuid"];
};

/** columns and relationships of "research" */
export type ResearchOrganisationsArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** columns and relationships of "research" */
export type ResearchOrganisations_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** aggregated selection of "research" */
export type Research_Aggregate = {
  __typename?: "research_aggregate";
  aggregate?: Maybe<Research_Aggregate_Fields>;
  nodes: Array<Research>;
};

/** aggregate fields of "research" */
export type Research_Aggregate_Fields = {
  __typename?: "research_aggregate_fields";
  avg?: Maybe<Research_Avg_Fields>;
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Research_Max_Fields>;
  min?: Maybe<Research_Min_Fields>;
  stddev?: Maybe<Research_Stddev_Fields>;
  stddev_pop?: Maybe<Research_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Research_Stddev_Samp_Fields>;
  sum?: Maybe<Research_Sum_Fields>;
  var_pop?: Maybe<Research_Var_Pop_Fields>;
  var_samp?: Maybe<Research_Var_Samp_Fields>;
  variance?: Maybe<Research_Variance_Fields>;
};

/** aggregate fields of "research" */
export type Research_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Research_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "research" */
export type Research_Aggregate_Order_By = {
  avg?: Maybe<Research_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Research_Max_Order_By>;
  min?: Maybe<Research_Min_Order_By>;
  stddev?: Maybe<Research_Stddev_Order_By>;
  stddev_pop?: Maybe<Research_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Research_Stddev_Samp_Order_By>;
  sum?: Maybe<Research_Sum_Order_By>;
  var_pop?: Maybe<Research_Var_Pop_Order_By>;
  var_samp?: Maybe<Research_Var_Samp_Order_By>;
  variance?: Maybe<Research_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "research" */
export type Research_Arr_Rel_Insert_Input = {
  data: Array<Research_Insert_Input>;
  on_conflict?: Maybe<Research_On_Conflict>;
};

/** aggregate avg on columns */
export type Research_Avg_Fields = {
  __typename?: "research_avg_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by avg() on columns of table "research" */
export type Research_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "research". All fields are combined with a logical 'AND'. */
export type Research_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Research_Bool_Exp>>>;
  _not?: Maybe<Research_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Research_Bool_Exp>>>;
  archived?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  organisations?: Maybe<Organisation_Research_Bool_Exp>;
  research_date?: Maybe<String_Comparison_Exp>;
  research_title?: Maybe<String_Comparison_Exp>;
  upload?: Maybe<Uploads_Bool_Exp>;
  upload_id?: Maybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "research" */
export enum Research_Constraint {
  /** unique or primary key constraint */
  ResearchPkey = "Research_pkey",
}

/** input type for incrementing integer column in table "research" */
export type Research_Inc_Input = {
  id?: Maybe<Scalars["Int"]>;
};

/** input type for inserting data into table "research" */
export type Research_Insert_Input = {
  archived?: Maybe<Scalars["Boolean"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  organisations?: Maybe<Organisation_Research_Arr_Rel_Insert_Input>;
  research_date?: Maybe<Scalars["String"]>;
  research_title?: Maybe<Scalars["String"]>;
  upload?: Maybe<Uploads_Obj_Rel_Insert_Input>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** aggregate max on columns */
export type Research_Max_Fields = {
  __typename?: "research_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  research_date?: Maybe<Scalars["String"]>;
  research_title?: Maybe<Scalars["String"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** order by max() on columns of table "research" */
export type Research_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  research_date?: Maybe<Order_By>;
  research_title?: Maybe<Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Research_Min_Fields = {
  __typename?: "research_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  research_date?: Maybe<Scalars["String"]>;
  research_title?: Maybe<Scalars["String"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** order by min() on columns of table "research" */
export type Research_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  research_date?: Maybe<Order_By>;
  research_title?: Maybe<Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "research" */
export type Research_Mutation_Response = {
  __typename?: "research_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Research>;
};

/** input type for inserting object relation for remote table "research" */
export type Research_Obj_Rel_Insert_Input = {
  data: Research_Insert_Input;
  on_conflict?: Maybe<Research_On_Conflict>;
};

/** on conflict condition type for table "research" */
export type Research_On_Conflict = {
  constraint: Research_Constraint;
  update_columns: Array<Research_Update_Column>;
  where?: Maybe<Research_Bool_Exp>;
};

/** ordering options when selecting data from "research" */
export type Research_Order_By = {
  archived?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisations_aggregate?: Maybe<Organisation_Research_Aggregate_Order_By>;
  research_date?: Maybe<Order_By>;
  research_title?: Maybe<Order_By>;
  upload?: Maybe<Uploads_Order_By>;
  upload_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "research" */
export type Research_Pk_Columns_Input = {
  id: Scalars["Int"];
};

/** select columns of table "research" */
export enum Research_Select_Column {
  /** column name */
  Archived = "archived",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  ResearchDate = "research_date",
  /** column name */
  ResearchTitle = "research_title",
  /** column name */
  UploadId = "upload_id",
}

/** input type for updating data in table "research" */
export type Research_Set_Input = {
  archived?: Maybe<Scalars["Boolean"]>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  id?: Maybe<Scalars["Int"]>;
  research_date?: Maybe<Scalars["String"]>;
  research_title?: Maybe<Scalars["String"]>;
  upload_id?: Maybe<Scalars["uuid"]>;
};

/** aggregate stddev on columns */
export type Research_Stddev_Fields = {
  __typename?: "research_stddev_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev() on columns of table "research" */
export type Research_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Research_Stddev_Pop_Fields = {
  __typename?: "research_stddev_pop_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_pop() on columns of table "research" */
export type Research_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Research_Stddev_Samp_Fields = {
  __typename?: "research_stddev_samp_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by stddev_samp() on columns of table "research" */
export type Research_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Research_Sum_Fields = {
  __typename?: "research_sum_fields";
  id?: Maybe<Scalars["Int"]>;
};

/** order by sum() on columns of table "research" */
export type Research_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "research" */
export enum Research_Update_Column {
  /** column name */
  Archived = "archived",
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Id = "id",
  /** column name */
  ResearchDate = "research_date",
  /** column name */
  ResearchTitle = "research_title",
  /** column name */
  UploadId = "upload_id",
}

/** aggregate var_pop on columns */
export type Research_Var_Pop_Fields = {
  __typename?: "research_var_pop_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_pop() on columns of table "research" */
export type Research_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Research_Var_Samp_Fields = {
  __typename?: "research_var_samp_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by var_samp() on columns of table "research" */
export type Research_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Research_Variance_Fields = {
  __typename?: "research_variance_fields";
  id?: Maybe<Scalars["Float"]>;
};

/** order by variance() on columns of table "research" */
export type Research_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars["String"]>;
  _gt?: Maybe<Scalars["String"]>;
  _gte?: Maybe<Scalars["String"]>;
  _ilike?: Maybe<Scalars["String"]>;
  _in?: Maybe<Array<Scalars["String"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _like?: Maybe<Scalars["String"]>;
  _lt?: Maybe<Scalars["String"]>;
  _lte?: Maybe<Scalars["String"]>;
  _neq?: Maybe<Scalars["String"]>;
  _nilike?: Maybe<Scalars["String"]>;
  _nin?: Maybe<Array<Scalars["String"]>>;
  _nlike?: Maybe<Scalars["String"]>;
  _nsimilar?: Maybe<Scalars["String"]>;
  _similar?: Maybe<Scalars["String"]>;
};

/** subscription root */
export type Subscription_Root = {
  __typename?: "subscription_root";
  /** fetch data from the table: "actual_balances" */
  actual_balances: Array<Actual_Balances>;
  /** fetch aggregated fields from the table: "actual_balances" */
  actual_balances_aggregate: Actual_Balances_Aggregate;
  /** fetch data from the table: "actual_balances" using primary key columns */
  actual_balances_by_pk?: Maybe<Actual_Balances>;
  /** fetch data from the table: "app_users" */
  app_users: Array<App_Users>;
  /** fetch aggregated fields from the table: "app_users" */
  app_users_aggregate: App_Users_Aggregate;
  /** fetch data from the table: "app_users" using primary key columns */
  app_users_by_pk?: Maybe<App_Users>;
  /** fetch data from the table: "bank_accounts" */
  bank_accounts: Array<Bank_Accounts>;
  /** fetch aggregated fields from the table: "bank_accounts" */
  bank_accounts_aggregate: Bank_Accounts_Aggregate;
  /** fetch data from the table: "bank_accounts" using primary key columns */
  bank_accounts_by_pk?: Maybe<Bank_Accounts>;
  /** fetch data from the table: "bank_factsheets" */
  bank_factsheets: Array<Bank_Factsheets>;
  /** fetch aggregated fields from the table: "bank_factsheets" */
  bank_factsheets_aggregate: Bank_Factsheets_Aggregate;
  /** fetch data from the table: "bank_factsheets" using primary key columns */
  bank_factsheets_by_pk?: Maybe<Bank_Factsheets>;
  /** fetch data from the table: "banks" */
  banks: Array<Banks>;
  /** fetch aggregated fields from the table: "banks" */
  banks_aggregate: Banks_Aggregate;
  /** fetch data from the table: "banks" using primary key columns */
  banks_by_pk?: Maybe<Banks>;
  /** fetch data from the table: "business_unit_bank_exposure_limits" */
  business_unit_bank_exposure_limits: Array<Business_Unit_Bank_Exposure_Limits>;
  /** fetch aggregated fields from the table: "business_unit_bank_exposure_limits" */
  business_unit_bank_exposure_limits_aggregate: Business_Unit_Bank_Exposure_Limits_Aggregate;
  /** fetch data from the table: "business_unit_bank_exposure_limits" using primary key columns */
  business_unit_bank_exposure_limits_by_pk?: Maybe<Business_Unit_Bank_Exposure_Limits>;
  /** fetch data from the table: "business_unit_liquidity_limits" */
  business_unit_liquidity_limits: Array<Business_Unit_Liquidity_Limits>;
  /** fetch aggregated fields from the table: "business_unit_liquidity_limits" */
  business_unit_liquidity_limits_aggregate: Business_Unit_Liquidity_Limits_Aggregate;
  /** fetch data from the table: "business_unit_liquidity_limits" using primary key columns */
  business_unit_liquidity_limits_by_pk?: Maybe<Business_Unit_Liquidity_Limits>;
  /** fetch data from the table: "business_units" */
  business_units: Array<Business_Units>;
  /** fetch aggregated fields from the table: "business_units" */
  business_units_aggregate: Business_Units_Aggregate;
  /** fetch data from the table: "business_units" using primary key columns */
  business_units_by_pk?: Maybe<Business_Units>;
  /** fetch data from the table: "currencies" */
  currencies: Array<Currencies>;
  /** fetch aggregated fields from the table: "currencies" */
  currencies_aggregate: Currencies_Aggregate;
  /** fetch data from the table: "currencies" using primary key columns */
  currencies_by_pk?: Maybe<Currencies>;
  /** fetch data from the table: "currency_book_bank_exposure_limits" */
  currency_book_bank_exposure_limits: Array<Currency_Book_Bank_Exposure_Limits>;
  /** fetch aggregated fields from the table: "currency_book_bank_exposure_limits" */
  currency_book_bank_exposure_limits_aggregate: Currency_Book_Bank_Exposure_Limits_Aggregate;
  /** fetch data from the table: "currency_book_bank_exposure_limits" using primary key columns */
  currency_book_bank_exposure_limits_by_pk?: Maybe<Currency_Book_Bank_Exposure_Limits>;
  /** fetch data from the table: "currency_book_liquidity_limits" */
  currency_book_liquidity_limits: Array<Currency_Book_Liquidity_Limits>;
  /** fetch aggregated fields from the table: "currency_book_liquidity_limits" */
  currency_book_liquidity_limits_aggregate: Currency_Book_Liquidity_Limits_Aggregate;
  /** fetch data from the table: "currency_book_liquidity_limits" using primary key columns */
  currency_book_liquidity_limits_by_pk?: Maybe<Currency_Book_Liquidity_Limits>;
  /** fetch data from the table: "currency_books" */
  currency_books: Array<Currency_Books>;
  /** fetch aggregated fields from the table: "currency_books" */
  currency_books_aggregate: Currency_Books_Aggregate;
  /** fetch data from the table: "currency_books" using primary key columns */
  currency_books_by_pk?: Maybe<Currency_Books>;
  /** fetch data from the table: "model_balances" */
  model_balances: Array<Model_Balances>;
  /** fetch aggregated fields from the table: "model_balances" */
  model_balances_aggregate: Model_Balances_Aggregate;
  /** fetch data from the table: "model_balances" using primary key columns */
  model_balances_by_pk?: Maybe<Model_Balances>;
  /** fetch data from the table: "models" */
  models: Array<Models>;
  /** fetch aggregated fields from the table: "models" */
  models_aggregate: Models_Aggregate;
  /** fetch data from the table: "models" using primary key columns */
  models_by_pk?: Maybe<Models>;
  /** fetch data from the table: "organisation_bank_exposure_limits" */
  organisation_bank_exposure_limits: Array<Organisation_Bank_Exposure_Limits>;
  /** fetch aggregated fields from the table: "organisation_bank_exposure_limits" */
  organisation_bank_exposure_limits_aggregate: Organisation_Bank_Exposure_Limits_Aggregate;
  /** fetch data from the table: "organisation_bank_exposure_limits" using primary key columns */
  organisation_bank_exposure_limits_by_pk?: Maybe<Organisation_Bank_Exposure_Limits>;
  /** fetch data from the table: "organisation_banks" */
  organisation_banks: Array<Organisation_Banks>;
  /** fetch aggregated fields from the table: "organisation_banks" */
  organisation_banks_aggregate: Organisation_Banks_Aggregate;
  /** fetch data from the table: "organisation_banks" using primary key columns */
  organisation_banks_by_pk?: Maybe<Organisation_Banks>;
  /** fetch data from the table: "organisation_liquidity_limits" */
  organisation_liquidity_limits: Array<Organisation_Liquidity_Limits>;
  /** fetch aggregated fields from the table: "organisation_liquidity_limits" */
  organisation_liquidity_limits_aggregate: Organisation_Liquidity_Limits_Aggregate;
  /** fetch data from the table: "organisation_liquidity_limits" using primary key columns */
  organisation_liquidity_limits_by_pk?: Maybe<Organisation_Liquidity_Limits>;
  /** fetch data from the table: "organisation_reports" */
  organisation_reports: Array<Organisation_Reports>;
  /** fetch aggregated fields from the table: "organisation_reports" */
  organisation_reports_aggregate: Organisation_Reports_Aggregate;
  /** fetch data from the table: "organisation_reports" using primary key columns */
  organisation_reports_by_pk?: Maybe<Organisation_Reports>;
  /** fetch data from the table: "organisation_research" */
  organisation_research: Array<Organisation_Research>;
  /** fetch aggregated fields from the table: "organisation_research" */
  organisation_research_aggregate: Organisation_Research_Aggregate;
  /** fetch data from the table: "organisation_research" using primary key columns */
  organisation_research_by_pk?: Maybe<Organisation_Research>;
  /** fetch data from the table: "organisation_users" */
  organisation_users: Array<Organisation_Users>;
  /** fetch aggregated fields from the table: "organisation_users" */
  organisation_users_aggregate: Organisation_Users_Aggregate;
  /** fetch data from the table: "organisation_users" using primary key columns */
  organisation_users_by_pk?: Maybe<Organisation_Users>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** fetch data from the table: "product_types_enum" */
  product_types_enum: Array<Product_Types_Enum>;
  /** fetch aggregated fields from the table: "product_types_enum" */
  product_types_enum_aggregate: Product_Types_Enum_Aggregate;
  /** fetch data from the table: "product_types_enum" using primary key columns */
  product_types_enum_by_pk?: Maybe<Product_Types_Enum>;
  /** fetch data from the table: "research" */
  research: Array<Research>;
  /** fetch aggregated fields from the table: "research" */
  research_aggregate: Research_Aggregate;
  /** fetch data from the table: "research" using primary key columns */
  research_by_pk?: Maybe<Research>;
  /** fetch data from the table: "uploads" */
  uploads: Array<Uploads>;
  /** fetch aggregated fields from the table: "uploads" */
  uploads_aggregate: Uploads_Aggregate;
  /** fetch data from the table: "uploads" using primary key columns */
  uploads_by_pk?: Maybe<Uploads>;
};

/** subscription root */
export type Subscription_RootActual_BalancesArgs = {
  distinct_on?: Maybe<Array<Actual_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Actual_Balances_Order_By>>;
  where?: Maybe<Actual_Balances_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootActual_Balances_AggregateArgs = {
  distinct_on?: Maybe<Array<Actual_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Actual_Balances_Order_By>>;
  where?: Maybe<Actual_Balances_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootActual_Balances_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootApp_UsersArgs = {
  distinct_on?: Maybe<Array<App_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<App_Users_Order_By>>;
  where?: Maybe<App_Users_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootApp_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<App_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<App_Users_Order_By>>;
  where?: Maybe<App_Users_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootApp_Users_By_PkArgs = {
  id: Scalars["String"];
};

/** subscription root */
export type Subscription_RootBank_AccountsArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBank_Accounts_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Accounts_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Accounts_Order_By>>;
  where?: Maybe<Bank_Accounts_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBank_Accounts_By_PkArgs = {
  account_id: Scalars["String"];
};

/** subscription root */
export type Subscription_RootBank_FactsheetsArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBank_Factsheets_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBank_Factsheets_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootBanksArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBanks_AggregateArgs = {
  distinct_on?: Maybe<Array<Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Banks_Order_By>>;
  where?: Maybe<Banks_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBanks_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootBusiness_Unit_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBusiness_Unit_Bank_Exposure_Limits_AggregateArgs =
  {
    distinct_on?: Maybe<
      Array<Business_Unit_Bank_Exposure_Limits_Select_Column>
    >;
    limit?: Maybe<Scalars["Int"]>;
    offset?: Maybe<Scalars["Int"]>;
    order_by?: Maybe<Array<Business_Unit_Bank_Exposure_Limits_Order_By>>;
    where?: Maybe<Business_Unit_Bank_Exposure_Limits_Bool_Exp>;
  };

/** subscription root */
export type Subscription_RootBusiness_Unit_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootBusiness_Unit_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Liquidity_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBusiness_Unit_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Unit_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Unit_Liquidity_Limits_Order_By>>;
  where?: Maybe<Business_Unit_Liquidity_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBusiness_Unit_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootBusiness_UnitsArgs = {
  distinct_on?: Maybe<Array<Business_Units_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Units_Order_By>>;
  where?: Maybe<Business_Units_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBusiness_Units_AggregateArgs = {
  distinct_on?: Maybe<Array<Business_Units_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Business_Units_Order_By>>;
  where?: Maybe<Business_Units_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootBusiness_Units_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootCurrenciesArgs = {
  distinct_on?: Maybe<Array<Currencies_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currencies_Order_By>>;
  where?: Maybe<Currencies_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootCurrencies_AggregateArgs = {
  distinct_on?: Maybe<Array<Currencies_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currencies_Order_By>>;
  where?: Maybe<Currencies_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootCurrencies_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootCurrency_Book_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootCurrency_Book_Bank_Exposure_Limits_AggregateArgs =
  {
    distinct_on?: Maybe<
      Array<Currency_Book_Bank_Exposure_Limits_Select_Column>
    >;
    limit?: Maybe<Scalars["Int"]>;
    offset?: Maybe<Scalars["Int"]>;
    order_by?: Maybe<Array<Currency_Book_Bank_Exposure_Limits_Order_By>>;
    where?: Maybe<Currency_Book_Bank_Exposure_Limits_Bool_Exp>;
  };

/** subscription root */
export type Subscription_RootCurrency_Book_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootCurrency_Book_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Liquidity_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootCurrency_Book_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Book_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Book_Liquidity_Limits_Order_By>>;
  where?: Maybe<Currency_Book_Liquidity_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootCurrency_Book_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootCurrency_BooksArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootCurrency_Books_AggregateArgs = {
  distinct_on?: Maybe<Array<Currency_Books_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Currency_Books_Order_By>>;
  where?: Maybe<Currency_Books_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootCurrency_Books_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootModel_BalancesArgs = {
  distinct_on?: Maybe<Array<Model_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Model_Balances_Order_By>>;
  where?: Maybe<Model_Balances_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootModel_Balances_AggregateArgs = {
  distinct_on?: Maybe<Array<Model_Balances_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Model_Balances_Order_By>>;
  where?: Maybe<Model_Balances_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootModel_Balances_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootModelsArgs = {
  distinct_on?: Maybe<Array<Models_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Models_Order_By>>;
  where?: Maybe<Models_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootModels_AggregateArgs = {
  distinct_on?: Maybe<Array<Models_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Models_Order_By>>;
  where?: Maybe<Models_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootModels_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootOrganisation_Bank_Exposure_LimitsArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Bank_Exposure_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Bank_Exposure_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Bank_Exposure_Limits_Order_By>>;
  where?: Maybe<Organisation_Bank_Exposure_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Bank_Exposure_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootOrganisation_BanksArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Banks_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Banks_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Banks_Order_By>>;
  where?: Maybe<Organisation_Banks_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Banks_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootOrganisation_Liquidity_LimitsArgs = {
  distinct_on?: Maybe<Array<Organisation_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Liquidity_Limits_Order_By>>;
  where?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Liquidity_Limits_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Liquidity_Limits_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Liquidity_Limits_Order_By>>;
  where?: Maybe<Organisation_Liquidity_Limits_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Liquidity_Limits_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootOrganisation_ReportsArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Reports_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Reports_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootOrganisation_ResearchArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Research_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Research_Order_By>>;
  where?: Maybe<Organisation_Research_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Research_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootOrganisation_UsersArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Users_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Users_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Users_Order_By>>;
  where?: Maybe<Organisation_Users_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisation_Users_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootOrganisationsArgs = {
  distinct_on?: Maybe<Array<Organisations_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisations_Order_By>>;
  where?: Maybe<Organisations_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisations_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisations_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisations_Order_By>>;
  where?: Maybe<Organisations_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootOrganisations_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootProduct_Types_EnumArgs = {
  distinct_on?: Maybe<Array<Product_Types_Enum_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Product_Types_Enum_Order_By>>;
  where?: Maybe<Product_Types_Enum_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootProduct_Types_Enum_AggregateArgs = {
  distinct_on?: Maybe<Array<Product_Types_Enum_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Product_Types_Enum_Order_By>>;
  where?: Maybe<Product_Types_Enum_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootProduct_Types_Enum_By_PkArgs = {
  id: Scalars["String"];
};

/** subscription root */
export type Subscription_RootResearchArgs = {
  distinct_on?: Maybe<Array<Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Research_Order_By>>;
  where?: Maybe<Research_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootResearch_AggregateArgs = {
  distinct_on?: Maybe<Array<Research_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Research_Order_By>>;
  where?: Maybe<Research_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootResearch_By_PkArgs = {
  id: Scalars["Int"];
};

/** subscription root */
export type Subscription_RootUploadsArgs = {
  distinct_on?: Maybe<Array<Uploads_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Uploads_Order_By>>;
  where?: Maybe<Uploads_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootUploads_AggregateArgs = {
  distinct_on?: Maybe<Array<Uploads_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Uploads_Order_By>>;
  where?: Maybe<Uploads_Bool_Exp>;
};

/** subscription root */
export type Subscription_RootUploads_By_PkArgs = {
  id: Scalars["uuid"];
};

/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars["timestamptz"]>;
  _gt?: Maybe<Scalars["timestamptz"]>;
  _gte?: Maybe<Scalars["timestamptz"]>;
  _in?: Maybe<Array<Scalars["timestamptz"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _lt?: Maybe<Scalars["timestamptz"]>;
  _lte?: Maybe<Scalars["timestamptz"]>;
  _neq?: Maybe<Scalars["timestamptz"]>;
  _nin?: Maybe<Array<Scalars["timestamptz"]>>;
};

/** columns and relationships of "uploads" */
export type Uploads = {
  __typename?: "uploads";
  /** An array relationship */
  bank_factsheets: Array<Bank_Factsheets>;
  /** An aggregated array relationship */
  bank_factsheets_aggregate: Bank_Factsheets_Aggregate;
  created_at: Scalars["timestamptz"];
  description?: Maybe<Scalars["String"]>;
  id: Scalars["uuid"];
  /** An array relationship */
  organisation_reports: Array<Organisation_Reports>;
  /** An aggregated array relationship */
  organisation_reports_aggregate: Organisation_Reports_Aggregate;
  public_url?: Maybe<Scalars["String"]>;
  reviewed: Scalars["Boolean"];
  s3_key: Scalars["String"];
  s3_level: Scalars["String"];
};

/** columns and relationships of "uploads" */
export type UploadsBank_FactsheetsArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** columns and relationships of "uploads" */
export type UploadsBank_Factsheets_AggregateArgs = {
  distinct_on?: Maybe<Array<Bank_Factsheets_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Bank_Factsheets_Order_By>>;
  where?: Maybe<Bank_Factsheets_Bool_Exp>;
};

/** columns and relationships of "uploads" */
export type UploadsOrganisation_ReportsArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** columns and relationships of "uploads" */
export type UploadsOrganisation_Reports_AggregateArgs = {
  distinct_on?: Maybe<Array<Organisation_Reports_Select_Column>>;
  limit?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
  order_by?: Maybe<Array<Organisation_Reports_Order_By>>;
  where?: Maybe<Organisation_Reports_Bool_Exp>;
};

/** aggregated selection of "uploads" */
export type Uploads_Aggregate = {
  __typename?: "uploads_aggregate";
  aggregate?: Maybe<Uploads_Aggregate_Fields>;
  nodes: Array<Uploads>;
};

/** aggregate fields of "uploads" */
export type Uploads_Aggregate_Fields = {
  __typename?: "uploads_aggregate_fields";
  count?: Maybe<Scalars["Int"]>;
  max?: Maybe<Uploads_Max_Fields>;
  min?: Maybe<Uploads_Min_Fields>;
};

/** aggregate fields of "uploads" */
export type Uploads_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Uploads_Select_Column>>;
  distinct?: Maybe<Scalars["Boolean"]>;
};

/** order by aggregate values of table "uploads" */
export type Uploads_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Uploads_Max_Order_By>;
  min?: Maybe<Uploads_Min_Order_By>;
};

/** input type for inserting array relation for remote table "uploads" */
export type Uploads_Arr_Rel_Insert_Input = {
  data: Array<Uploads_Insert_Input>;
  on_conflict?: Maybe<Uploads_On_Conflict>;
};

/** Boolean expression to filter rows from the table "uploads". All fields are combined with a logical 'AND'. */
export type Uploads_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Uploads_Bool_Exp>>>;
  _not?: Maybe<Uploads_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Uploads_Bool_Exp>>>;
  bank_factsheets?: Maybe<Bank_Factsheets_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  organisation_reports?: Maybe<Organisation_Reports_Bool_Exp>;
  public_url?: Maybe<String_Comparison_Exp>;
  reviewed?: Maybe<Boolean_Comparison_Exp>;
  s3_key?: Maybe<String_Comparison_Exp>;
  s3_level?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uploads" */
export enum Uploads_Constraint {
  /** unique or primary key constraint */
  UploadsPkey = "Uploads_pkey",
}

/** input type for inserting data into table "uploads" */
export type Uploads_Insert_Input = {
  bank_factsheets?: Maybe<Bank_Factsheets_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars["timestamptz"]>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["uuid"]>;
  organisation_reports?: Maybe<Organisation_Reports_Arr_Rel_Insert_Input>;
  public_url?: Maybe<Scalars["String"]>;
  reviewed?: Maybe<Scalars["Boolean"]>;
  s3_key?: Maybe<Scalars["String"]>;
  s3_level?: Maybe<Scalars["String"]>;
};

/** aggregate max on columns */
export type Uploads_Max_Fields = {
  __typename?: "uploads_max_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["uuid"]>;
  public_url?: Maybe<Scalars["String"]>;
  s3_key?: Maybe<Scalars["String"]>;
  s3_level?: Maybe<Scalars["String"]>;
};

/** order by max() on columns of table "uploads" */
export type Uploads_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  public_url?: Maybe<Order_By>;
  s3_key?: Maybe<Order_By>;
  s3_level?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Uploads_Min_Fields = {
  __typename?: "uploads_min_fields";
  created_at?: Maybe<Scalars["timestamptz"]>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["uuid"]>;
  public_url?: Maybe<Scalars["String"]>;
  s3_key?: Maybe<Scalars["String"]>;
  s3_level?: Maybe<Scalars["String"]>;
};

/** order by min() on columns of table "uploads" */
export type Uploads_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  public_url?: Maybe<Order_By>;
  s3_key?: Maybe<Order_By>;
  s3_level?: Maybe<Order_By>;
};

/** response of any mutation on the table "uploads" */
export type Uploads_Mutation_Response = {
  __typename?: "uploads_mutation_response";
  /** number of affected rows by the mutation */
  affected_rows: Scalars["Int"];
  /** data of the affected rows by the mutation */
  returning: Array<Uploads>;
};

/** input type for inserting object relation for remote table "uploads" */
export type Uploads_Obj_Rel_Insert_Input = {
  data: Uploads_Insert_Input;
  on_conflict?: Maybe<Uploads_On_Conflict>;
};

/** on conflict condition type for table "uploads" */
export type Uploads_On_Conflict = {
  constraint: Uploads_Constraint;
  update_columns: Array<Uploads_Update_Column>;
  where?: Maybe<Uploads_Bool_Exp>;
};

/** ordering options when selecting data from "uploads" */
export type Uploads_Order_By = {
  bank_factsheets_aggregate?: Maybe<Bank_Factsheets_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  organisation_reports_aggregate?: Maybe<Organisation_Reports_Aggregate_Order_By>;
  public_url?: Maybe<Order_By>;
  reviewed?: Maybe<Order_By>;
  s3_key?: Maybe<Order_By>;
  s3_level?: Maybe<Order_By>;
};

/** primary key columns input for table: "uploads" */
export type Uploads_Pk_Columns_Input = {
  id: Scalars["uuid"];
};

/** select columns of table "uploads" */
export enum Uploads_Select_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  PublicUrl = "public_url",
  /** column name */
  Reviewed = "reviewed",
  /** column name */
  S3Key = "s3_key",
  /** column name */
  S3Level = "s3_level",
}

/** input type for updating data in table "uploads" */
export type Uploads_Set_Input = {
  created_at?: Maybe<Scalars["timestamptz"]>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["uuid"]>;
  public_url?: Maybe<Scalars["String"]>;
  reviewed?: Maybe<Scalars["Boolean"]>;
  s3_key?: Maybe<Scalars["String"]>;
  s3_level?: Maybe<Scalars["String"]>;
};

/** update columns of table "uploads" */
export enum Uploads_Update_Column {
  /** column name */
  CreatedAt = "created_at",
  /** column name */
  Description = "description",
  /** column name */
  Id = "id",
  /** column name */
  PublicUrl = "public_url",
  /** column name */
  Reviewed = "reviewed",
  /** column name */
  S3Key = "s3_key",
  /** column name */
  S3Level = "s3_level",
}

/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars["uuid"]>;
  _gt?: Maybe<Scalars["uuid"]>;
  _gte?: Maybe<Scalars["uuid"]>;
  _in?: Maybe<Array<Scalars["uuid"]>>;
  _is_null?: Maybe<Scalars["Boolean"]>;
  _lt?: Maybe<Scalars["uuid"]>;
  _lte?: Maybe<Scalars["uuid"]>;
  _neq?: Maybe<Scalars["uuid"]>;
  _nin?: Maybe<Array<Scalars["uuid"]>>;
};
